var sc = Object.defineProperty;
var rc = (e, t, n) => t in e ? sc(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var I = (e, t, n) => (rc(e, typeof t != "symbol" ? t + "" : t, n), n);
import { jsx as l, jsxs as w, Fragment as be } from "react/jsx-runtime";
import * as P from "react";
import F, { createContext as Mt, useState as j, useRef as U, useEffect as B, useMemo as H, useLayoutEffect as Or, useCallback as le, memo as oc, useReducer as ic, useContext as lt, cloneElement as ac, forwardRef as lc, useId as $i, createRef as To } from "react";
import * as cc from "react-dom";
import { unstable_batchedUpdates as _n, createPortal as uc } from "react-dom";
var dc = Object.defineProperty, hc = (e, t, n) => t in e ? dc(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Qs = (e, t, n) => hc(e, typeof t != "symbol" ? t + "" : t, n);
function fc(e = {}, t = {}, n = {}) {
  return Object.entries(t).reduce(
    (s, [r, o]) => {
      const i = n[o];
      return i !== null && typeof i < "u" && (s[r] = i), s;
    },
    { ...e }
  );
}
function gc(e, t = []) {
  return (typeof t == "string" ? t.split(/,\s*|\s+/) : t).reduce(
    (n, s) => {
      const r = e[s] || vc(`Cannot expose non-existent action method: ${s}`);
      return n[s] = r.bind(e), n;
    },
    {}
  );
}
function pc(e, t) {
  const n = e.debug ?? t.debug, s = ko(e.debugPrefix ?? t.debugPrefix, e), r = ko(e.debugColor ?? t.debugColor, e);
  return n ? s ? (o, ...i) => console.log(
    `%c${s}%c${o}`,
    `color: ${r}`,
    "color:black",
    ...i
  ) : console.log.bind(console) : () => {
  };
}
function mc(e) {
  return Array.isArray(e);
}
function Oi(e) {
  return typeof e == "function";
}
function ko(e, t) {
  return Oi(e) ? e(t) : e;
}
function bc(e) {
  return mc(e) ? e : [e];
}
function vc(...e) {
  throw new Error(e.join(""));
}
const Xe = (e, t = {}, n = F.createContext(t)) => ({ Context: n, Provider: (s) => /* @__PURE__ */ l(
  e,
  {
    ...s,
    render: (r) => /* @__PURE__ */ l(n.Provider, { value: r, children: s.children })
  }
), Consumer: (s) => (r) => /* @__PURE__ */ l(n.Consumer, { children: (o) => /* @__PURE__ */ l(s, { ...o, ...r }) }), Children: ({ children: s }) => bc(s).map(
  (r, o) => Oi(r) ? /* @__PURE__ */ l(n.Consumer, { children: r }, o) : r
), Use: () => F.useContext(n) });
let Rt = class extends F.Component {
  constructor(t) {
    super(t);
    const n = this.constructor;
    this.debug = pc(t, n), this.state = fc(
      n.initialState,
      n.initialProps,
      t
    ), this.actions = gc(this, n.actions);
  }
  getContext() {
    return {
      ...this.props,
      // properties passed to the context
      ...this.state,
      // internal state
      ...this.actions
      // callable action functions mapped to methods
    };
  }
  getRenderProps() {
    return this.getContext();
  }
  render() {
    return this.props.render(
      this.getRenderProps()
    );
  }
};
Qs(Rt, "initialState", {}), Qs(Rt, "initialProps", {}), Qs(Rt, "actions", []);
const Cc = ({
  render: e,
  open: t
}) => {
  const [n, s] = F.useState(t), r = () => s((a) => !a), o = () => s(!0), i = () => s(!1);
  return F.useEffect(
    () => {
      s(t);
    },
    [t]
  ), e({
    isOpen: n,
    open: o,
    close: i,
    toggleOpen: r
  });
}, Tr = Xe(Cc), fC = Tr.Use, yc = "svg", gr = "-", Ti = "fill", xc = "path", wc = "line", Sc = "rect", Rc = "array", Lc = "circle", Nc = "ellipse", Mc = "polygon", Dc = "polyline", kr = /-(?!\d)/, Io = "currentColor", Ir = 512, Er = 512, Pr = {
  defaults: {
    width: 512,
    height: 512,
    type: "line"
  },
  icons: {
    alpha: "M102,448L256,64L410,448 M152,333L360,333",
    angle: "M448,336L256,144L64,336",
    angles: "M448,448L256,256L64,448M448,256L256,64L64,256",
    arrow: "M96,224L256,64L416,224M256,86L256,448",
    arrows: "M160,128L256,32L352,128M352,384L256,480L160,384M256,48L256,464",
    arrowhead: "M176,112L256,32L336,112M256,48L256,192",
    asterisk: "M76,152L436,360M76,360L436,152M256,48L256,464",
    at: "M256,160C309,160 352,203 352,256C352,309 309,352 256,352C203,352 160,309 160,256C160,203 203,160 256,160M256,480C132,480 32,380 32,256C32,132 132,32 256,32C380,32 480,132 480,256L480,288C480,323 451,352 416,352C381,352 352,323 352,288L352,176",
    ban: "M100,412L412,100 M256,32C380,32 480,132 480,255C480,379 380,480 256,480C132,480 32,379 32,255C32,132 132,32 256,32Z",
    bars: "M64,96L448,96M64,256L448,256M64,416L448,416",
    card: "rect:32 96 448 320 32 32",
    caret: "M448,336L256,144L64,336L448,336Z",
    check: "M48,248L192,392L464,120",
    circle: "circle:256 256 224",
    clipboard: "M192,80L80,80L80,496L432,496L432,80L320,80L320,112L192,112L192,80ZM256,16C282,16 304,38 304,64C304,90 282,112 256,112C230,112 208,90 208,64C208,38 230,16 256,16Z",
    clone: "M304,416L304,444C304,468 284,488 260,488L68,488C44,488 24,468 24,444L24,252C24,228 44,208 68,208L96,208M480,75L480,277C480,301 461,320 437,320L235,320C211,320 192,301 192,277L192,75C192,51 211,32 235,32L437,32C461,32 480,51 480,75Z",
    cloud: "M480,293C480,234 437,177 362,196C346,161 319,116 240,120C180,124 139,165 125,224C121,223 116,223 111,223C68,223 32,260 32,307C32,354 68,392 111,392C120,392 366,392 380,392C462,392 480,335 480,293Z",
    cog: "M306,21L206,21L187,91L147,114L78,95L28,182L78,233L78,279L28,330L78,417L147,398L187,421L206,491L306,491L325,421L365,398L434,417L484,330L434,279L434,233L484,182L434,95L365,114L325,91L306,21Z M256,176C300,176 336,212 336,256C336,300 300,336 256,336C212,336 176,300 176,256C176,212 212,176 256,176Z",
    columns: [
      "rect:32 32 448 448 45 45",
      "line:180,32 180,480",
      "line:332,32 332,480"
    ],
    comment: "M256,64C371,64 464,139 464,232C464,325 371,400 256,400C236,400 217,398 199,394C184,390 163,448 80,464C111,426 118,358 110,352C72,321 48,279 48,232C48,139 141,64 256,64Z",
    crop: "M32,80L288,80 M80,32L80,288M432,480L432,224M480,432L224,432M80,428L432,80",
    cross: "M112,112L400,400M400,112L112,400",
    crosshairs: [
      "circle:256 256 192",
      "M256,16L256,112 M496,256L400,256 M16,256L112,256 M256,496L256,400"
    ],
    diamond: "M256,32L480,256L256,480L32,256L256,32",
    download: "M256,64L256,320L352,224M256,320L160,224M384,320L425,320C438,320 448,330 448,342L448,426C448,438 438,448 425,448L86,448C74,448 64,438 64,426L64,342C64,330 74,320 86,320L128,320",
    drag: "M96,128L256,32L416,128M96,384L256,480L416,384M144,256L368,256",
    envelope: [
      "rect:32 96 448 320 32 32",
      "M32,144C32,144 158.906,243.712 221.676,293.031C241.821,308.86 270.179,308.86 290.324,293.031C353.094,243.712 480,144 480,144"
    ],
    equals: "M96,320L416,320 M96,192L416,192",
    exclamation: "M256,96L256,310M254,416L258,416",
    eye: [
      "M21,256C131,42 381,43 493,256 M21,256C130,470 383,469 493,256",
      "circle:256 256 80"
    ],
    eyeshut: "M21,256C131,42 381,43 493,256M21,256C130,320 383,320 493,256M21,256C130,470 383,469 493,256",
    filter: "M64,32L448,32L448,128L320,256L320,432L192,480L192,256L64,128L64,32Z",
    folder: "M480,128L480,448L32,448L32,64L176,64L240,128L480,128Z",
    globe: [
      "circle:256 256 224",
      "ellipse:256 256 116 224",
      "M32,255.997L480,256.115M53.867,160L458.413,160M53.867,352.587L458.413,352M256.14,32L256.14,480"
    ],
    heart: "M256,128C298,48 382,48 424,88C466,128 466,208 424,288C394,348 319,408 256,448C193,408 118,348 88,288C46,208 46,128 88,88C130,48 214,48 256,128Z",
    hourglass: "M80,32L432,32M80,480L432,480M128,32C128,256 384,256 384,480M384,32C384,256 128,256 128,480",
    image: [
      "rect:32 80 448 366 32",
      "M32,304L128,240L384,432M272,345L367,281L480,366",
      "circle:288 192 16"
    ],
    info: "M212,202L256,202L256,416M182,416L330,416M252,96L256,96",
    key: [
      "M189,246C183,229 180,212 180,194C180,118 242,56 318,56C394,56 456,118 456,194C456,270 394,332 318,332C300,332 283,329 266,323L232,360L184,360L184,408L136,408L136,456L56,456L56,379L189,246Z",
      "circle:344 168 8"
    ],
    list: "M176,96L448,96M176,256L448,256M176,416L448,416M64,96L80,96M64,256L80,256M64,416L80,416",
    locked: [
      "M144,224L144,166C144,105 195,54 256,54C317,54 368,105 368,166L368,224M256,320L256,368",
      "rect:80 224 352 240 32 32"
    ],
    login: "M192,128L320,256L192,384M304,256L64,256M320,64L448,64L448,448L320,448",
    logout: "M320,128L448,256L320,384M432,256L192,256M192,448L64,448L64,64L192,64",
    minus: "M96,256L416,256",
    mobile: [
      "rect:128 48 256 416 32 32",
      "M128,120L384,120M128,392L384,392"
    ],
    move: "M192,96L256,32L320,96M416,192L480,256L416,320M320,416L256,480L192,416M96,192L32,256L96,320M48,256L464,256M256,48L256,464",
    number: "M256,448L256,64L176,128 M160,448L336,449",
    page: "M416,170L416,480L96,480L96,32L288,32L416,170M288,32L288,176L416,176",
    pen: "M482,143C491,134 491,120 482,112L401,30C392,21 378,21 369,30L72,326L22,489L186,439L482,143M305,93L418,206",
    phone: "M51,59C40,62 32,72 32,84C41,321 192,472 428,480C440,480 451,471 453,459C459,435 469,395 475,371C478,360 472,348 462,343C438,331 395,309 370,297C360,292 347,295 339,304C325,323 303,352 304,352C255,352 160,257 160,208C160,207 188,186 207,172C217,165 220,152 215,141C202,117 181,74 169,50C164,39 152,34 141,37C116,43 75,53 51,59Z",
    plus: "M256,96L256,416M96,256L416,256",
    point: "M448,224L256,16L64,224L160,224L160,480L352,480L352,224L448,224Z",
    prime: "M256,128L256,256",
    question: "M160,160C160,126 197,80 255,80C314,80 336,128 336,160C336,236 255,235 255,320 M255,416L256,416",
    rotate: "M392,120C356,84 307,64 256,64C150,64 64,150 64,256C64,362 150,448 256,448C303,448 349,430 384,399C349,430 303,448 256,448C150,448 64,362 64,256C64,150 150,64 256,64C307,64 356,84 392,120Z M352,208L480,208L480,80",
    search: "M204,32C300,32 384,111 384,208C384,305 305,384 208,384C111,384 32,305 32,208C32,111 107,32 204,32M480,480L332,332",
    slash: "M64,448L448,64",
    square: "rect:32 32 448 448",
    square10: "rect:32 32 448 448 45 45",
    square20: "rect:32 32 448 448 90 90",
    square30: "rect:32 32 448 448 135 135",
    square40: "rect:32 32 448 448 180 180",
    star: "M256,32L324,183L489,202L367,313L400,476L256,394L112,476L145,313L23,202L188,183L256,32Z",
    thumb: "M149,174L32,174L32,448L149,448L149,184 M149,217C277,160 246,36 282,38C372,44 324,192 324,192L440,192C462,192 480,210 480,232C480,254 462,272 440,272L368,272M424,272C446,272 464,290 464,312C464,334 446,352 424,352L352,352M392,352C414,352 432,370 432,392C432,414 414,432 392,432L256,432C220,432 149,409 149,409",
    time: "M256,128L256,256L336,336",
    trash: "M32,80L480,80 M80,80C80,80 100,344 109,452C111,477 131,496 156,496C211,496 301,496 356,496C381,496 401,477 403,452C412,344 432,80 432,80 M160,80L208,16L304,16L352,74",
    triangle: "M256,64L32,448L480,448L256,64Z",
    unlocked: [
      "M144,224L144,166C144,105 195,54 256,54C304,54 346,85 361,128M256,320L256,368",
      "rect:80 224 352 240 32 32"
    ],
    upload: "M256,320L256,64L160,160M256,64L352,160M384,320L425,320C438,320 448,330 448,342L448,426C448,438 438,448 425,448L86,448C74,448 64,438 64,426L64,342C64,330 74,320 86,320L128,320",
    user: [
      "M448,400C448,349 410,308 364,308L149,308C102,308 64,349 64,400C64,424 64,480 64,480L448,480C448,480 448,423 448,400Z",
      "circle:256,144,96"
    ],
    vertical: "line:256,48 256,464",
    wrench: "M486,108C493,124 496,142 496,160C496,239 431,304 352,304C330,304 309,299 290,290L98,482C79,501 49,501 30,482C11,463 11,433 30,414L222,222C213,203 208,182 208,160C208,81 273,16 352,16C370,16 388,19 404,26L336,96L352,160L416,176L486,108Z"
  }
};
function $c(e, t, n = Pr) {
  n.icons[e] = t;
}
function gC(e, t = Pr) {
  Object.entries(e).forEach(
    ([n, s]) => $c(n, s, t)
  );
}
const Yn = Mt();
function Eo(e) {
  return typeof e == "function";
}
function Po(e) {
  return typeof e == "object" && !ki(e) && !Oc(e);
}
function ki(e) {
  return Array.isArray(e);
}
function Oc(e) {
  return e === null;
}
function Tc({
  context: e = {},
  Implementation: t,
  spec: n = !1,
  props: s = {},
  ref: r
}) {
  if (!n)
    return /* @__PURE__ */ l(t, { ...s, ref: r });
  let o = {}, i = Eo(n) ? n(e) : e[n];
  if (ki(i) && (t = i[0], i = i[1]), Eo(i)) {
    const a = i(s, r, e);
    if (F.isValidElement(a))
      return a;
    Po(a) && Object.assign(o, s, a);
  } else
    Po(i) ? Object.assign(o, i, s) : Object.assign(o, s);
  return /* @__PURE__ */ l(t, { ...o, ref: r });
}
const kc = (e) => ({ Context: Yn, Provider: ({ children: t, ...n }) => /* @__PURE__ */ l(Yn.Provider, { value: { ...e, ...n }, children: t }), Consumer: (t) => (n) => /* @__PURE__ */ l(Yn.Consumer, { children: (s) => /* @__PURE__ */ l(t, { ...s, ...n, context: s }) }), Component: (t, n = t.displayName || t.name) => F.forwardRef(
  (s, r) => /* @__PURE__ */ l(Yn.Consumer, { children: (o) => /* @__PURE__ */ l(
    Tc,
    {
      Implementation: t,
      context: o,
      spec: n,
      props: s,
      ref: r
    }
  ) })
) }), Ic = kc(), Ec = Ic.Component;
function _e(e) {
  return typeof e == "string";
}
function $n(e) {
  return Array.isArray(e);
}
function Ss(e) {
  return typeof e == "object" && !$n(e) && !Ei(e);
}
function Ii(e) {
  return e === void 0;
}
function Ei(e) {
  return e === null;
}
function Rs(e) {
  return !(Ii(e) || Ei(e));
}
function Pi(e) {
  return !Rs(e);
}
function Ae(...e) {
  throw new Error(e.join(""));
}
function Pc() {
  return Intl.DateTimeFormat().resolvedOptions().locale;
}
Pc();
function pr(e, t = /,\s*|\s+/) {
  return Pi(e) ? [] : _e(e) ? e.length ? e.split(t) : [] : $n(e) ? e : [e];
}
const Ac = (e, t) => {
  const n = e[t];
  return delete e[t], n;
};
function On(e) {
  return e.split(/\s*[;&]\s*/).filter((t) => t.length > 0).reduce(
    (t, n) => {
      const [s, r] = n.split(/\s*[:=]\s*/);
      return t[s] = Ii(r) ? !0 : r, t;
    },
    {}
  );
}
const Ar = (e) => e.filter(Rs).join(" "), Fc = (e) => Object.entries(e).filter(([, t]) => t).map(([t]) => t), Vc = (...e) => Ar(
  e.flatMap(
    (t) => Ss(t) ? Fc(t) : t
  )
), Ai = (e) => pr(e, /\s+/), Fi = {
  x: 0,
  y: 0,
  size: 16,
  scaleX: 1,
  scaleY: 1,
  flipX: !1,
  flipY: !1,
  rotate: 0
}, ct = {
  flip: (e, t) => {
    _e(t) && t.match(/^y$/i) ? e.flipY = !e.flipY : e.flipX = !e.flipX;
  },
  flipx: (e) => e.flipX = !e.flipX,
  flipy: (e) => e.flipY = !e.flipY,
  grow: (e, t) => e.size += parseFloat(t),
  shrink: (e, t) => e.size -= parseFloat(t),
  scalex: (e, t) => e.scaleX *= parseFloat(t),
  scaley: (e, t) => e.scaleY *= parseFloat(t),
  left: (e, t) => t === !0 ? e.rotate -= 90 : e.x -= parseFloat(t),
  right: (e, t) => t === !0 ? e.rotate += 90 : e.x += parseFloat(t),
  up: (e, t) => t === !0 ? e.rotate += 0 : e.y -= parseFloat(t),
  down: (e, t) => t === !0 ? e.rotate += 180 : e.y += parseFloat(t),
  rotate: (e, t) => e.rotate += parseInt(t)
};
ct.flop = ct.flipy;
ct["flip-x"] = ct.flipx;
ct["flip-y"] = ct.flipy;
function Vi(e, t = { ...Fi }) {
  const n = _e(e) ? On(e) : e || {};
  return Object.entries(n).reduce(
    (s, [r, o]) => {
      const i = r.toLowerCase();
      return (ct[i] || Ae(`Invalid transform: ${i}`))(s, o), s;
    },
    t
  );
}
const Bc = 4.42, Ue = (e) => `${Bc * e}%`, jc = {
  // fill:               'currentColor',
  // stroke:             'currentColor',
  /*
  strokeWidth:        widthMultiple(2),
  strokeLinecap:      'round',
  strokeLinejoin:     'round',
  strokeMiterlimit:   '1.5'
  */
}, mr = {
  outline: {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: Ue(2),
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "1.5"
  },
  solid: {
    fill: "currentColor",
    stroke: "none"
  },
  round: {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "1.5"
  },
  square: {
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeMiterlimit: "1.5"
  },
  butt: {
    strokeLinecap: "butt"
  },
  bevel: {
    strokeLinejoin: "bevel"
  },
  thinnest: {
    strokeWidth: Ue(0.5)
  },
  thinner: {
    strokeWidth: Ue(1)
  },
  thin: {
    strokeWidth: Ue(1.5)
  },
  medium: {
    strokeWidth: Ue(2)
  },
  thick: {
    strokeWidth: Ue(2.5)
  },
  thicker: {
    strokeWidth: Ue(3)
  },
  thickest: {
    strokeWidth: Ue(3.5)
  }
};
mr.line = mr.outline;
const Wc = {
  ...Object.entries(mr).reduce(
    (e, [t, n]) => (e[t] = (s) => Object.assign(s, n), e),
    {}
  ),
  fill: (e, t) => e.fill = t === !0 ? Io : t,
  stroke: (e, t) => e.stroke = t === !0 ? Io : t,
  nofill: (e) => delete e.fill,
  nostroke: (e) => delete e.stroke,
  strokewidth: (e, t) => e.strokeWidth = t.match(/^[\d.]+$/) ? Ue(parseFloat(t)) : t,
  opacity: (e, t) => e.opacity = t,
  fillopacity: (e, t) => e.fillOpacity = t,
  strokeopacity: (e, t) => e.strokeOpacity = t,
  dasharray: (e, t) => e.strokeDasharray = t,
  drawlength: (e, t) => e["--draw-length"] = t,
  drawtime: (e, t) => e["--draw-time"] = t,
  filltime: (e, t) => e["--fill-time"] = t
};
function cs(e, t) {
  return (_e(t) ? t.split(kr) : t).forEach(
    (n) => {
      const [s, r = !0] = n.split(/[:=]/), o = s.toLowerCase(), i = Wc[o];
      if (i) {
        i(e.style || (e.style = { ...jc }), r);
        return;
      }
      (ct[o] || Ae(`Invalid style or transform: ${o}`))(e.transform || (e.transform = { ...Fi }), r);
    }
  );
}
const Hc = {
  width: Ir,
  height: Er,
  type: Ti
}, Bi = {
  svg: (e) => ({
    element: yc,
    svg: e
  }),
  array: (e) => ({
    element: Rc,
    items: e
  }),
  path: (e) => ({
    element: xc,
    d: e
  }),
  polygon: (e) => ({
    element: Mc,
    points: e
  }),
  polyline: (e) => ({
    element: Dc,
    points: e
  }),
  circle: (e) => ({
    element: Lc,
    ...Gn(e, "cx cy r")
  }),
  ellipse: (e) => ({
    element: Nc,
    ...Gn(e, "cx cy rx ry")
  }),
  line: (e) => ({
    element: wc,
    ...Gn(e, "x1 y1 x2 y2")
  }),
  rect: (e) => ({
    element: Sc,
    ...Gn(e, "x y width height rx ry")
  })
};
function Gn(e, t) {
  const n = $n(t) ? [...t] : pr(t);
  return pr(e).reduce(
    (s, r) => {
      if (n.length) {
        const o = n.shift();
        s[o] = r;
      }
      return s;
    },
    {}
  );
}
const ji = (e) => {
  const [t, n = ""] = e.split("?"), [s, ...r] = t.split(/\.(?!\d)/), o = s.split(kr).filter((a) => a.length), i = On(n);
  return {
    dashes: o,
    classes: r,
    style: i
  };
}, zc = (e, t) => {
  const n = ji(e), { dashes: s } = n;
  for (let r = s.length; r > 0; r--) {
    const o = s.slice(0, r).join(gr);
    if (t[o]) {
      n.name = s.splice(0, r).join(gr);
      break;
    }
  }
  return n;
}, Ao = (e, t, n = {}) => {
  const { icons: s } = t, r = zc(e, s), { name: o, classes: i, style: a, dashes: c } = r;
  Pi(o) && Ae(`No icon found matching any leading subset of ${r.dashes.join(gr)}`);
  const u = t.icons[o] || Ae(`Icon not found in data: ${o}`), d = Wi(u, t, { ...n, name: o });
  if ((i.length || n.className) && (d.className = Ar([...i || [], n.className])), d.transform && (d.transform = Vi(d.transform)), d.style && (d.style = _e(d.style) ? On(d.style) : { ...d.style }), d.type) {
    const h = d.style && { ...d.style };
    cs(d, d.type), delete d.type, h && Object.assign(d.style, h);
  }
  return c.length && cs(d, c), Object.keys(a).length && (d.style = Object.assign(d.style || {}, a)), d;
};
function Uc(e) {
  const t = e.match(/^(.*?):(.*)/);
  return t ? { path: t[2], type: t[1] } : { path: e };
}
const Wi = (e, t, n = {}) => {
  const { defaults: s = {} } = t, r = {
    ...Hc,
    ...s,
    ...n
  };
  return Hi(r, e, t);
}, Hi = (e, t, n) => {
  if (_e(t))
    return Kc(e, t);
  if (Ss(t))
    return qc(e, t, n);
  if ($n(t))
    return Xc(e, t, n);
  Ae(`Cannot parse icon data: ${t}`);
};
function Kc(e, t) {
  if (t.match(/^\w*</))
    return e.body = {
      element: "svg",
      svg: t
    }, e;
  const n = t.match(/^(.*?):(.*)/);
  if (n) {
    const [, s, r] = n, { dashes: o, classes: i } = ji(s), a = o.shift(), c = Bi[a] || Ae(`Invalid icon data element: ${a}`);
    return e.body = c(r), i.length && (e.body.className = Ar(i)), o.length && cs(e.body, o), e;
  }
  return e.body = {
    element: "path",
    d: t
  }, e;
}
function qc(e, t, n) {
  const s = { ...t };
  if (s.element)
    return e.body = s, e;
  if (s.data) {
    const r = Ac(s, "data");
    return Hi(e, r, n), Object.assign(e, s), e;
  }
  for (let r of Object.entries(Bi)) {
    const [o, i] = r, a = s[o];
    if (Rs(a))
      return e.body = i(a), delete s[o], Object.assign(e, s), e;
  }
  Ae(`Cannot parse icon data: ${JSON.stringify(t)}`);
}
function Xc(e, t, n) {
  return e.body = {
    element: "array",
    items: t.map(
      (s) => Wi(s, n).body
    )
  }, e;
}
const _c = ({ size: e, ...t }) => {
  t.width ?? (t.width = e || Ir), t.height ?? (t.height = e || Er), t.path && Object.assign(t, Uc(t.path));
  let n;
  return t.style && (_e(t.style) ? (n = On(t.style), t.style = {}) : n = { ...t.style }), cs(
    t,
    t.type ? t.type.split(kr).filter((s) => s.length) : Ti
  ), delete t.type, t.style && n && Object.assign(t.style, n), t.transform && (t.transform = Vi(t.transform)), t;
}, Fr = (e) => Ss(e) ? Object.entries(e).reduce(
  (t, [n, s]) => (t[n.replace(/(?!-)-./g, (r) => r[1].toUpperCase())] = s, t),
  {}
) : e, Yc = (e) => Rs(e) ? Fr(On(e)) : null, Ye = ({
  style: e,
  class: t,
  ...n
}) => ({
  style: _e(e) ? Yc(e) : Fr(e),
  className: t,
  ...n
}), Gc = (e) => /* @__PURE__ */ l("circle", { ...Ye(e) }), Zc = (e) => /* @__PURE__ */ l("ellipse", { ...Ye(e) }), Jc = (e) => /* @__PURE__ */ l("line", { ...Ye(e) }), zi = (e) => /* @__PURE__ */ l("path", { ...Ye(e) }), Qc = (e) => /* @__PURE__ */ l("polygon", { ...Ye(e) }), eu = (e) => /* @__PURE__ */ l("polyline", { ...Ye(e) }), tu = (e) => /* @__PURE__ */ l("rect", { ...Ye(e) }), nu = ({
  svg: e,
  ...t
}) => /* @__PURE__ */ l("g", { dangerouslySetInnerHTML: { __html: e }, ...Ye(t) }), su = ({
  items: e,
  ...t
}) => /* @__PURE__ */ l("g", { ...Ye(t), children: e.map(
  (n, s) => /* @__PURE__ */ l(us, { body: n }, s)
) }), ru = {
  array: su,
  circle: Gc,
  ellipse: Zc,
  line: Jc,
  path: zi,
  polygon: Qc,
  polyline: eu,
  rect: tu,
  svg: nu
}, us = ({
  path: e,
  body: t,
  ...n
}) => {
  if (e)
    return /* @__PURE__ */ l(zi, { d: e, ...n });
  if (_e(t))
    return /* @__PURE__ */ l("g", { dangerouslySetInnerHTML: { __html: t } });
  if (Ss(t)) {
    const { element: s, ...r } = t, o = ru[s] || Ae(`Invalid element type: ${s} => `, JSON.stringify(t));
    return /* @__PURE__ */ l(o, { ...r });
  }
  if ($n(t))
    return t.map(
      (s, r) => /* @__PURE__ */ l(us, { body: s }, r)
    );
  Ae(`Don't know how to handle body: ${t}`);
};
function ou({
  width: e,
  height: t,
  transform: n,
  children: s
}) {
  const r = e / 2, o = t / 2, i = n.x * e / 16, a = n.y * t / 16, c = n.size / 16 * (n.flipX ? -1 : 1) * n.scaleX, u = n.size / 16 * (n.flipY ? -1 : 1) * n.scaleY, d = n.rotate;
  return /* @__PURE__ */ l("g", { transform: `translate(${r} ${o})`, children: /* @__PURE__ */ l("g", { transform: `translate(${i}, ${a}) scale(${c}, ${u}) rotate(${d} 0 0)`, children: /* @__PURE__ */ l("g", { transform: `translate(-${r} -${o})`, children: s }) }) });
}
const er = ({
  onClick: e,
  minx: t = 0,
  miny: n = 0,
  width: s = Ir,
  height: r = Er,
  style: o,
  transform: i,
  className: a = "",
  debug: c,
  ...u
  // fill='currentColor'
}) => /* @__PURE__ */ w(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-hidden": "true",
    focusable: "false",
    viewBox: `${t} ${n} ${s} ${r}`,
    className: `${a} icon`,
    style: Fr(o),
    onClick: e,
    children: [
      !!c && console.log("style: ", o),
      i ? /* @__PURE__ */ l(
        ou,
        {
          width: s,
          height: r,
          transform: i,
          children: /* @__PURE__ */ l(us, { ...u })
        }
      ) : /* @__PURE__ */ l(us, { ...u })
    ]
  }
), iu = ({
  name: e,
  iconsClass: t = "icons",
  library: n = Pr,
  ...s
}) => {
  if (!e)
    return /* @__PURE__ */ l(er, { ..._c(s) });
  try {
    const r = Ai(e);
    return r.length === 1 ? /* @__PURE__ */ l(
      er,
      {
        ...s,
        ...Ao(e, n, s)
      }
    ) : /* @__PURE__ */ l("div", { className: Vc(t, s.className), children: r.map(
      (o) => /* @__PURE__ */ l(
        er,
        {
          ...s,
          ...Ao(o, n, s)
        },
        o
      )
    ) });
  } catch (r) {
    Ae(`Badger Icon failed to render icon "${e}". ${r.message}`);
  }
}, Ui = Ec(iu, "Icon"), au = ({
  names: e,
  className: t
}) => /* @__PURE__ */ l("div", { className: `grid overlap ${t}`, children: Ai(e).map(
  (n) => /* @__PURE__ */ l(Ui, { name: n }, n)
) });
function Dt(e) {
  return typeof e == "boolean";
}
function Ge(e) {
  return typeof e == "string";
}
function Tn(e) {
  return typeof e == "number";
}
function Ls(e) {
  return Number.isInteger(e);
}
function Fe(e) {
  return Array.isArray(e);
}
function $t(e) {
  return typeof e == "function";
}
function lu(e) {
  return e instanceof RegExp;
}
function ve(e) {
  return typeof e == "object" && !Fe(e) && !Vr(e);
}
function Ki(e) {
  return Ge(e) || Tn(e) || Dt(e);
}
function qi(e) {
  return e === void 0;
}
function Vr(e) {
  return e === null;
}
function T(e) {
  return !(qi(e) || Vr(e));
}
function Ns(e) {
  return !T(e);
}
function Ms(...e) {
  throw new Error(e.join(""));
}
const re = (e, ...t) => $t(e) ? e(...t) : e;
function E() {
}
const Ot = (e) => e, Fo = (e) => {
  const t = e.toString().split(".");
  return t.length < 2 ? 1 : Math.pow(10, t[1].length);
}, Ds = (...e) => e.reduce((t, n) => {
  const s = Fo(t), r = Fo(n);
  return s > r ? s : r;
}, -1 / 0), at = (...e) => e.reduce((t, n) => {
  const s = Ds(t, n);
  return t * s * (n * s) / (s * s);
}, 1), rs = (...e) => e.reduce((t, n) => {
  const s = Ds(t, n);
  return t * s / (n * s);
}), Xi = (...e) => {
  const t = Ds.apply(null, e);
  return e.reduce((n, s) => n + t * s, 0) / t;
}, cu = (...e) => {
  const t = Ds.apply(null, e), [n, ...s] = e;
  return s.reduce((r, o) => r - t * o, n * t) / t;
}, G = (e, t, n) => Math.min(Math.max(e, t), n);
function uu() {
  return Intl.DateTimeFormat().resolvedOptions().locale;
}
let Br = { locale: uu(), currency: "GBP", currencySign: "£", thousands: "," };
const _i = (e, t, n = 1) => {
  const s = t < e ? -Math.abs(n) : n;
  return Array(1 + Math.floor(Math.abs((t - e) / n))).fill(e).map((r, o) => r + o * s);
};
function qt(e, t = {}) {
  return new Intl.NumberFormat(t.locale || Br.locale, t).format(e);
}
function du(e, t = {}) {
  return qt(e, { style: "currency", currency: Br.currency, ...t });
}
function hu(e, t = Br.thousands) {
  if (Ns(e))
    return "";
  for (var n = e.toString().split("."), s = /(\d+)(\d{3})/; s.test(n[0]); )
    n[0] = n[0].replace(s, `$1${t}$2`);
  return n.join(".");
}
function sn(e, t = /,\s*|\s+/) {
  return Ns(e) ? [] : Ge(e) ? e.length ? e.split(t) : [] : Fe(e) ? e : [e];
}
function Nt(e, t = !0, n = {}) {
  return ve(e) ? e : sn(e).reduce((s, r) => (s[r] = $t(t) ? t(r) : t, s), n);
}
function jr(e) {
  return e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
}
function fu(e, t = {}) {
  const n = t[e];
  if (T(n))
    return n;
  let s;
  return e.match(/(ss?|sh|ch|x)$/) ? e + "es" : (s = e.match(/(.*?[^aeiou])y$/)) ? s[1] + "ies" : e.match(/([^s\d\W])$/) ? e + "s" : e;
}
function gu(e, t, n, s = "no") {
  return (e ? hu(e) : s) + " " + (e === 1 ? t : n || fu(t));
}
const pu = jr;
function mu(e) {
  if ($t(e))
    return e;
  if (lu(e))
    return (t) => e.test(t);
  if (ve(e))
    return (t) => !!e[t];
  if (Fe(e) || Ge(e)) {
    const t = Nt(e);
    return (n) => !!t[n];
  }
  Ms("Invalid selector() specification: " + e);
}
const kn = (e, t, n = {}) => {
  let s = {}, r = { delete: !1, ...n };
  const o = mu(t);
  return Object.keys(e).map((i) => {
    if (o(i)) {
      let a = e[i];
      r.delete && delete e[i], r.key && (i = r.key(i)), r.value && (a = r.value(a)), s[i] = a;
    }
  }), s;
}, Wr = (e, t) => $t(t) ? t(e) : e[t], Vo = (e, t) => parseInt(Wr(e, t) || 0), Bo = (e, t) => parseFloat(Wr(e, t) || 0), jo = (e, t) => (Wr(e, t) || "").toString(), Wo = (e) => (t, n) => Vo(t, e) - Vo(n, e), tr = (e) => (t, n) => Bo(t, e) - Bo(n, e), nr = (e) => (t, n) => {
  let s = jo(t, e).toLowerCase(), r = jo(n, e).toLowerCase();
  return s > r ? 1 : r > s ? -1 : 0;
}, bu = (e) => (t, n) => e(n, t);
function vu(e, t = 300) {
  let n;
  return (...s) => {
    clearTimeout(n), n = setTimeout(() => e.apply(this, s), t);
  };
}
function Hr(e) {
  return new Promise((t) => setTimeout(t, e));
}
const Cu = (e) => e.filter(T).join(" "), yu = (e) => Object.entries(e).filter(([, t]) => t).map(([t]) => t), M = (...e) => Cu(
  e.flatMap(
    (t) => ve(t) ? yu(t) : t
  )
), zr = (e) => {
  if (!e)
    return null;
  const [t, n, s, r, o] = e.split("-");
  return M(
    t,
    Nu(n),
    Mu(s),
    Du(r),
    $u(o)
  );
}, Yi = ({
  className: e,
  size: t,
  color: n,
  ...s
}) => ({
  ...s,
  className: M(
    e,
    t,
    zr(n)
  )
}), xu = ({
  className: e,
  size: t,
  color: n,
  border: s,
  radius: r,
  shadow: o,
  grid: i,
  stack: a,
  gap: c,
  pad: u,
  mar: d,
  padding: h = u,
  margin: g = d,
  ...f
}, ...m) => ({
  ...f,
  className: M(
    ...m,
    e,
    t,
    zr(n),
    ft(s),
    pt(r),
    gt(o),
    wu(i),
    Kr(c),
    Su(a),
    Ru(h),
    Lu(g)
  )
}), Ur = (...e) => {
  const { className: t, ...n } = xu(...e);
  return M(t, n);
}, ft = (e) => Xr(e, "border", (t) => `border bdw-${t}`), gt = (e) => Xr(e, "shadow-1", (t) => `shadow-${t}`), wu = (e) => qr(e, "grid-1", (t) => `grid-${t}`), Su = (e) => e ? `stack-${e}` : null, Ru = (e) => Gi(e, "pad"), Lu = (e) => Gi(e, "mar"), pt = (e) => Xr(e, "bdr-1", (t) => `bdr-${t}`), Nu = (e) => $s(e, (t) => `fgc-${t}`), Mu = (e) => $s(e, (t) => `bgc-${t}`), Du = (e) => $s(e, (t) => `fgd-${t}`), $u = (e) => $s(e, (t) => `bgd-${t}`), Kr = (e) => qr(
  e,
  "gap-1",
  (t) => {
    const n = sn(t);
    return n.length === 2 ? br("gap", ["v", "h"], n) : `gap-${t}`;
  }
), $s = (e, t) => Ls(parseInt(e)) ? re(t, e) : null, qr = (e, t, n) => e === !0 ? t : T(e) ? re(n, e) : null, Xr = (e, t, n) => e === !0 ? t : Ls(parseInt(e)) ? re(n, e) : null, Gi = (e, t) => qr(
  e,
  t,
  (n) => Ou(t, sn(n))
), Ou = (e, t) => t.length === 2 ? br(e, ["v", "h"], t) : t.length === 4 ? br(e, ["t", "r", "b", "l"], t) : t.map((n) => `${e}-${n}`).join(" "), br = (e, t, n) => n.map((s, r) => `${e}-${t[r]}-${s}`).join(" "), Zn = Mt();
function Ho(e) {
  return typeof e == "function";
}
function zo(e) {
  return typeof e == "object" && !Zi(e) && !Tu(e);
}
function Zi(e) {
  return Array.isArray(e);
}
function Tu(e) {
  return e === null;
}
function ku({
  context: e = {},
  Implementation: t,
  spec: n = !1,
  props: s = {},
  ref: r
}) {
  if (!n)
    return /* @__PURE__ */ l(t, { ...s, ref: r });
  let o = {}, i = Ho(n) ? n(e) : e[n];
  if (Zi(i) && (t = i[0], i = i[1]), Ho(i)) {
    const a = i(s, r, e);
    if (F.isValidElement(a))
      return a;
    zo(a) && Object.assign(o, s, a);
  } else
    zo(i) ? Object.assign(o, i, s) : Object.assign(o, s);
  return /* @__PURE__ */ l(t, { ...o, ref: r });
}
const Iu = (e) => ({ Context: Zn, Provider: ({ children: t, ...n }) => /* @__PURE__ */ l(Zn.Provider, { value: { ...e, ...n }, children: t }), Consumer: (t) => (n) => /* @__PURE__ */ l(Zn.Consumer, { children: (s) => /* @__PURE__ */ l(t, { ...s, ...n, context: s }) }), Component: (t, n = t.displayName || t.name) => F.forwardRef(
  (s, r) => /* @__PURE__ */ l(Zn.Consumer, { children: (o) => /* @__PURE__ */ l(
    ku,
    {
      Implementation: t,
      context: o,
      spec: n,
      props: s,
      ref: r
    }
  ) })
) }), Eu = Iu(), L = Eu.Component, Pu = (e) => /* @__PURE__ */ l(
  Ui,
  {
    ...Yi(e)
  }
), X = L(Pu, "Icon");
function Au(e, t, n = {}) {
  return T(t) && (n[e] = Ls(t) ? `${t}deg` : t), Object.keys(n).length ? n : null;
}
const Fu = (e, t, n = {}) => ({
  ...Object.entries(e).reduce(
    (s, [r, o]) => {
      const i = t[r];
      return T(i) && (s[o] = i), s;
    },
    t.style || {}
  ),
  ...n
}), sr = (e, { side: t = "" } = {}) => {
  const n = `icon${t}`, s = e[n], r = ve(s) ? s : { name: s }, o = M(
    r.className,
    e[`${n}Class`],
    t ? `on-${t.toLowerCase()}` : null
  );
  o.length && (r.className = o);
  const i = e[`${n}Rotate`];
  return T(i) && (r.style = Au("--icon-rotate", i, r.style)), r;
}, Uo = (e) => Ge(e) ? { name: e } : e, Vu = ({
  icon: e,
  iconLeft: t,
  iconRight: n,
  spanText: s,
  spanClass: r,
  text: o,
  children: i,
  ...a
}) => /* @__PURE__ */ w(be, { children: [
  !!e && /* @__PURE__ */ l(
    X,
    {
      ...sr({ icon: e, ...a }),
      fixedWidth: !0
    }
  ),
  !!t && /* @__PURE__ */ l(
    X,
    {
      ...sr({ iconLeft: t, ...a }, { side: "Left" }),
      fixedWidth: !0
    }
  ),
  s ? /* @__PURE__ */ l("span", { className: r ?? "", children: o || i }) : o || i,
  !!n && /* @__PURE__ */ l(
    X,
    {
      ...sr({ iconRight: n, ...a }, { side: "Right" }),
      fixedWidth: !0
    }
  )
] }), mt = L(Vu, "WithIcons"), Bu = ({
  summary: e,
  summaryClass: t,
  toggleOpen: n,
  detailsSummaryClass: s = "summary",
  summarySpanClass: r = "summary-text",
  ...o
}) => /* @__PURE__ */ l(
  "div",
  {
    onClick: n,
    className: M(s, t),
    children: /* @__PURE__ */ l(
      mt,
      {
        text: e,
        spanText: !0,
        spanClass: r,
        ...kn(o, /^(icon|text)/)
      }
    )
  }
), Ji = ({
  content: e,
  children: t,
  contentClass: n
}) => /* @__PURE__ */ l("div", { className: n, children: e || t }), ju = ({
  className: e,
  size: t,
  color: n,
  lined: s,
  border: r,
  radius: o,
  shaded: i,
  shadow: a,
  isOpen: c,
  toggleOpen: u,
  detailsClass: d = "details",
  noIconClass: h = "no-icon",
  wideSummary: g,
  wideSummaryClass: f = "wide-summary",
  Summary: m = Bu,
  Content: p = Ji,
  ...b
}) => /* @__PURE__ */ w(
  "div",
  {
    className: M(
      d,
      h,
      e,
      n,
      ft(r),
      pt(o),
      gt(a),
      { size: t, color: n, lined: s, shaded: i, open: c, [f]: g }
    ),
    children: [
      /* @__PURE__ */ l(m, { toggleOpen: u, ...b }),
      !!c && /* @__PURE__ */ l(p, { ...b })
    ]
  }
), Wu = Tr.Consumer(ju), Hu = ({
  summary: e,
  summaryClass: t
}) => /* @__PURE__ */ l("summary", { className: t, children: e }), zu = ({
  className: e,
  size: t,
  color: n,
  lined: s,
  border: r,
  radius: o,
  shaded: i,
  shadow: a,
  open: c,
  Summary: u = Hu,
  Content: d = Ji,
  ...h
}) => /* @__PURE__ */ w(
  "details",
  {
    className: M(
      e,
      n,
      ft(r),
      pt(o),
      gt(a),
      { size: t, color: n, lined: s, shaded: i }
    ),
    open: c,
    children: [
      /* @__PURE__ */ l(u, { ...h }),
      /* @__PURE__ */ l(d, { ...h })
    ]
  }
), Uu = {
  iconLeft: "angle-right",
  iconLeftRotate: 90,
  iconRightRotate: -90
}, Ku = ({
  native: e,
  open: t,
  Container: n = e ? zu : Wu,
  ...s
}) => /* @__PURE__ */ l(Tr.Provider, { open: t, children: /* @__PURE__ */ l(n, { ...Uu, ...s }) }), qu = L(Ku, "Details"), Xu = ({
  items: e,
  shadow: t,
  radius: n,
  className: s,
  accordionClass: r = "accordion",
  ...o
}) => /* @__PURE__ */ l(
  "div",
  {
    className: M(
      s,
      r,
      gt(t),
      pt(n)
    ),
    children: e.map(
      (i, a) => /* @__PURE__ */ l(
        qu,
        {
          radius: n,
          ...o,
          ...i
        },
        i.key ?? i.id ?? a
      )
    )
  }
), pC = L(Xu, "Accordion"), _u = (e) => /* @__PURE__ */ l(
  au,
  {
    ...Yi(e)
  }
), mC = L(_u, "Icons"), Yu = ({
  dismissable: e,
  dismiss: t,
  revealable: n,
  isRevealed: s,
  openIcon: r = "angle-down",
  closedIcon: o = "angle-left",
  dismissIcon: i = "cross"
}) => /* @__PURE__ */ w("div", { className: "on-right", children: [
  !!e && /* @__PURE__ */ l(
    X,
    {
      name: i,
      fixedWidth: !0,
      className: "dismiss",
      onClick: () => t(!0)
    }
  ),
  !!n && /* @__PURE__ */ l(
    X,
    {
      name: s ? r : o,
      fixedWidth: !0,
      className: "reveal"
    }
  )
] }), Qi = L(Yu, "AlertControls"), Gu = ({
  headline: e,
  headIcon: t,
  headicon: n = t,
  toggle: s,
  revealable: r = !1,
  controlProps: o,
  Controls: i = Qi
}) => /* @__PURE__ */ w(
  "div",
  {
    className: "headline flex space",
    onClick: r ? s : null,
    children: [
      /* @__PURE__ */ w("div", { children: [
        !!n && /* @__PURE__ */ l(
          X,
          {
            name: n,
            fixedWidth: !0,
            className: "on-left"
          }
        ),
        e
      ] }),
      /* @__PURE__ */ l(i, { ...o })
    ]
  }
), Zu = L(Gu, "AlertHeadline"), Ju = ({
  title: e,
  text: t,
  children: n
}) => /* @__PURE__ */ w(be, { children: [
  e && /* @__PURE__ */ l("h3", { children: e }),
  t ? /* @__PURE__ */ l("p", { children: t }) : n
] }), ea = L(Ju, "AlertContent"), Qu = ({
  icon: e,
  Content: t = ea,
  ...n
}) => /* @__PURE__ */ w("div", { className: "side-icon", children: [
  /* @__PURE__ */ l(X, { name: e }),
  /* @__PURE__ */ l("div", { className: "wide", children: /* @__PURE__ */ l(t, { ...n }) })
] }), ed = L(Qu, "AlertIcon");
function bC(e) {
  return e.split(/\s*[;&]\s*/).filter((t) => t.length > 0).reduce(
    (t, n) => {
      const [s, r] = n.split(/\s*[:=]\s*/);
      return t[s] = qi(r) ? !0 : r, t;
    },
    {}
  );
}
const td = "unknown", nd = "mobile", sd = "tablet", rd = "laptop", od = "desktop", id = "widescreen", ad = "ultra", Os = {
  [td]: 0,
  [nd]: 480,
  [sd]: 720,
  [rd]: 960,
  [od]: 1200,
  [id]: 1440
}, ld = {
  breakpoints: Os,
  largest: ad
}, _r = (e = 0, t = {}) => {
  const n = { ...ld, ...t }, s = Object.entries(n.breakpoints).find(
    ([, r]) => e <= r
  );
  return s ? s[0] : n.largest;
}, cd = (e = window) => typeof e > "u" ? !1 : e.innerWidth, vC = (e, t) => _r(cd(e), t), In = (e) => Ki(e) || !e.separator && !e.heading && !e.disabled, ta = (e) => Ki(e) ? e : e.value ?? e.id, na = (e, t, n = ta) => {
  if (Ns(t))
    return [];
  const s = n(t), r = e.findIndex(
    (o) => s === n(o)
  );
  return r >= 0 ? [e[r], r] : [];
}, ud = (e, t) => {
  const n = e.toLowerCase().split(/\s+/);
  return t.filter(
    (s) => {
      const r = ve(s), o = r ? s.search ?? s.text ?? s.label ?? s.name ?? s.value : s;
      if (r && s.fixed)
        return !0;
      if (T(o)) {
        const i = o.toString().toLowerCase();
        return n.every(
          (a) => i.indexOf(a) >= 0
        );
      }
      return !1;
    }
  );
};
function dd(e, t = In) {
  const n = e.findIndex(t);
  return n < 0 ? null : n;
}
function hd(e, t = In) {
  for (let n = e.length - 1; n >= 0; n--)
    if (t(e[n]))
      return n;
  return null;
}
function fd(e, t, n = In) {
  for (let s = 1; s <= e.length; s++) {
    const r = (t + s) % e.length;
    if (n(e[r]))
      return r;
  }
  return null;
}
function gd(e, t, n = In) {
  for (let s = 1; s <= e.length; s++) {
    const r = (t + e.length - s) % e.length;
    if (n(e[r]))
      return r;
  }
  return null;
}
const pd = (e) => e == null ? void 0 : e.stopPropagation(), md = {
  ...Os,
  cols: !0
}, bd = (e) => {
  const t = { ...e };
  return [kn(
    t,
    md,
    { delete: !0 }
  ), t];
}, vd = (e, t) => {
  const [n, s] = bd(e);
  return [Cd(n, t), s];
}, Cd = (e, t) => {
  if (!t)
    return `grid-${e.cols || 1}`;
  let n = e.cols || 1;
  const s = Object.keys(Os), r = s.indexOf(t);
  if (r >= 0) {
    const i = s.slice(r).find(
      (a) => e[a]
    );
    i && (n = e[i]);
  }
  return `grid-${n}`;
}, xt = (e) => Tn(e) ? e : parseFloat(e), vr = (e, t, n) => sn(e).find(
  (s) => t[s] !== n[s]
), Yr = (e) => (t) => {
  e.forEach(
    (n) => {
      $t(n) ? n(t) : n != null && (n.current = t);
    }
  );
}, Lt = (e) => {
  const t = `HINT: define ${e}() to render this value`;
  return (n) => Ge(n) || Tn(n) ? n : ve(n) ? n.text ?? n.label ?? n.name ?? n.heading ?? t : t;
}, yd = (e) => Ge(e) || Tn(e) ? e : /* @__PURE__ */ l(mt, { ...e }), sa = (e, t) => {
  if (!e || !t)
    return;
  const n = t.offsetTop, s = n + t.offsetHeight, r = e.scrollTop, o = r + e.offsetHeight;
  n < r ? e.scrollTo({
    top: n
  }) : s > o && e.scrollTo({
    top: r + (s - o)
  });
}, xd = (e) => {
  const t = e.match(/^(\d+)px$/);
  if (t)
    return parseInt(t[1]);
  const n = e.match(/^(\d+)rem$/);
  if (n)
    return parseInt(n[1] * 16);
  const s = e.match(/^(\d+)$/);
  return s ? parseInt(s[1]) : Os[e] || Ms(`Invalid size specified: ${e}`);
};
function wd() {
  let e = {};
  return {
    clear: () => e = {},
    getItem: (t) => e[t],
    setItem: (t, n) => e[t] = n,
    removeItem: (t) => delete e[t]
  };
}
const Jn = typeof window < "u" && window.localStorage || wd(), Qn = (e, t) => [e, t].join("-");
function Gr(e) {
  return {
    get: (t, n) => {
      const s = Jn.getItem(
        Qn(e, t)
      );
      return T(s) ? JSON.parse(s) : T(n) ? (Jn.setItem(
        Qn(e, t),
        JSON.stringify(n)
      ), n) : null;
    },
    set: (t, n) => Jn.setItem(
      Qn(e, t),
      JSON.stringify(n)
    ),
    delete: (t) => Jn.removeItem(
      Qn(e, t)
    )
  };
}
const ra = (e) => e.charAt(0).toUpperCase() + e.slice(1), CC = (e = {}, t = {}) => Object.entries(t).reduce(
  (n, [s, r]) => {
    const o = n[s];
    if (!o)
      return n;
    const a = { ...r[o] || Ms(`Invalid themedProps() value for ${s}: ${o}`), ...n };
    return delete a[s], a;
  },
  e
), yC = (e, t, n = {}) => {
  const s = e.variant || Object.keys(t).find((r) => e[r]) || "default";
  return t[s] || t.default || n;
}, Ze = ({
  title: e,
  headline: t,
  headicon: n,
  headIcon: s = n,
  type: r,
  size: o,
  color: i,
  compact: a,
  stripe: c,
  border: u,
  radius: d,
  shadow: h,
  className: g,
  text: f,
  children: m,
  onDismiss: p,
  icon: b,
  dismissable: v = !1,
  revealable: y = !1,
  revealed: C = !1,
  openIcon: x,
  closedIcon: S,
  dismissIcon: D,
  Headline: R = Zu,
  Controls: N = Qi,
  Content: k = ea,
  Icon: O = ed
}) => {
  const [$, W] = j(y ? C : !0), [A, z] = j(!1), Ce = M(
    "alert",
    r,
    o,
    i,
    g,
    {
      compact: a,
      revealable: y,
      dismissable: v,
      stripe: c
    },
    $ ? "revealed" : null,
    gt(h),
    ft(u),
    pt(d)
  ), te = () => W((oe) => !oe), Y = {
    dismissable: v,
    revealable: y,
    isRevealed: $,
    dismiss: () => {
      z(!0), p && p();
    },
    openIcon: x,
    closedIcon: S,
    dismissIcon: D
  }, ne = {
    title: e,
    text: f,
    children: m
  }, ue = {
    ...ne,
    icon: b,
    Content: k
  }, Et = {
    headline: t,
    headIcon: s,
    toggle: te,
    revealable: y,
    controlProps: Y,
    Controls: N
  };
  return A ? null : /* @__PURE__ */ w("div", { className: Ce, children: [
    !!t && /* @__PURE__ */ l(R, { ...Et }),
    $ && (b ? /* @__PURE__ */ l(O, { ...ue }) : /* @__PURE__ */ l(k, { ...ne }))
  ] });
}, Sd = L(
  (e) => /* @__PURE__ */ l(Ze, { ...e, type: "info" }),
  "Info"
), Rd = L(
  (e) => /* @__PURE__ */ l(Ze, { ...e, type: "success" }),
  "Success"
), Ld = L(
  (e) => /* @__PURE__ */ l(Ze, { ...e, type: "warning" }),
  "Warning"
), Nd = L(
  (e) => /* @__PURE__ */ l(Ze, { ...e, type: "error" }),
  "Error"
);
Ze.Info = Sd;
Ze.Success = Rd;
Ze.Warning = Ld;
Ze.Error = Nd;
const xC = L(Ze, "Alert"), Md = ({
  prefix: e,
  prefixClass: t = "prefix"
}) => /* @__PURE__ */ l("div", { className: t, children: e }), Dd = ({
  suffix: e,
  suffixClass: t = "suffix"
}) => /* @__PURE__ */ l("div", { className: t, children: e }), $d = ({
  size: e,
  color: t,
  compact: n,
  className: s,
  tag: r,
  shadow: o,
  border: i,
  radius: a,
  tooltip: c,
  icon: u,
  iconClass: d,
  iconLeft: h,
  iconLeftClass: g,
  iconRight: f,
  iconRightClass: m,
  label: p,
  text: b,
  prefix: v,
  suffix: y,
  children: C,
  Prefix: x = Md,
  Suffix: S = Dd,
  Content: D = mt,
  ...R
}) => {
  const N = M(
    "badge",
    e,
    t,
    s,
    {
      compact: n,
      tag: r,
      icon: u
    },
    gt(o),
    ft(i),
    pt(a)
  ), k = {
    icon: u,
    iconClass: d,
    iconLeft: h,
    iconLeftClass: g,
    iconRight: f,
    iconRightClass: m,
    text: b,
    children: C
  };
  return /* @__PURE__ */ w(
    "div",
    {
      className: N,
      "data-tooltip": c,
      "aria-label": p,
      ...R,
      children: [
        !!v && /* @__PURE__ */ l(x, { prefix: v, ...R }),
        /* @__PURE__ */ l(
          D,
          {
            ...k
          }
        ),
        !!y && /* @__PURE__ */ l(S, { suffix: y, ...R })
      ]
    }
  );
}, wC = L($d, "Badge"), Od = ({
  type: e = "button",
  size: t,
  color: n,
  className: s,
  disabled: r,
  bright: o,
  dark: i,
  outline: a,
  bare: c,
  shaded: u,
  shadow: d,
  border: h,
  radius: g,
  label: f,
  tooltip: m,
  tabIndex: p = 0,
  icon: b,
  iconClass: v,
  iconLeft: y,
  iconLeftClass: C,
  iconRight: x,
  iconRightClass: S,
  text: D,
  children: R,
  Content: N = mt,
  ...k
}) => {
  const O = M(
    t,
    n,
    s,
    {
      bright: o,
      dark: i,
      outline: a,
      bare: c,
      shaded: u,
      icon: b
    },
    gt(d),
    ft(h),
    pt(g)
  );
  return /* @__PURE__ */ l(
    "button",
    {
      className: O,
      "aria-label": f,
      tabIndex: p,
      type: e,
      disabled: r,
      "aria-disabled": r,
      "data-tooltip": m,
      ...k,
      children: /* @__PURE__ */ l(
        N,
        {
          ...{
            icon: b,
            iconClass: v,
            iconLeft: y,
            iconLeftClass: C,
            iconRight: x,
            iconRightClass: S,
            text: D,
            children: R
          }
        }
      )
    }
  );
}, Se = L(Od, "Button"), Td = ({
  buttons: e,
  children: t,
  className: n = "buttons",
  buttonClass: s,
  Button: r = Se,
  ...o
}) => /* @__PURE__ */ l("div", { className: n, children: e ? e.map(
  (i, a) => /* @__PURE__ */ l(
    r,
    {
      className: s,
      ...o,
      ...i
    },
    a
  )
) : t }), Cr = L(Td, "Buttons"), kd = ({
  className: e,
  disabled: t,
  children: n,
  ref: s
}) => /* @__PURE__ */ l(
  "label",
  {
    className: M(e, { disabled: t }),
    ref: s,
    children: n
  }
), Id = L(kd, "CheckboxLabel"), Ed = ({
  disabled: e = !1,
  tabIndex: t = 0,
  onChange: n = E,
  inputClass: s,
  round: r,
  square: o,
  ref: i,
  switch: a,
  ...c
}) => /* @__PURE__ */ l(
  "input",
  {
    type: "checkbox",
    ref: i,
    "aria-disabled": e,
    tabIndex: e ? -1 : t,
    onChange: (u) => n(u.target.checked),
    className: M(s, { round: r, square: o }),
    role: a ? "switch" : null,
    ...c
  }
), Pd = L(Ed, "CheckboxInput"), Ad = ({
  size: e,
  color: t,
  border: n,
  inline: s,
  className: r = "checkbox",
  text: o,
  ref: i,
  inputRef: a,
  checked: c,
  checkedText: u = o,
  uncheckedText: d = o,
  // icon,
  // checkedIcon=icon,
  // uncheckedIcon=icon,
  // iconClass,
  Label: h = Id,
  Input: g = Pd,
  ...f
}) => /* @__PURE__ */ w(
  h,
  {
    className: M(
      e,
      t,
      r,
      ft(n),
      { inline: s }
    ),
    ref: i,
    checked: c,
    ...f,
    children: [
      /* @__PURE__ */ l(g, { ref: a, checked: c, ...f }),
      c ? u : d
    ]
  }
), oa = L(Ad, "Checkbox"), Fd = ({
  checked: e = !1
} = {}) => {
  const [t, n] = j(e);
  return {
    isChecked: t,
    setChecked: n,
    check: () => n(!0),
    uncheck: () => n(!1)
  };
}, SC = ({
  checked: e = !1,
  onChange: t,
  ...n
}) => {
  const { isChecked: s, setChecked: r } = Fd({ checked: e });
  return /* @__PURE__ */ l(
    oa,
    {
      checked: s,
      onChange: (i) => {
        r(i), t && t(i);
      },
      ...n
    }
  );
}, Zr = ({
  visible: e = !1
} = {}) => {
  const [t, n] = j(e);
  return {
    isVisible: t,
    setVisible: n,
    show: () => n(!0),
    hide: () => n(!1)
  };
}, Vd = ({
  close: e,
  icon: t = "cross",
  className: n = "close"
}) => /* @__PURE__ */ l("div", { className: n, onClick: e, children: /* @__PURE__ */ l(X, { name: t }) }), Bd = L(Vd, "ModalClose"), jd = ({
  title: e,
  header: t
}) => e || t ? /* @__PURE__ */ w("header", { children: [
  !!e && /* @__PURE__ */ l("h3", { children: e }),
  t
] }) : null, Wd = L(jd, "ModalHeader"), Hd = ({
  footer: e
}) => !!e && /* @__PURE__ */ l("footer", { children: e }), zd = L(Hd, "ModalFooter"), Ud = ({
  text: e,
  children: t,
  Header: n = Wd,
  Footer: s = zd,
  ...r
}) => /* @__PURE__ */ w("article", { onClick: pd, children: [
  /* @__PURE__ */ l(n, { ...r }),
  e || t,
  /* @__PURE__ */ l(s, { ...r })
] }), Kd = L(Ud, "ModalContent"), qd = ({
  ref: e,
  open: t,
  close: n,
  className: s,
  closeClass: r = "close",
  closeIcon: o = "cross",
  Close: i = Bd,
  Content: a = Kd,
  closeOnClick: c,
  onClick: u = c ? n : null,
  onCancel: d = n || E,
  style: h = {},
  maxWidth: g,
  maxHeight: f,
  ...m
}) => {
  e || (e = U(null)), B(
    () => {
      const { current: b } = e;
      t ? b.showModal() : b.close();
    },
    [t]
  );
  const p = {
    ...h
  };
  return g && (p["--max-width"] = g), f && (p["--max-height"] = f), /* @__PURE__ */ w(
    "dialog",
    {
      ref: e,
      className: s,
      style: p,
      onClick: u,
      onCancel: d,
      children: [
        !!n && /* @__PURE__ */ l(
          i,
          {
            close: n,
            icon: o,
            className: r
          }
        ),
        /* @__PURE__ */ l(a, { ...m })
      ]
    }
  );
}, ia = L(qd, "Modal"), Xd = ({
  isVisible: e,
  title: t,
  header: n,
  prompt: s,
  modalClass: r,
  ...o
}) => /* @__PURE__ */ l(
  ia,
  {
    ...o,
    open: e,
    title: t,
    header: n,
    className: r,
    text: s ?? /* @__PURE__ */ l(Ko, { ...o }),
    footer: !!s && /* @__PURE__ */ l(Ko, { ...o })
  }
), Ko = ({
  buttonClass: e,
  cancel: t,
  confirm: n
}) => /* @__PURE__ */ w("div", { className: "flex space gap-4", children: [
  /* @__PURE__ */ l(Se, { className: e, ...t }),
  /* @__PURE__ */ l(Se, { className: e, ...n })
] }), _d = ({
  initiallyRevealed: e = !1,
  open: t = e,
  confirmIcon: n = "check",
  confirmText: s = "Confirm",
  confirmColor: r = "red",
  confirmClass: o,
  cancelIcon: i = "cross",
  cancelText: a = "Cancel",
  cancelColor: c = "grey",
  cancelClass: u,
  confirm: d = {
    iconRight: n,
    text: s,
    color: r,
    className: o
  },
  cancel: h = {
    iconLeft: i,
    text: a,
    color: c,
    className: u
  },
  // prompt,
  buttonsClass: g,
  className: f = g,
  buttonClass: m,
  modal: p,
  modalClass: b,
  onClick: v = () => window.alert("No confirm action defined"),
  ...y
}) => {
  const { isVisible: C, hide: x, show: S } = Zr({ visible: t }), R = {
    iconRight: n,
    text: s,
    color: r,
    className: o,
    ...d,
    onClick: (k) => {
      k.preventDefault(), x(), v();
    }
  }, N = {
    iconLeft: i,
    text: a,
    color: c,
    className: u,
    outline: !0,
    ...h,
    onClick: x
  };
  return p ? /* @__PURE__ */ w(be, { children: [
    /* @__PURE__ */ l(
      Cr,
      {
        className: f,
        buttonClass: m,
        buttons: [{ ...y, onClick: S }]
      }
    ),
    /* @__PURE__ */ l(
      Xd,
      {
        isVisible: C,
        confirm: R,
        cancel: N,
        modalClass: b,
        ...y
      }
    )
  ] }) : /* @__PURE__ */ l(
    Cr,
    {
      className: f,
      buttonClass: m,
      buttons: C ? [N, R] : [{ ...y, onClick: S }]
    }
  );
}, RC = L(_d, "Confirm"), LC = (e) => {
  const t = e, n = "text", s = jr(t);
  return { field: t, type: n, label: s };
}, rr = (e) => {
  Ge(e) && (e = { field: e });
  const { field: t } = e;
  return e.type || (e.type = "text"), e.label || (e.label = jr(t)), e.heading || (e.heading = e.label), e.id || (e.id = t), e.sortable ?? (e.sortable = !0), e.filterable ?? (e.filterable = !0), e;
}, Yd = (e) => {
  if (Ge(e))
    return Nt(
      e,
      rr
    );
  if (Fe(e))
    return e.reduce(
      (t, n) => {
        const s = rr(n);
        return t[s.field] = s, t;
      },
      {}
    );
  if (ve(e))
    return Object.entries(e).reduce(
      (t, [n, s]) => {
        if (Dt(s) && !s)
          return t;
        const r = rr({
          // column can also be any true value which might not be iterable
          ...ve(s) ? s : {},
          field: n
        });
        return t[r.field] = r, t;
      },
      {}
    );
  Ms("Invalid columns definition");
}, Gd = (e, t) => {
  if (t) {
    const n = t.filter((s) => e[s]);
    if (n.length)
      return n;
  }
  return Object.keys(e).filter((n) => !e[n].hidden);
}, Zd = (e, t) => {
  if (t) {
    const n = t.filter((r) => e[r]), s = Nt(n);
    if (n.push(
      ...Object.keys(e).filter((r) => !s[r])
    ), n.length)
      return n;
  }
  return Object.keys(e);
}, Jd = (e, t, n) => t && e[t] ? [t, n] : [null, null], Qd = ({ value: e, search: t }) => (
  // we have to do woolly string searching because the value returned from a select
  // component is always a string
  T(e) ? e.toString() === t.toString() : !1
), Wt = ({ value: e, search: t }) => {
  const n = t.toLowerCase().split(/\s+/);
  if (T(e)) {
    const s = e.toString().toLowerCase();
    return n.every(
      (r) => s.indexOf(r) > -1
    );
  } else
    return !1;
}, eh = ({ value: e, search: t }) => (
  //console.log('filterInteger(%o, %o, %o) [%s][%o] == [%s][%o]', row, field, search, typeof match, match, typeof search, search);
  T(e) ? parseInt(e) === parseInt(t) : !1
), th = ({ value: e, search: t }) => (
  //console.log('filterFloat(%o, %o, %o) [%s][%o] == [%s][%o]', row, field, search, typeof match, match, typeof search, search);
  T(e) ? parseFloat(e) === parseFloat(t) : !1
), yr = (e) => Ge(e) ? !!parseInt(e) : !!e, nh = ({ value: e = !1, search: t }) => (
  // The problem here is that a vanilla select input can't have options with
  // true/false values, and values of 0/1 get converted to strings.
  // So if the search value is a string then we parse it as an integer and
  // compare it to 0.
  yr(e) === yr(t)
), qo = {
  string: Wt,
  text: Wt,
  id: Wt,
  number: Wt,
  price: Wt,
  pounds: Wt,
  select: Qd,
  boolean: nh,
  integer: eh,
  float: th
}, sh = (e, t, n) => {
  const s = Object.keys(n).filter((r) => t[r]);
  return s.length === 0 ? e : e.filter(
    (r) => s.every(
      (o) => {
        const i = n[o], a = t[o], c = a.field || o, u = r[c], d = a.filterType || a.type, h = a.filter || qo[d] || qo.text;
        return T(i) && (Dt(i) || i.length) ? h({ row: r, field: c, value: u, search: i }) : !0;
      }
    )
  );
}, rh = (e, t = 1, n = e.length) => {
  const s = e.length, r = Math.ceil(s / n);
  t = Math.min(t, r);
  const o = t - 1, i = n * o, a = Math.min(i + n - 1, s - 1), c = e.slice(i, a + 1);
  return {
    pageSize: n,
    pages: r,
    page: o,
    pageNo: t,
    total: s,
    firstIndex: i,
    lastIndex: a,
    firstPage: 1,
    lastPage: r,
    thisSize: c.length,
    from: i + 1,
    to: a + 1,
    all: i === a,
    one: s === 1,
    none: s === 0,
    rows: c
  };
}, Xo = {
  string: nr,
  text: nr,
  select: nr,
  number: tr,
  price: tr,
  currency: tr,
  integer: Wo,
  id: Wo
}, oh = (e, t, n, s) => {
  if (!n || !t[n])
    return e;
  const r = t[n], o = r.sort, i = r.type || "text", a = $t(o) ? o : (Xo[i] || Xo.text)(n);
  return e.sort(
    s ? bu(a) : a
  );
}, ih = ({
  render: e,
  rows: t = [],
  storageKey: n,
  storageItem: s = "state",
  debug: r,
  ...o
}) => {
  const i = r ? console.log : E, [a, c] = H(
    () => {
      const O = n && Gr(n), $ = O ? O.get(s, {}) : {};
      return [O, $];
    },
    [n]
  ), [u, d, h, g, f] = H(
    () => {
      i("computing columns: ", o.columns);
      const O = Yd(o.columns);
      return [
        O,
        Gd(O, c.visibleColumns),
        Zd(O, c.columnOrder),
        ...Jd(
          O,
          c.sortColumn ?? o.sortColumn,
          c.sortReverse ?? o.sortReverse
        )
      ];
    },
    [o.columns, o.sortColumn, o.sortReverse, c]
  ), [m, p] = aC({
    pageNo: c.pageNo ?? o.pageNo ?? 1,
    pageSize: c.pageSize ?? o.pageSize ?? 10,
    sortColumn: g,
    sortReverse: f,
    columnOrder: h,
    visibleColumns: d
  }), [b, v] = j(!1), [y, C] = j({}), x = (O) => {
    O.preventDefault(), O.stopPropagation(), v(($) => !$);
  }, S = (O, $) => {
    C(
      (W) => {
        const A = { ...W };
        return T($) && (Dt($) || $.length) ? A[O] = $ : delete A[O], A;
      }
    ), p.setPageNo(1);
  };
  B(
    () => {
      i("columns have changed: ", u), p.setSortColumn(g), p.setSortReverse(f), p.setColumnOrder(h), p.setVisibleColumns(d);
    },
    [g, f, h, d]
  ), B(
    () => {
      i("rows, filters or sorting order has changed"), p.setPageNo(1);
    },
    [t, m.sortColumn, m.sortReverse, m.filters]
  ), B(
    () => {
      a && (i("Saving state in local storage:", m), a.set(s, m));
    },
    [m, a]
  );
  const D = (O) => {
    m.sortColumn === O ? (i(`Sort column already set to ${O}, changing direction`), p.setSortReverse(($) => !$)) : (i(`Setting sort column to ${O}`), p.setSortColumn(O), p.setSortReverse(!1));
  }, R = (O) => p.setVisibleColumns(
    ($) => {
      const W = Nt($), A = W[O] ? $.filter((z) => z !== O) : Object.keys(u).filter((z) => z === O || W[z]);
      return i("New visible columns:", A), A;
    }
  ), N = (O) => {
    let $ = [], W = [];
    const A = Nt(m.visibleColumns);
    O.forEach(
      (z) => {
        $.push(z), A[z] && W.push(z);
      }
    ), i("New order of all columns:", $), i("New order of visible columns:", W), p.setVisibleColumns(W), p.setColumnOrder($);
  }, k = H(
    () => rh(
      oh(
        sh(t, u, y),
        u,
        m.sortColumn,
        m.sortReverse
      ),
      m.pageNo,
      m.pageSize
    ),
    [
      t,
      u,
      y,
      m.sortColumn,
      m.sortReverse,
      m.pageNo,
      m.pageSize
    ]
  );
  return e({
    ...o,
    rows: t,
    columns: u,
    page: k,
    showFilters: b,
    toggleFilters: x,
    filters: y,
    setFilter: S,
    hasFilters: Object.keys(y).length,
    toggleSortColumn: D,
    toggleVisibleColumn: R,
    changeColumnOrder: N,
    ...m,
    ...p
  });
}, _ = Xe(ih), NC = _.Use, MC = _.Consumer, ah = ({
  page: e,
  summaryClass: t = "flex center balance mar-b-2"
}) => /* @__PURE__ */ w("div", { className: t, children: [
  "Page ",
  e.pageNo,
  "/",
  e.lastPage,
  " ",
  e.none ? "no rows" : e.one ? "one row" : e.all ? `all ${qt(e.total)} rows` : `rows ${qt(e.from)}-${qt(e.to)} of ${qt(e.total)}`,
  " "
] }), lh = _.Consumer(ah), DC = "-", Yt = "", Xt = "any", ch = "ArrowLeft", uh = "ArrowRight", Ts = "ArrowUp", ks = "ArrowDown", dh = "Tab", Is = "Enter", Jr = " ", Es = "Escape", hh = "Backspace", aa = "True", la = "False", $C = 512, OC = 512;
var Ke;
let ca = (Ke = class extends Rt {
  componentDidMount() {
    this.mounted = !0, this.props.onLoad(this);
  }
  componentWillUnmount() {
    this.mounted = !1, this.props.onUnload(this);
  }
  onMouseEnter() {
    this.debug("onMouseEnter()"), this.setState(
      { hasHover: !0 },
      this.props.openOnHover ? () => {
        this.open(), this.focusTrigger();
      } : null
    );
  }
  onMouseLeave() {
    this.debug("onMouseLeave()"), this.setState(
      { hasHover: !1 },
      this.props.openOnHover ? () => this.closeSoon() : null
    );
  }
  onFocus() {
    this.debug("onFocus()"), this.setState(
      { hasFocus: !0 },
      this.props.onFocus
    );
  }
  onBlur() {
    this.debug("onBlur()"), this.setState(
      { hasFocus: !1 },
      this.props.onBlur
    ), this.props.closeOnBlur && this.closeSoon();
  }
  onClick() {
    this.debug("onClick()"), this.state.isOpen ? this.close() : this.open();
  }
  open() {
    this.debug("open()"), this.setState(
      {
        isOpen: !0
      },
      this.props.onOpen
    );
  }
  close() {
    this.debug("close()"), this.setState(
      this.closeState(),
      this.props.onClose
    );
  }
  closeState() {
    return this.constructor.inactiveState;
  }
  closeSoon(t = !1) {
    this.debug(`closeSoon()  force:${t}`), Hr(this.props.closeDelay).then(
      () => {
        this.closeable(t) ? this.close() : this.debug(`NOT closing force:${t} hasHover:${this.state.hasHover}`);
      }
    );
  }
  closeable(t) {
    return t || !this.state.hasHover;
  }
  onKeyDown(t) {
    switch (this.debug(`onKeyDown(${t.key})`), t.key) {
      case Is:
      case Jr:
        this.state.isOpen ? this.close() : this.open();
        break;
      case Es:
        this.close();
        break;
      default:
        this.debug(`ignored key ${t.key}`);
        return;
    }
    t.preventDefault();
  }
  triggerRef(t) {
    this._triggerRef = t;
  }
  focusTrigger() {
    this._triggerRef ? (this.debug("focussing trigger"), this._triggerRef.focus()) : this.debug("no trigger to focus");
  }
}, I(Ke, "debug", !1), I(Ke, "defaultProps", {
  options: [],
  openOnHover: !1,
  closeOnBlur: !0,
  closeDelay: 300,
  onLoad: E,
  onUnload: E,
  onFocus: E,
  onBlur: E,
  onClick: E,
  onOpen: E,
  onClose: E
}), I(Ke, "inactiveState", {
  isOpen: !1
}), I(Ke, "initialState", {
  ...Ke.inactiveState
}), Ke);
const St = class St extends ca {
  open(t = this.initialCursor() ?? this.cursorFirstIndex()) {
    this.debug(`open(${t})`), this.setState(
      {
        isOpen: !0,
        cursor: t
      },
      this.props.onOpen
    );
  }
  onKeyDown(t) {
    switch (this.debug(`onKeyDown(${t.key})`), this.debug("alt: ", t.altKey), this.debug("ctrl: ", t.ctrlKey), this.debug("meta: ", t.metaKey), t.key) {
      case ks:
        this.state.isOpen ? this.setCursor(this.cursorNextIndex()) : this.open(this.initialCursor() ?? this.cursorFirstIndex());
        break;
      case Ts:
        this.state.isOpen ? this.setCursor(this.cursorPrevIndex()) : this.open(this.initialCursor() ?? this.cursorLastIndex());
        break;
      case Is:
      case Jr:
        this.state.isOpen ? this.selectCursor() : this.open(this.initialCursor() ?? this.cursorFirstIndex());
        break;
      case Es:
        this.close();
        break;
      default:
        this.debug(`ignored key ${t.key}`);
        return;
    }
    t.preventDefault();
  }
  menuOptions() {
    return this.props.options;
  }
  initialCursor() {
    return null;
  }
  cursorFirstIndex() {
    return dd(
      this.menuOptions(),
      this.props.validOption
    );
  }
  cursorLastIndex() {
    return hd(
      this.menuOptions(),
      this.props.validOption
    );
  }
  cursorNextIndex() {
    return fd(
      this.menuOptions(),
      this.state.cursor,
      this.props.validOption
    );
  }
  cursorPrevIndex() {
    return gd(
      this.menuOptions(),
      this.state.cursor,
      this.props.validOption
    );
  }
  setCursor(t) {
    this.debug(`setCursor(${t})`), this.setState({ cursor: t });
  }
  selectCursor() {
    this.debug("selectCursor()");
    const { cursor: t } = this.state, n = this.menuOptions();
    if (n && n.length && T(t)) {
      const s = n[t];
      this.debug(`selectCursor() ${t} =>`, s), this.selectOption(s);
    } else
      this.debug("Not selecting: cursor out of range");
  }
  selectOption(t) {
    this.debug("selectOption()", t), this.setState(
      // TODO: this needs to be abstracted out
      // For select it's:
      // {
      //   value,
      //   input: this.inputValue(value)
      //   ...inactiveState
      // },
      this.selectState(t),
      () => this.props.onSelect(t)
    ), this.props.closeOnSelect ? (this.debug("closeOnSelect is set, closing"), this.closeSoon(!0)) : this.debug("closeOnSelect is not set, NOT closing");
  }
  selectState(t) {
    return { selected: t };
  }
  /*
    // do we have a trigger in select/search?  I suppose so...
    triggerRef(ref) {
      this._triggerRef = ref
    }
  
    focusTrigger() {
      if (this._triggerRef) {
        this.debug('focussing trigger')
        this._triggerRef.focus()
      }
      else {
        this.debug('no trigger to focus')
      }
    }
    */
  menuRef(t) {
    this._menuRef = t;
  }
  activeRef(t) {
    sa(this._menuRef, t);
  }
};
I(St, "debug", !1), I(St, "defaultProps", {
  options: [],
  openOnHover: !1,
  closeOnBlur: !0,
  closeDelay: 300,
  onLoad: E,
  onUnload: E,
  onFocus: E,
  onBlur: E,
  onClick: E,
  onOpen: E,
  onClose: E,
  onSelect: E,
  closeOnSelect: !0
}), I(St, "inactiveState", {
  isOpen: !1,
  cursor: void 0,
  selected: void 0
}), I(St, "initialState", {
  ...St.inactiveState
});
let ds = St;
var Ie;
let fh = (Ie = class extends ds {
}, I(Ie, "debug", !1), I(Ie, "debugPrefix", "Dropdown > "), I(Ie, "debugColor", "MediumVioletRed"), I(Ie, "defaultProps", {
  ...Ie.defaultProps,
  options: [],
  displayOption: yd
}), I(Ie, "actions", [
  "onMouseEnter",
  "onMouseLeave",
  "onFocus",
  "onBlur",
  "onClick",
  "onKeyDown",
  "open",
  "close",
  "setCursor",
  "selectCursor",
  "selectOption",
  "triggerRef",
  "menuRef",
  "activeRef"
]), Ie);
const rn = Xe(fh), TC = rn.Use, gh = ({
  triggerClass: e = "trigger",
  triggerRef: t,
  triggerColor: n,
  triggerSize: s,
  button: r,
  icon: o,
  floatingRef: i,
  safeAreaClass: a = "safe-area",
  onMouseEnter: c,
  onMouseLeave: u,
  onKeyDown: d,
  onFocus: h,
  onBlur: g,
  onClick: f,
  ...m
}) => /* @__PURE__ */ w(
  "div",
  {
    className: M(e, n, s, { button: r, icon: o }),
    onClick: f,
    onMouseEnter: c,
    onMouseLeave: u,
    onKeyDown: d,
    onFocus: h,
    onBlur: g,
    tabIndex: 0,
    ref: Yr([t, i]),
    children: [
      /* @__PURE__ */ l(mt, { icon: o, ...kn(m, /^(icon|text)/) }),
      /* @__PURE__ */ l("div", { className: a })
    ]
  }
), ph = rn.Consumer(gh), mh = ({
  option: e,
  active: t,
  activeRef: n,
  selected: s,
  onClick: r,
  onMouseEnter: o,
  optionClass: i = "item no-hover",
  activeClass: a = "active",
  selectedClass: c = "selected",
  disabledClass: u = "disabled",
  displayOption: d
  // ...props
}) => /* @__PURE__ */ l(
  "div",
  {
    className: M(
      i,
      e.className,
      e.indent ? `indent-${e.indent}` : null,
      t ? a : null,
      s ? c : null,
      e.disabled ? u : null
    ),
    onMouseEnter: o,
    onClick: r,
    ref: t ? n : null,
    "aria-disabled": e.disabled,
    children: d(e)
  }
), bh = rn.Consumer(mh), vh = ({
  option: e,
  separatorClass: t = "separator"
}) => /* @__PURE__ */ l("div", { className: M(t, e.className) }), Ch = ({
  option: e,
  optionClass: t = "item no-hover",
  headingClass: n = "heading"
}) => /* @__PURE__ */ l("h4", { className: M(n, t, e.className), children: e.heading }), yh = ({
  options: e = [],
  menuClass: t = "menu border bdr-1",
  menuRef: n,
  floatingRef: s,
  floatingStyle: r,
  cursor: o,
  selected: i,
  selectOption: a,
  setCursor: c,
  onMouseEnter: u,
  onMouseLeave: d,
  Option: h = bh,
  Separator: g = vh,
  Heading: f = Ch
}) => /* @__PURE__ */ l(
  "div",
  {
    className: t,
    ref: Yr([n, s]),
    onMouseEnter: u,
    onMouseLeave: d,
    style: r,
    children: e.map(
      (m, p) => m.separator ? /* @__PURE__ */ l(
        g,
        {
          option: m
        },
        p
      ) : m.heading ? /* @__PURE__ */ l(
        f,
        {
          option: m
        },
        p
      ) : /* @__PURE__ */ l(
        h,
        {
          option: m,
          active: T(o) && e[o] === m,
          selected: i === m,
          onClick: () => a(m),
          onMouseEnter: () => c(p)
        },
        m.id ?? m.value ?? p
      )
    )
  }
), xh = rn.Consumer(yh);
function Ps() {
  return typeof window < "u";
}
function on(e) {
  return ua(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function me(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Je(e) {
  var t;
  return (t = (ua(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function ua(e) {
  return Ps() ? e instanceof Node || e instanceof me(e).Node : !1;
}
function ae(e) {
  return Ps() ? e instanceof Element || e instanceof me(e).Element : !1;
}
function Ve(e) {
  return Ps() ? e instanceof HTMLElement || e instanceof me(e).HTMLElement : !1;
}
function _o(e) {
  return !Ps() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof me(e).ShadowRoot;
}
function En(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: s,
    display: r
  } = Le(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + s + n) && !["inline", "contents"].includes(r);
}
function wh(e) {
  return ["table", "td", "th"].includes(on(e));
}
function As(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function Qr(e) {
  const t = eo(), n = ae(e) ? Le(e) : e;
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((s) => (n.willChange || "").includes(s)) || ["paint", "layout", "strict", "content"].some((s) => (n.contain || "").includes(s));
}
function Sh(e) {
  let t = ut(e);
  for (; Ve(t) && !en(t); ) {
    if (Qr(t))
      return t;
    if (As(t))
      return null;
    t = ut(t);
  }
  return null;
}
function eo() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function en(e) {
  return ["html", "body", "#document"].includes(on(e));
}
function Le(e) {
  return me(e).getComputedStyle(e);
}
function Fs(e) {
  return ae(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function ut(e) {
  if (on(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    _o(e) && e.host || // Fallback.
    Je(e)
  );
  return _o(t) ? t.host : t;
}
function da(e) {
  const t = ut(e);
  return en(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Ve(t) && En(t) ? t : da(t);
}
function xr(e, t, n) {
  var s;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const r = da(e), o = r === ((s = e.ownerDocument) == null ? void 0 : s.body), i = me(r);
  if (o) {
    const a = wr(i);
    return t.concat(i, i.visualViewport || [], En(r) ? r : [], a && n ? xr(a) : []);
  }
  return t.concat(r, xr(r, [], n));
}
function wr(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
const hs = Math.min, Re = Math.max, fs = Math.round, Pe = (e) => ({
  x: e,
  y: e
});
function to(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Vs(e) {
  return e.split("-")[0];
}
function no(e) {
  return e.split("-")[1];
}
function Rh(e) {
  return e === "x" ? "y" : "x";
}
function Lh(e) {
  return e === "y" ? "height" : "width";
}
function Bs(e) {
  return ["top", "bottom"].includes(Vs(e)) ? "y" : "x";
}
function Nh(e) {
  return Rh(Bs(e));
}
function Mh(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Dh(e) {
  return typeof e != "number" ? Mh(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function gs(e) {
  const {
    x: t,
    y: n,
    width: s,
    height: r
  } = e;
  return {
    width: s,
    height: r,
    top: n,
    left: t,
    right: t + s,
    bottom: n + r,
    x: t,
    y: n
  };
}
function Yo(e, t, n) {
  let {
    reference: s,
    floating: r
  } = e;
  const o = Bs(t), i = Nh(t), a = Lh(i), c = Vs(t), u = o === "y", d = s.x + s.width / 2 - r.width / 2, h = s.y + s.height / 2 - r.height / 2, g = s[a] / 2 - r[a] / 2;
  let f;
  switch (c) {
    case "top":
      f = {
        x: d,
        y: s.y - r.height
      };
      break;
    case "bottom":
      f = {
        x: d,
        y: s.y + s.height
      };
      break;
    case "right":
      f = {
        x: s.x + s.width,
        y: h
      };
      break;
    case "left":
      f = {
        x: s.x - r.width,
        y: h
      };
      break;
    default:
      f = {
        x: s.x,
        y: s.y
      };
  }
  switch (no(t)) {
    case "start":
      f[i] -= g * (n && u ? -1 : 1);
      break;
    case "end":
      f[i] += g * (n && u ? -1 : 1);
      break;
  }
  return f;
}
const $h = async (e, t, n) => {
  const {
    placement: s = "bottom",
    strategy: r = "absolute",
    middleware: o = [],
    platform: i
  } = n, a = o.filter(Boolean), c = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let u = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: r
  }), {
    x: d,
    y: h
  } = Yo(u, s, c), g = s, f = {}, m = 0;
  for (let p = 0; p < a.length; p++) {
    const {
      name: b,
      fn: v
    } = a[p], {
      x: y,
      y: C,
      data: x,
      reset: S
    } = await v({
      x: d,
      y: h,
      initialPlacement: s,
      placement: g,
      strategy: r,
      middlewareData: f,
      rects: u,
      platform: i,
      elements: {
        reference: e,
        floating: t
      }
    });
    d = y ?? d, h = C ?? h, f = {
      ...f,
      [b]: {
        ...f[b],
        ...x
      }
    }, S && m <= 50 && (m++, typeof S == "object" && (S.placement && (g = S.placement), S.rects && (u = S.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: t,
      strategy: r
    }) : S.rects), {
      x: d,
      y: h
    } = Yo(u, g, c)), p = -1);
  }
  return {
    x: d,
    y: h,
    placement: g,
    strategy: r,
    middlewareData: f
  };
};
async function Oh(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: s,
    y: r,
    platform: o,
    rects: i,
    elements: a,
    strategy: c
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: h = "floating",
    altBoundary: g = !1,
    padding: f = 0
  } = to(t, e), m = Dh(f), b = a[g ? h === "floating" ? "reference" : "floating" : h], v = gs(await o.getClippingRect({
    element: (n = await (o.isElement == null ? void 0 : o.isElement(b))) == null || n ? b : b.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(a.floating)),
    boundary: u,
    rootBoundary: d,
    strategy: c
  })), y = h === "floating" ? {
    x: s,
    y: r,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, C = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(a.floating)), x = await (o.isElement == null ? void 0 : o.isElement(C)) ? await (o.getScale == null ? void 0 : o.getScale(C)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = gs(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: y,
    offsetParent: C,
    strategy: c
  }) : y);
  return {
    top: (v.top - S.top + m.top) / x.y,
    bottom: (S.bottom - v.bottom + m.bottom) / x.y,
    left: (v.left - S.left + m.left) / x.x,
    right: (S.right - v.right + m.right) / x.x
  };
}
async function Th(e, t) {
  const {
    placement: n,
    platform: s,
    elements: r
  } = e, o = await (s.isRTL == null ? void 0 : s.isRTL(r.floating)), i = Vs(n), a = no(n), c = Bs(n) === "y", u = ["left", "top"].includes(i) ? -1 : 1, d = o && c ? -1 : 1, h = to(t, e);
  let {
    mainAxis: g,
    crossAxis: f,
    alignmentAxis: m
  } = typeof h == "number" ? {
    mainAxis: h,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: h.mainAxis || 0,
    crossAxis: h.crossAxis || 0,
    alignmentAxis: h.alignmentAxis
  };
  return a && typeof m == "number" && (f = a === "end" ? m * -1 : m), c ? {
    x: f * d,
    y: g * u
  } : {
    x: g * u,
    y: f * d
  };
}
const kh = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, s;
      const {
        x: r,
        y: o,
        placement: i,
        middlewareData: a
      } = t, c = await Th(t, e);
      return i === ((n = a.offset) == null ? void 0 : n.placement) && (s = a.arrow) != null && s.alignmentOffset ? {} : {
        x: r + c.x,
        y: o + c.y,
        data: {
          ...c,
          placement: i
        }
      };
    }
  };
}, Ih = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, s;
      const {
        placement: r,
        rects: o,
        platform: i,
        elements: a
      } = t, {
        apply: c = () => {
        },
        ...u
      } = to(e, t), d = await Oh(t, u), h = Vs(r), g = no(r), f = Bs(r) === "y", {
        width: m,
        height: p
      } = o.floating;
      let b, v;
      h === "top" || h === "bottom" ? (b = h, v = g === (await (i.isRTL == null ? void 0 : i.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (v = h, b = g === "end" ? "top" : "bottom");
      const y = p - d.top - d.bottom, C = m - d.left - d.right, x = hs(p - d[b], y), S = hs(m - d[v], C), D = !t.middlewareData.shift;
      let R = x, N = S;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (N = C), (s = t.middlewareData.shift) != null && s.enabled.y && (R = y), D && !g) {
        const O = Re(d.left, 0), $ = Re(d.right, 0), W = Re(d.top, 0), A = Re(d.bottom, 0);
        f ? N = m - 2 * (O !== 0 || $ !== 0 ? O + $ : Re(d.left, d.right)) : R = p - 2 * (W !== 0 || A !== 0 ? W + A : Re(d.top, d.bottom));
      }
      await c({
        ...t,
        availableWidth: N,
        availableHeight: R
      });
      const k = await i.getDimensions(a.floating);
      return m !== k.width || p !== k.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function ha(e) {
  const t = Le(e);
  let n = parseFloat(t.width) || 0, s = parseFloat(t.height) || 0;
  const r = Ve(e), o = r ? e.offsetWidth : n, i = r ? e.offsetHeight : s, a = fs(n) !== o || fs(s) !== i;
  return a && (n = o, s = i), {
    width: n,
    height: s,
    $: a
  };
}
function fa(e) {
  return ae(e) ? e : e.contextElement;
}
function Gt(e) {
  const t = fa(e);
  if (!Ve(t))
    return Pe(1);
  const n = t.getBoundingClientRect(), {
    width: s,
    height: r,
    $: o
  } = ha(t);
  let i = (o ? fs(n.width) : n.width) / s, a = (o ? fs(n.height) : n.height) / r;
  return (!i || !Number.isFinite(i)) && (i = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: i,
    y: a
  };
}
const Eh = /* @__PURE__ */ Pe(0);
function ga(e) {
  const t = me(e);
  return !eo() || !t.visualViewport ? Eh : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Ph(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== me(e) ? !1 : t;
}
function Rn(e, t, n, s) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), o = fa(e);
  let i = Pe(1);
  t && (s ? ae(s) && (i = Gt(s)) : i = Gt(e));
  const a = Ph(o, n, s) ? ga(o) : Pe(0);
  let c = (r.left + a.x) / i.x, u = (r.top + a.y) / i.y, d = r.width / i.x, h = r.height / i.y;
  if (o) {
    const g = me(o), f = s && ae(s) ? me(s) : s;
    let m = g, p = wr(m);
    for (; p && s && f !== m; ) {
      const b = Gt(p), v = p.getBoundingClientRect(), y = Le(p), C = v.left + (p.clientLeft + parseFloat(y.paddingLeft)) * b.x, x = v.top + (p.clientTop + parseFloat(y.paddingTop)) * b.y;
      c *= b.x, u *= b.y, d *= b.x, h *= b.y, c += C, u += x, m = me(p), p = wr(m);
    }
  }
  return gs({
    width: d,
    height: h,
    x: c,
    y: u
  });
}
function so(e, t) {
  const n = Fs(e).scrollLeft;
  return t ? t.left + n : Rn(Je(e)).left + n;
}
function pa(e, t, n) {
  n === void 0 && (n = !1);
  const s = e.getBoundingClientRect(), r = s.left + t.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    so(e, s)
  )), o = s.top + t.scrollTop;
  return {
    x: r,
    y: o
  };
}
function Ah(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: s,
    strategy: r
  } = e;
  const o = r === "fixed", i = Je(s), a = t ? As(t.floating) : !1;
  if (s === i || a && o)
    return n;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = Pe(1);
  const d = Pe(0), h = Ve(s);
  if ((h || !h && !o) && ((on(s) !== "body" || En(i)) && (c = Fs(s)), Ve(s))) {
    const f = Rn(s);
    u = Gt(s), d.x = f.x + s.clientLeft, d.y = f.y + s.clientTop;
  }
  const g = i && !h && !o ? pa(i, c, !0) : Pe(0);
  return {
    width: n.width * u.x,
    height: n.height * u.y,
    x: n.x * u.x - c.scrollLeft * u.x + d.x + g.x,
    y: n.y * u.y - c.scrollTop * u.y + d.y + g.y
  };
}
function Fh(e) {
  return Array.from(e.getClientRects());
}
function Vh(e) {
  const t = Je(e), n = Fs(e), s = e.ownerDocument.body, r = Re(t.scrollWidth, t.clientWidth, s.scrollWidth, s.clientWidth), o = Re(t.scrollHeight, t.clientHeight, s.scrollHeight, s.clientHeight);
  let i = -n.scrollLeft + so(e);
  const a = -n.scrollTop;
  return Le(s).direction === "rtl" && (i += Re(t.clientWidth, s.clientWidth) - r), {
    width: r,
    height: o,
    x: i,
    y: a
  };
}
function Bh(e, t) {
  const n = me(e), s = Je(e), r = n.visualViewport;
  let o = s.clientWidth, i = s.clientHeight, a = 0, c = 0;
  if (r) {
    o = r.width, i = r.height;
    const u = eo();
    (!u || u && t === "fixed") && (a = r.offsetLeft, c = r.offsetTop);
  }
  return {
    width: o,
    height: i,
    x: a,
    y: c
  };
}
function jh(e, t) {
  const n = Rn(e, !0, t === "fixed"), s = n.top + e.clientTop, r = n.left + e.clientLeft, o = Ve(e) ? Gt(e) : Pe(1), i = e.clientWidth * o.x, a = e.clientHeight * o.y, c = r * o.x, u = s * o.y;
  return {
    width: i,
    height: a,
    x: c,
    y: u
  };
}
function Go(e, t, n) {
  let s;
  if (t === "viewport")
    s = Bh(e, n);
  else if (t === "document")
    s = Vh(Je(e));
  else if (ae(t))
    s = jh(t, n);
  else {
    const r = ga(e);
    s = {
      x: t.x - r.x,
      y: t.y - r.y,
      width: t.width,
      height: t.height
    };
  }
  return gs(s);
}
function ma(e, t) {
  const n = ut(e);
  return n === t || !ae(n) || en(n) ? !1 : Le(n).position === "fixed" || ma(n, t);
}
function Wh(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let s = xr(e, [], !1).filter((a) => ae(a) && on(a) !== "body"), r = null;
  const o = Le(e).position === "fixed";
  let i = o ? ut(e) : e;
  for (; ae(i) && !en(i); ) {
    const a = Le(i), c = Qr(i);
    !c && a.position === "fixed" && (r = null), (o ? !c && !r : !c && a.position === "static" && !!r && ["absolute", "fixed"].includes(r.position) || En(i) && !c && ma(e, i)) ? s = s.filter((d) => d !== i) : r = a, i = ut(i);
  }
  return t.set(e, s), s;
}
function Hh(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: s,
    strategy: r
  } = e;
  const i = [...n === "clippingAncestors" ? As(t) ? [] : Wh(t, this._c) : [].concat(n), s], a = i[0], c = i.reduce((u, d) => {
    const h = Go(t, d, r);
    return u.top = Re(h.top, u.top), u.right = hs(h.right, u.right), u.bottom = hs(h.bottom, u.bottom), u.left = Re(h.left, u.left), u;
  }, Go(t, a, r));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function zh(e) {
  const {
    width: t,
    height: n
  } = ha(e);
  return {
    width: t,
    height: n
  };
}
function Uh(e, t, n) {
  const s = Ve(t), r = Je(t), o = n === "fixed", i = Rn(e, !0, o, t);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = Pe(0);
  if (s || !s && !o)
    if ((on(t) !== "body" || En(r)) && (a = Fs(t)), s) {
      const g = Rn(t, !0, o, t);
      c.x = g.x + t.clientLeft, c.y = g.y + t.clientTop;
    } else
      r && (c.x = so(r));
  const u = r && !s && !o ? pa(r, a) : Pe(0), d = i.left + a.scrollLeft - c.x - u.x, h = i.top + a.scrollTop - c.y - u.y;
  return {
    x: d,
    y: h,
    width: i.width,
    height: i.height
  };
}
function or(e) {
  return Le(e).position === "static";
}
function Zo(e, t) {
  if (!Ve(e) || Le(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return Je(e) === n && (n = n.ownerDocument.body), n;
}
function ba(e, t) {
  const n = me(e);
  if (As(e))
    return n;
  if (!Ve(e)) {
    let r = ut(e);
    for (; r && !en(r); ) {
      if (ae(r) && !or(r))
        return r;
      r = ut(r);
    }
    return n;
  }
  let s = Zo(e, t);
  for (; s && wh(s) && or(s); )
    s = Zo(s, t);
  return s && en(s) && or(s) && !Qr(s) ? n : s || Sh(e) || n;
}
const Kh = async function(e) {
  const t = this.getOffsetParent || ba, n = this.getDimensions, s = await n(e.floating);
  return {
    reference: Uh(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: s.width,
      height: s.height
    }
  };
};
function qh(e) {
  return Le(e).direction === "rtl";
}
const Xh = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Ah,
  getDocumentElement: Je,
  getClippingRect: Hh,
  getOffsetParent: ba,
  getElementRects: Kh,
  getClientRects: Fh,
  getDimensions: zh,
  getScale: Gt,
  isElement: ae,
  isRTL: qh
}, _h = kh, Yh = Ih, Gh = (e, t, n) => {
  const s = /* @__PURE__ */ new Map(), r = {
    platform: Xh,
    ...n
  }, o = {
    ...r.platform,
    _c: s
  };
  return $h(e, t, {
    ...r,
    platform: o
  });
};
var os = typeof document < "u" ? Or : B;
function ps(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, s, r;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length)
        return !1;
      for (s = n; s-- !== 0; )
        if (!ps(e[s], t[s]))
          return !1;
      return !0;
    }
    if (r = Object.keys(e), n = r.length, n !== Object.keys(t).length)
      return !1;
    for (s = n; s-- !== 0; )
      if (!{}.hasOwnProperty.call(t, r[s]))
        return !1;
    for (s = n; s-- !== 0; ) {
      const o = r[s];
      if (!(o === "_owner" && e.$$typeof) && !ps(e[o], t[o]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function va(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Jo(e, t) {
  const n = va(e);
  return Math.round(t * n) / n;
}
function ir(e) {
  const t = P.useRef(e);
  return os(() => {
    t.current = e;
  }), t;
}
function Zh(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: s = [],
    platform: r,
    elements: {
      reference: o,
      floating: i
    } = {},
    transform: a = !0,
    whileElementsMounted: c,
    open: u
  } = e, [d, h] = P.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [g, f] = P.useState(s);
  ps(g, s) || f(s);
  const [m, p] = P.useState(null), [b, v] = P.useState(null), y = P.useCallback((Y) => {
    Y !== D.current && (D.current = Y, p(Y));
  }, []), C = P.useCallback((Y) => {
    Y !== R.current && (R.current = Y, v(Y));
  }, []), x = o || m, S = i || b, D = P.useRef(null), R = P.useRef(null), N = P.useRef(d), k = c != null, O = ir(c), $ = ir(r), W = ir(u), A = P.useCallback(() => {
    if (!D.current || !R.current)
      return;
    const Y = {
      placement: t,
      strategy: n,
      middleware: g
    };
    $.current && (Y.platform = $.current), Gh(D.current, R.current, Y).then((ne) => {
      const ue = {
        ...ne,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: W.current !== !1
      };
      z.current && !ps(N.current, ue) && (N.current = ue, cc.flushSync(() => {
        h(ue);
      }));
    });
  }, [g, t, n, $, W]);
  os(() => {
    u === !1 && N.current.isPositioned && (N.current.isPositioned = !1, h((Y) => ({
      ...Y,
      isPositioned: !1
    })));
  }, [u]);
  const z = P.useRef(!1);
  os(() => (z.current = !0, () => {
    z.current = !1;
  }), []), os(() => {
    if (x && (D.current = x), S && (R.current = S), x && S) {
      if (O.current)
        return O.current(x, S, A);
      A();
    }
  }, [x, S, A, O, k]);
  const Ce = P.useMemo(() => ({
    reference: D,
    floating: R,
    setReference: y,
    setFloating: C
  }), [y, C]), te = P.useMemo(() => ({
    reference: x,
    floating: S
  }), [x, S]), Z = P.useMemo(() => {
    const Y = {
      position: n,
      left: 0,
      top: 0
    };
    if (!te.floating)
      return Y;
    const ne = Jo(te.floating, d.x), ue = Jo(te.floating, d.y);
    return a ? {
      ...Y,
      transform: "translate(" + ne + "px, " + ue + "px)",
      ...va(te.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: ne,
      top: ue
    };
  }, [n, a, te.floating, d.x, d.y]);
  return P.useMemo(() => ({
    ...d,
    update: A,
    refs: Ce,
    elements: te,
    floatingStyles: Z
  }), [d, A, Ce, te, Z]);
}
const Jh = (e, t) => ({
  ..._h(e),
  options: [e, t]
}), Qh = (e, t) => ({
  ...Yh(e),
  options: [e, t]
}), Ca = {
  ...P
}, ef = Ca.useInsertionEffect, tf = ef || ((e) => e());
function nf(e) {
  const t = P.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return tf(() => {
    t.current = e;
  }), P.useCallback(function() {
    for (var n = arguments.length, s = new Array(n), r = 0; r < n; r++)
      s[r] = arguments[r];
    return t.current == null ? void 0 : t.current(...s);
  }, []);
}
var Sr = typeof document < "u" ? Or : B;
let Qo = !1, sf = 0;
const ei = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + sf++
);
function rf() {
  const [e, t] = P.useState(() => Qo ? ei() : void 0);
  return Sr(() => {
    e == null && t(ei());
  }, []), P.useEffect(() => {
    Qo = !0;
  }, []), e;
}
const of = Ca.useId, af = of || rf;
let Rr;
process.env.NODE_ENV !== "production" && (Rr = /* @__PURE__ */ new Set());
function lf() {
  for (var e, t = arguments.length, n = new Array(t), s = 0; s < t; s++)
    n[s] = arguments[s];
  const r = "Floating UI: " + n.join(" ");
  if (!((e = Rr) != null && e.has(r))) {
    var o;
    (o = Rr) == null || o.add(r), console.error(r);
  }
}
function cf() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(t, n) {
      var s;
      (s = e.get(t)) == null || s.forEach((r) => r(n));
    },
    on(t, n) {
      e.set(t, [...e.get(t) || [], n]);
    },
    off(t, n) {
      var s;
      e.set(t, ((s = e.get(t)) == null ? void 0 : s.filter((r) => r !== n)) || []);
    }
  };
}
const uf = /* @__PURE__ */ P.createContext(null), df = /* @__PURE__ */ P.createContext(null), hf = () => {
  var e;
  return ((e = P.useContext(uf)) == null ? void 0 : e.id) || null;
}, ff = () => P.useContext(df);
function gf(e) {
  const {
    open: t = !1,
    onOpenChange: n,
    elements: s
  } = e, r = af(), o = P.useRef({}), [i] = P.useState(() => cf()), a = hf() != null;
  if (process.env.NODE_ENV !== "production") {
    const f = s.reference;
    f && !ae(f) && lf("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [c, u] = P.useState(s.reference), d = nf((f, m, p) => {
    o.current.openEvent = f ? m : void 0, i.emit("openchange", {
      open: f,
      event: m,
      reason: p,
      nested: a
    }), n == null || n(f, m, p);
  }), h = P.useMemo(() => ({
    setPositionReference: u
  }), []), g = P.useMemo(() => ({
    reference: c || s.reference || null,
    floating: s.floating || null,
    domReference: s.reference
  }), [c, s.reference, s.floating]);
  return P.useMemo(() => ({
    dataRef: o,
    open: t,
    onOpenChange: d,
    elements: g,
    events: i,
    floatingId: r,
    refs: h
  }), [t, d, g, i, r, h]);
}
function pf(e) {
  e === void 0 && (e = {});
  const {
    nodeId: t
  } = e, n = gf({
    ...e,
    elements: {
      reference: null,
      floating: null,
      ...e.elements
    }
  }), s = e.rootContext || n, r = s.elements, [o, i] = P.useState(null), [a, c] = P.useState(null), d = (r == null ? void 0 : r.domReference) || o, h = P.useRef(null), g = ff();
  Sr(() => {
    d && (h.current = d);
  }, [d]);
  const f = Zh({
    ...e,
    elements: {
      ...r,
      ...a && {
        reference: a
      }
    }
  }), m = P.useCallback((C) => {
    const x = ae(C) ? {
      getBoundingClientRect: () => C.getBoundingClientRect(),
      contextElement: C
    } : C;
    c(x), f.refs.setReference(x);
  }, [f.refs]), p = P.useCallback((C) => {
    (ae(C) || C === null) && (h.current = C, i(C)), (ae(f.refs.reference.current) || f.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    C !== null && !ae(C)) && f.refs.setReference(C);
  }, [f.refs]), b = P.useMemo(() => ({
    ...f.refs,
    setReference: p,
    setPositionReference: m,
    domReference: h
  }), [f.refs, p, m]), v = P.useMemo(() => ({
    ...f.elements,
    domReference: d
  }), [f.elements, d]), y = P.useMemo(() => ({
    ...f,
    ...s,
    refs: b,
    elements: v,
    nodeId: t
  }), [f, b, v, t, s]);
  return Sr(() => {
    s.dataRef.current.floatingContext = y;
    const C = g == null ? void 0 : g.nodesRef.current.find((x) => x.id === t);
    C && (C.context = y);
  }), P.useMemo(() => ({
    ...f,
    context: y,
    refs: b,
    elements: v
  }), [f, b, v, y]);
}
const ya = (e) => Qh({
  apply({ rects: t, elements: n }) {
    Object.assign(
      n.floating.style,
      e(t.reference)
    );
  }
}), mf = ya(
  (e) => ({ width: `${e.width}px` })
), bf = ya(
  (e) => ({ height: `${e.height}px` })
), vf = ({
  offset: e = 0,
  matchWidth: t,
  matchHeight: n
} = {}) => {
  const s = [
    Jh(parseInt(e))
  ];
  return t && s.push(mf), n && s.push(bf), s;
}, Cf = ({
  placement: e,
  defaultPlacement: t,
  right: n,
  vertical: s = "bottom"
} = {}) => e || t || (n ? `${s}-end` : `${s}-start`), xa = (e) => pf({
  middleware: vf(e),
  placement: Cf(e)
}), yf = ({
  className: e = "dropdown",
  openClass: t = "open",
  closedClass: n = "closed",
  isOpen: s,
  size: r,
  wide: o,
  offset: i = 8,
  placement: a,
  right: c,
  Trigger: u = ph,
  Options: d = xh
}) => {
  const { refs: h, floatingStyles: g } = xa({
    offset: i,
    placement: a,
    right: c
  });
  return /* @__PURE__ */ w(
    "div",
    {
      className: M(
        e,
        r,
        s ? t : n,
        { right: c, wide: o }
      ),
      children: [
        /* @__PURE__ */ l(u, { floatingRef: h.setReference }),
        s && /* @__PURE__ */ l(
          d,
          {
            floatingRef: h.setFloating,
            floatingStyle: g
          }
        )
      ]
    }
  );
}, xf = rn.Consumer(yf), wf = ({
  Content: e = xf,
  ...t
}) => /* @__PURE__ */ l(rn.Provider, { ...t, children: /* @__PURE__ */ l(e, {}) }), Sf = L(wf, "DropdownMenu"), Rf = ({
  setPageSize: e,
  pageSizes: t = [10, 25, 50, 100, 250, 500, 1e3],
  pageSizeText: n = (s) => `${s} per page`
}) => /* @__PURE__ */ l("div", { className: "pagesize", children: /* @__PURE__ */ l(
  Sf,
  {
    right: !0,
    iconRight: "page",
    text: "Page Size",
    size: "small",
    triggerClass: "trigger pad-v-none",
    options: t.map(
      (s) => ({ n: s, text: n(s) })
    ),
    onSelect: (s) => e(s.n)
  }
) }), Lf = _.Consumer(Rf);
class yn extends ca {
}
I(yn, "debug", !1), I(yn, "debugPrefix", "Dropdown > "), I(yn, "debugColor", "MediumVioletRed"), I(yn, "actions", [
  "onMouseEnter",
  "onMouseLeave",
  "onFocus",
  "onBlur",
  "onClick",
  "onKeyDown",
  "open",
  "close",
  "triggerRef"
]);
const an = Xe(yn), kC = an.Use, Nf = ({
  triggerClass: e = "trigger",
  triggerRef: t,
  triggerColor: n,
  triggerSize: s,
  button: r,
  icon: o,
  floatingRef: i,
  safeAreaClass: a = "safe-area",
  onMouseEnter: c,
  onMouseLeave: u,
  onKeyDown: d,
  onFocus: h,
  onBlur: g,
  onClick: f,
  ...m
}) => /* @__PURE__ */ w(
  "div",
  {
    className: M(e, n, s, { button: r, icon: o }),
    onClick: f,
    onMouseEnter: c,
    onMouseLeave: u,
    onKeyDown: d,
    onFocus: h,
    onBlur: g,
    tabIndex: 0,
    ref: Yr([t, i]),
    children: [
      /* @__PURE__ */ l(mt, { icon: o, ...kn(m, /^(icon|text)/) }),
      /* @__PURE__ */ l("div", { className: a })
    ]
  }
), Mf = an.Consumer(Nf), Df = ({
  bodyClass: e = "body border bdr-1",
  onMouseEnter: t,
  onMouseLeave: n,
  floatingRef: s,
  floatingStyle: r,
  content: o
}) => /* @__PURE__ */ l(
  "div",
  {
    className: e,
    onMouseEnter: t,
    onMouseLeave: n,
    ref: s,
    style: r,
    children: o || "No content defined"
  }
), $f = an.Consumer(Df), Of = ({
  className: e = "dropdown",
  openClass: t = "open",
  closedClass: n = "closed",
  placement: s,
  offset: r = 8,
  isOpen: o,
  right: i,
  size: a,
  wide: c,
  Trigger: u = Mf,
  Body: d = $f
}) => {
  const { refs: h, floatingStyles: g } = xa({
    offset: r,
    placement: s,
    right: i
  });
  return /* @__PURE__ */ w(
    "div",
    {
      className: M(
        e,
        a,
        o ? t : n,
        { right: i, wide: c }
      ),
      children: [
        /* @__PURE__ */ l(u, { floatingRef: h.setReference }),
        o && /* @__PURE__ */ l(
          d,
          {
            floatingRef: h.setFloating,
            floatingStyle: g
          }
        )
      ]
    }
  );
}, Tf = an.Consumer(Of), kf = ({
  Content: e = Tf,
  content: t,
  children: n,
  ...s
}) => /* @__PURE__ */ l(an.Provider, { content: t || n, ...s, children: /* @__PURE__ */ l(e, {}) }), If = L(kf, "Dropdown"), Ef = ({
  item: e,
  setNodeRef: t,
  style: n,
  listeners: s,
  toggleVisibleColumn: r,
  isVisible: o,
  ...i
}) => /* @__PURE__ */ w(
  "div",
  {
    ref: t,
    style: n,
    className: `sortable item flex middle outline pad-v-none pad-h-1 border mar-b-2 ${e.moved ? "moved" : ""}`,
    ...i,
    children: [
      /* @__PURE__ */ l(
        oa,
        {
          className: "fluid flex middle no-focus",
          checked: o[e.id] || !1,
          onChange: () => r(e.id),
          text: e.heading
        },
        e.id
      ),
      /* @__PURE__ */ l(
        "div",
        {
          ...s,
          className: "pad-h-2",
          children: /* @__PURE__ */ l(X, { name: "drag", className: "drag-handle" })
        }
      )
    ]
  }
), Pf = ({
  close: e
}) => /* @__PURE__ */ l(
  Se,
  {
    className: "wide",
    size: "smaller",
    color: "green",
    text: "OK",
    onClick: e
  }
), Af = an.Consumer(Pf);
function Ff() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return H(
    () => (s) => {
      t.forEach((r) => r(s));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  );
}
const js = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
function ln(e) {
  const t = Object.prototype.toString.call(e);
  return t === "[object Window]" || // In Electron context the Window object serializes to [object global]
  t === "[object global]";
}
function ro(e) {
  return "nodeType" in e;
}
function ce(e) {
  var t, n;
  return e ? ln(e) ? e : ro(e) && (t = (n = e.ownerDocument) == null ? void 0 : n.defaultView) != null ? t : window : window;
}
function oo(e) {
  const {
    Document: t
  } = ce(e);
  return e instanceof t;
}
function Pn(e) {
  return ln(e) ? !1 : e instanceof ce(e).HTMLElement;
}
function wa(e) {
  return e instanceof ce(e).SVGElement;
}
function cn(e) {
  return e ? ln(e) ? e.document : ro(e) ? oo(e) ? e : Pn(e) || wa(e) ? e.ownerDocument : document : document : document;
}
const Ne = js ? Or : B;
function Ws(e) {
  const t = U(e);
  return Ne(() => {
    t.current = e;
  }), le(function() {
    for (var n = arguments.length, s = new Array(n), r = 0; r < n; r++)
      s[r] = arguments[r];
    return t.current == null ? void 0 : t.current(...s);
  }, []);
}
function Vf() {
  const e = U(null), t = le((s, r) => {
    e.current = setInterval(s, r);
  }, []), n = le(() => {
    e.current !== null && (clearInterval(e.current), e.current = null);
  }, []);
  return [t, n];
}
function Ln(e, t) {
  t === void 0 && (t = [e]);
  const n = U(e);
  return Ne(() => {
    n.current !== e && (n.current = e);
  }, t), n;
}
function An(e, t) {
  const n = U();
  return H(
    () => {
      const s = e(n.current);
      return n.current = s, s;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...t]
  );
}
function ms(e) {
  const t = Ws(e), n = U(null), s = le(
    (r) => {
      r !== n.current && (t == null || t(r, n.current)), n.current = r;
    },
    //eslint-disable-next-line
    []
  );
  return [n, s];
}
function bs(e) {
  const t = U();
  return B(() => {
    t.current = e;
  }, [e]), t.current;
}
let ar = {};
function Fn(e, t) {
  return H(() => {
    if (t)
      return t;
    const n = ar[e] == null ? 0 : ar[e] + 1;
    return ar[e] = n, e + "-" + n;
  }, [e, t]);
}
function Sa(e) {
  return function(t) {
    for (var n = arguments.length, s = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++)
      s[r - 1] = arguments[r];
    return s.reduce((o, i) => {
      const a = Object.entries(i);
      for (const [c, u] of a) {
        const d = o[c];
        d != null && (o[c] = d + e * u);
      }
      return o;
    }, {
      ...t
    });
  };
}
const Zt = /* @__PURE__ */ Sa(1), Nn = /* @__PURE__ */ Sa(-1);
function Bf(e) {
  return "clientX" in e && "clientY" in e;
}
function Hs(e) {
  if (!e)
    return !1;
  const {
    KeyboardEvent: t
  } = ce(e.target);
  return t && e instanceof t;
}
function jf(e) {
  if (!e)
    return !1;
  const {
    TouchEvent: t
  } = ce(e.target);
  return t && e instanceof t;
}
function vs(e) {
  if (jf(e)) {
    if (e.touches && e.touches.length) {
      const {
        clientX: t,
        clientY: n
      } = e.touches[0];
      return {
        x: t,
        y: n
      };
    } else if (e.changedTouches && e.changedTouches.length) {
      const {
        clientX: t,
        clientY: n
      } = e.changedTouches[0];
      return {
        x: t,
        y: n
      };
    }
  }
  return Bf(e) ? {
    x: e.clientX,
    y: e.clientY
  } : null;
}
const dt = /* @__PURE__ */ Object.freeze({
  Translate: {
    toString(e) {
      if (!e)
        return;
      const {
        x: t,
        y: n
      } = e;
      return "translate3d(" + (t ? Math.round(t) : 0) + "px, " + (n ? Math.round(n) : 0) + "px, 0)";
    }
  },
  Scale: {
    toString(e) {
      if (!e)
        return;
      const {
        scaleX: t,
        scaleY: n
      } = e;
      return "scaleX(" + t + ") scaleY(" + n + ")";
    }
  },
  Transform: {
    toString(e) {
      if (e)
        return [dt.Translate.toString(e), dt.Scale.toString(e)].join(" ");
    }
  },
  Transition: {
    toString(e) {
      let {
        property: t,
        duration: n,
        easing: s
      } = e;
      return t + " " + n + "ms " + s;
    }
  }
}), ti = "a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]";
function Wf(e) {
  return e.matches(ti) ? e : e.querySelector(ti);
}
const Hf = {
  display: "none"
};
function zf(e) {
  let {
    id: t,
    value: n
  } = e;
  return F.createElement("div", {
    id: t,
    style: Hf
  }, n);
}
function Uf(e) {
  let {
    id: t,
    announcement: n,
    ariaLiveType: s = "assertive"
  } = e;
  const r = {
    position: "fixed",
    top: 0,
    left: 0,
    width: 1,
    height: 1,
    margin: -1,
    border: 0,
    padding: 0,
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    clipPath: "inset(100%)",
    whiteSpace: "nowrap"
  };
  return F.createElement("div", {
    id: t,
    style: r,
    role: "status",
    "aria-live": s,
    "aria-atomic": !0
  }, n);
}
function Kf() {
  const [e, t] = j("");
  return {
    announce: le((s) => {
      s != null && t(s);
    }, []),
    announcement: e
  };
}
const Ra = /* @__PURE__ */ Mt(null);
function qf(e) {
  const t = lt(Ra);
  B(() => {
    if (!t)
      throw new Error("useDndMonitor must be used within a children of <DndContext>");
    return t(e);
  }, [e, t]);
}
function Xf() {
  const [e] = j(() => /* @__PURE__ */ new Set()), t = le((s) => (e.add(s), () => e.delete(s)), [e]);
  return [le((s) => {
    let {
      type: r,
      event: o
    } = s;
    e.forEach((i) => {
      var a;
      return (a = i[r]) == null ? void 0 : a.call(i, o);
    });
  }, [e]), t];
}
const _f = {
  draggable: `
    To pick up a draggable item, press the space bar.
    While dragging, use the arrow keys to move the item.
    Press space again to drop the item in its new position, or press escape to cancel.
  `
}, Yf = {
  onDragStart(e) {
    let {
      active: t
    } = e;
    return "Picked up draggable item " + t.id + ".";
  },
  onDragOver(e) {
    let {
      active: t,
      over: n
    } = e;
    return n ? "Draggable item " + t.id + " was moved over droppable area " + n.id + "." : "Draggable item " + t.id + " is no longer over a droppable area.";
  },
  onDragEnd(e) {
    let {
      active: t,
      over: n
    } = e;
    return n ? "Draggable item " + t.id + " was dropped over droppable area " + n.id : "Draggable item " + t.id + " was dropped.";
  },
  onDragCancel(e) {
    let {
      active: t
    } = e;
    return "Dragging was cancelled. Draggable item " + t.id + " was dropped.";
  }
};
function Gf(e) {
  let {
    announcements: t = Yf,
    container: n,
    hiddenTextDescribedById: s,
    screenReaderInstructions: r = _f
  } = e;
  const {
    announce: o,
    announcement: i
  } = Kf(), a = Fn("DndLiveRegion"), [c, u] = j(!1);
  if (B(() => {
    u(!0);
  }, []), qf(H(() => ({
    onDragStart(h) {
      let {
        active: g
      } = h;
      o(t.onDragStart({
        active: g
      }));
    },
    onDragMove(h) {
      let {
        active: g,
        over: f
      } = h;
      t.onDragMove && o(t.onDragMove({
        active: g,
        over: f
      }));
    },
    onDragOver(h) {
      let {
        active: g,
        over: f
      } = h;
      o(t.onDragOver({
        active: g,
        over: f
      }));
    },
    onDragEnd(h) {
      let {
        active: g,
        over: f
      } = h;
      o(t.onDragEnd({
        active: g,
        over: f
      }));
    },
    onDragCancel(h) {
      let {
        active: g,
        over: f
      } = h;
      o(t.onDragCancel({
        active: g,
        over: f
      }));
    }
  }), [o, t])), !c)
    return null;
  const d = F.createElement(F.Fragment, null, F.createElement(zf, {
    id: s,
    value: r.draggable
  }), F.createElement(Uf, {
    id: a,
    announcement: i
  }));
  return n ? uc(d, n) : d;
}
var J;
(function(e) {
  e.DragStart = "dragStart", e.DragMove = "dragMove", e.DragEnd = "dragEnd", e.DragCancel = "dragCancel", e.DragOver = "dragOver", e.RegisterDroppable = "registerDroppable", e.SetDroppableDisabled = "setDroppableDisabled", e.UnregisterDroppable = "unregisterDroppable";
})(J || (J = {}));
function Cs() {
}
function ni(e, t) {
  return H(
    () => ({
      sensor: e,
      options: t ?? {}
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e, t]
  );
}
function Zf() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return H(
    () => [...t].filter((s) => s != null),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...t]
  );
}
const Me = /* @__PURE__ */ Object.freeze({
  x: 0,
  y: 0
});
function La(e, t) {
  return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
}
function Jf(e, t) {
  const n = vs(e);
  if (!n)
    return "0 0";
  const s = {
    x: (n.x - t.left) / t.width * 100,
    y: (n.y - t.top) / t.height * 100
  };
  return s.x + "% " + s.y + "%";
}
function Na(e, t) {
  let {
    data: {
      value: n
    }
  } = e, {
    data: {
      value: s
    }
  } = t;
  return n - s;
}
function Qf(e, t) {
  let {
    data: {
      value: n
    }
  } = e, {
    data: {
      value: s
    }
  } = t;
  return s - n;
}
function si(e) {
  let {
    left: t,
    top: n,
    height: s,
    width: r
  } = e;
  return [{
    x: t,
    y: n
  }, {
    x: t + r,
    y: n
  }, {
    x: t,
    y: n + s
  }, {
    x: t + r,
    y: n + s
  }];
}
function Ma(e, t) {
  if (!e || e.length === 0)
    return null;
  const [n] = e;
  return t ? n[t] : n;
}
function ri(e, t, n) {
  return t === void 0 && (t = e.left), n === void 0 && (n = e.top), {
    x: t + e.width * 0.5,
    y: n + e.height * 0.5
  };
}
const eg = (e) => {
  let {
    collisionRect: t,
    droppableRects: n,
    droppableContainers: s
  } = e;
  const r = ri(t, t.left, t.top), o = [];
  for (const i of s) {
    const {
      id: a
    } = i, c = n.get(a);
    if (c) {
      const u = La(ri(c), r);
      o.push({
        id: a,
        data: {
          droppableContainer: i,
          value: u
        }
      });
    }
  }
  return o.sort(Na);
}, tg = (e) => {
  let {
    collisionRect: t,
    droppableRects: n,
    droppableContainers: s
  } = e;
  const r = si(t), o = [];
  for (const i of s) {
    const {
      id: a
    } = i, c = n.get(a);
    if (c) {
      const u = si(c), d = r.reduce((g, f, m) => g + La(u[m], f), 0), h = Number((d / 4).toFixed(4));
      o.push({
        id: a,
        data: {
          droppableContainer: i,
          value: h
        }
      });
    }
  }
  return o.sort(Na);
};
function ng(e, t) {
  const n = Math.max(t.top, e.top), s = Math.max(t.left, e.left), r = Math.min(t.left + t.width, e.left + e.width), o = Math.min(t.top + t.height, e.top + e.height), i = r - s, a = o - n;
  if (s < r && n < o) {
    const c = t.width * t.height, u = e.width * e.height, d = i * a, h = d / (c + u - d);
    return Number(h.toFixed(4));
  }
  return 0;
}
const sg = (e) => {
  let {
    collisionRect: t,
    droppableRects: n,
    droppableContainers: s
  } = e;
  const r = [];
  for (const o of s) {
    const {
      id: i
    } = o, a = n.get(i);
    if (a) {
      const c = ng(a, t);
      c > 0 && r.push({
        id: i,
        data: {
          droppableContainer: o,
          value: c
        }
      });
    }
  }
  return r.sort(Qf);
};
function rg(e, t, n) {
  return {
    ...e,
    scaleX: t && n ? t.width / n.width : 1,
    scaleY: t && n ? t.height / n.height : 1
  };
}
function Da(e, t) {
  return e && t ? {
    x: e.left - t.left,
    y: e.top - t.top
  } : Me;
}
function og(e) {
  return function(n) {
    for (var s = arguments.length, r = new Array(s > 1 ? s - 1 : 0), o = 1; o < s; o++)
      r[o - 1] = arguments[o];
    return r.reduce((i, a) => ({
      ...i,
      top: i.top + e * a.y,
      bottom: i.bottom + e * a.y,
      left: i.left + e * a.x,
      right: i.right + e * a.x
    }), {
      ...n
    });
  };
}
const ig = /* @__PURE__ */ og(1);
function $a(e) {
  if (e.startsWith("matrix3d(")) {
    const t = e.slice(9, -1).split(/, /);
    return {
      x: +t[12],
      y: +t[13],
      scaleX: +t[0],
      scaleY: +t[5]
    };
  } else if (e.startsWith("matrix(")) {
    const t = e.slice(7, -1).split(/, /);
    return {
      x: +t[4],
      y: +t[5],
      scaleX: +t[0],
      scaleY: +t[3]
    };
  }
  return null;
}
function ag(e, t, n) {
  const s = $a(t);
  if (!s)
    return e;
  const {
    scaleX: r,
    scaleY: o,
    x: i,
    y: a
  } = s, c = e.left - i - (1 - r) * parseFloat(n), u = e.top - a - (1 - o) * parseFloat(n.slice(n.indexOf(" ") + 1)), d = r ? e.width / r : e.width, h = o ? e.height / o : e.height;
  return {
    width: d,
    height: h,
    top: u,
    right: c + d,
    bottom: u + h,
    left: c
  };
}
const lg = {
  ignoreTransform: !1
};
function un(e, t) {
  t === void 0 && (t = lg);
  let n = e.getBoundingClientRect();
  if (t.ignoreTransform) {
    const {
      transform: u,
      transformOrigin: d
    } = ce(e).getComputedStyle(e);
    u && (n = ag(n, u, d));
  }
  const {
    top: s,
    left: r,
    width: o,
    height: i,
    bottom: a,
    right: c
  } = n;
  return {
    top: s,
    left: r,
    width: o,
    height: i,
    bottom: a,
    right: c
  };
}
function oi(e) {
  return un(e, {
    ignoreTransform: !0
  });
}
function cg(e) {
  const t = e.innerWidth, n = e.innerHeight;
  return {
    top: 0,
    left: 0,
    right: t,
    bottom: n,
    width: t,
    height: n
  };
}
function ug(e, t) {
  return t === void 0 && (t = ce(e).getComputedStyle(e)), t.position === "fixed";
}
function dg(e, t) {
  t === void 0 && (t = ce(e).getComputedStyle(e));
  const n = /(auto|scroll|overlay)/;
  return ["overflow", "overflowX", "overflowY"].some((r) => {
    const o = t[r];
    return typeof o == "string" ? n.test(o) : !1;
  });
}
function zs(e, t) {
  const n = [];
  function s(r) {
    if (t != null && n.length >= t || !r)
      return n;
    if (oo(r) && r.scrollingElement != null && !n.includes(r.scrollingElement))
      return n.push(r.scrollingElement), n;
    if (!Pn(r) || wa(r) || n.includes(r))
      return n;
    const o = ce(e).getComputedStyle(r);
    return r !== e && dg(r, o) && n.push(r), ug(r, o) ? n : s(r.parentNode);
  }
  return e ? s(e) : n;
}
function Oa(e) {
  const [t] = zs(e, 1);
  return t ?? null;
}
function lr(e) {
  return !js || !e ? null : ln(e) ? e : ro(e) ? oo(e) || e === cn(e).scrollingElement ? window : Pn(e) ? e : null : null;
}
function Ta(e) {
  return ln(e) ? e.scrollX : e.scrollLeft;
}
function ka(e) {
  return ln(e) ? e.scrollY : e.scrollTop;
}
function Lr(e) {
  return {
    x: Ta(e),
    y: ka(e)
  };
}
var ee;
(function(e) {
  e[e.Forward = 1] = "Forward", e[e.Backward = -1] = "Backward";
})(ee || (ee = {}));
function Ia(e) {
  return !js || !e ? !1 : e === document.scrollingElement;
}
function Ea(e) {
  const t = {
    x: 0,
    y: 0
  }, n = Ia(e) ? {
    height: window.innerHeight,
    width: window.innerWidth
  } : {
    height: e.clientHeight,
    width: e.clientWidth
  }, s = {
    x: e.scrollWidth - n.width,
    y: e.scrollHeight - n.height
  }, r = e.scrollTop <= t.y, o = e.scrollLeft <= t.x, i = e.scrollTop >= s.y, a = e.scrollLeft >= s.x;
  return {
    isTop: r,
    isLeft: o,
    isBottom: i,
    isRight: a,
    maxScroll: s,
    minScroll: t
  };
}
const hg = {
  x: 0.2,
  y: 0.2
};
function fg(e, t, n, s, r) {
  let {
    top: o,
    left: i,
    right: a,
    bottom: c
  } = n;
  s === void 0 && (s = 10), r === void 0 && (r = hg);
  const {
    isTop: u,
    isBottom: d,
    isLeft: h,
    isRight: g
  } = Ea(e), f = {
    x: 0,
    y: 0
  }, m = {
    x: 0,
    y: 0
  }, p = {
    height: t.height * r.y,
    width: t.width * r.x
  };
  return !u && o <= t.top + p.height ? (f.y = ee.Backward, m.y = s * Math.abs((t.top + p.height - o) / p.height)) : !d && c >= t.bottom - p.height && (f.y = ee.Forward, m.y = s * Math.abs((t.bottom - p.height - c) / p.height)), !g && a >= t.right - p.width ? (f.x = ee.Forward, m.x = s * Math.abs((t.right - p.width - a) / p.width)) : !h && i <= t.left + p.width && (f.x = ee.Backward, m.x = s * Math.abs((t.left + p.width - i) / p.width)), {
    direction: f,
    speed: m
  };
}
function gg(e) {
  if (e === document.scrollingElement) {
    const {
      innerWidth: o,
      innerHeight: i
    } = window;
    return {
      top: 0,
      left: 0,
      right: o,
      bottom: i,
      width: o,
      height: i
    };
  }
  const {
    top: t,
    left: n,
    right: s,
    bottom: r
  } = e.getBoundingClientRect();
  return {
    top: t,
    left: n,
    right: s,
    bottom: r,
    width: e.clientWidth,
    height: e.clientHeight
  };
}
function Pa(e) {
  return e.reduce((t, n) => Zt(t, Lr(n)), Me);
}
function pg(e) {
  return e.reduce((t, n) => t + Ta(n), 0);
}
function mg(e) {
  return e.reduce((t, n) => t + ka(n), 0);
}
function Aa(e, t) {
  if (t === void 0 && (t = un), !e)
    return;
  const {
    top: n,
    left: s,
    bottom: r,
    right: o
  } = t(e);
  Oa(e) && (r <= 0 || o <= 0 || n >= window.innerHeight || s >= window.innerWidth) && e.scrollIntoView({
    block: "center",
    inline: "center"
  });
}
const bg = [["x", ["left", "right"], pg], ["y", ["top", "bottom"], mg]];
class io {
  constructor(t, n) {
    this.rect = void 0, this.width = void 0, this.height = void 0, this.top = void 0, this.bottom = void 0, this.right = void 0, this.left = void 0;
    const s = zs(n), r = Pa(s);
    this.rect = {
      ...t
    }, this.width = t.width, this.height = t.height;
    for (const [o, i, a] of bg)
      for (const c of i)
        Object.defineProperty(this, c, {
          get: () => {
            const u = a(s), d = r[o] - u;
            return this.rect[c] + d;
          },
          enumerable: !0
        });
    Object.defineProperty(this, "rect", {
      enumerable: !1
    });
  }
}
class xn {
  constructor(t) {
    this.target = void 0, this.listeners = [], this.removeAll = () => {
      this.listeners.forEach((n) => {
        var s;
        return (s = this.target) == null ? void 0 : s.removeEventListener(...n);
      });
    }, this.target = t;
  }
  add(t, n, s) {
    var r;
    (r = this.target) == null || r.addEventListener(t, n, s), this.listeners.push([t, n, s]);
  }
}
function vg(e) {
  const {
    EventTarget: t
  } = ce(e);
  return e instanceof t ? e : cn(e);
}
function cr(e, t) {
  const n = Math.abs(e.x), s = Math.abs(e.y);
  return typeof t == "number" ? Math.sqrt(n ** 2 + s ** 2) > t : "x" in t && "y" in t ? n > t.x && s > t.y : "x" in t ? n > t.x : "y" in t ? s > t.y : !1;
}
var we;
(function(e) {
  e.Click = "click", e.DragStart = "dragstart", e.Keydown = "keydown", e.ContextMenu = "contextmenu", e.Resize = "resize", e.SelectionChange = "selectionchange", e.VisibilityChange = "visibilitychange";
})(we || (we = {}));
function ii(e) {
  e.preventDefault();
}
function Cg(e) {
  e.stopPropagation();
}
var V;
(function(e) {
  e.Space = "Space", e.Down = "ArrowDown", e.Right = "ArrowRight", e.Left = "ArrowLeft", e.Up = "ArrowUp", e.Esc = "Escape", e.Enter = "Enter", e.Tab = "Tab";
})(V || (V = {}));
const Fa = {
  start: [V.Space, V.Enter],
  cancel: [V.Esc],
  end: [V.Space, V.Enter, V.Tab]
}, yg = (e, t) => {
  let {
    currentCoordinates: n
  } = t;
  switch (e.code) {
    case V.Right:
      return {
        ...n,
        x: n.x + 25
      };
    case V.Left:
      return {
        ...n,
        x: n.x - 25
      };
    case V.Down:
      return {
        ...n,
        y: n.y + 25
      };
    case V.Up:
      return {
        ...n,
        y: n.y - 25
      };
  }
};
class ao {
  constructor(t) {
    this.props = void 0, this.autoScrollEnabled = !1, this.referenceCoordinates = void 0, this.listeners = void 0, this.windowListeners = void 0, this.props = t;
    const {
      event: {
        target: n
      }
    } = t;
    this.props = t, this.listeners = new xn(cn(n)), this.windowListeners = new xn(ce(n)), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleCancel = this.handleCancel.bind(this), this.attach();
  }
  attach() {
    this.handleStart(), this.windowListeners.add(we.Resize, this.handleCancel), this.windowListeners.add(we.VisibilityChange, this.handleCancel), setTimeout(() => this.listeners.add(we.Keydown, this.handleKeyDown));
  }
  handleStart() {
    const {
      activeNode: t,
      onStart: n
    } = this.props, s = t.node.current;
    s && Aa(s), n(Me);
  }
  handleKeyDown(t) {
    if (Hs(t)) {
      const {
        active: n,
        context: s,
        options: r
      } = this.props, {
        keyboardCodes: o = Fa,
        coordinateGetter: i = yg,
        scrollBehavior: a = "smooth"
      } = r, {
        code: c
      } = t;
      if (o.end.includes(c)) {
        this.handleEnd(t);
        return;
      }
      if (o.cancel.includes(c)) {
        this.handleCancel(t);
        return;
      }
      const {
        collisionRect: u
      } = s.current, d = u ? {
        x: u.left,
        y: u.top
      } : Me;
      this.referenceCoordinates || (this.referenceCoordinates = d);
      const h = i(t, {
        active: n,
        context: s.current,
        currentCoordinates: d
      });
      if (h) {
        const g = Nn(h, d), f = {
          x: 0,
          y: 0
        }, {
          scrollableAncestors: m
        } = s.current;
        for (const p of m) {
          const b = t.code, {
            isTop: v,
            isRight: y,
            isLeft: C,
            isBottom: x,
            maxScroll: S,
            minScroll: D
          } = Ea(p), R = gg(p), N = {
            x: Math.min(b === V.Right ? R.right - R.width / 2 : R.right, Math.max(b === V.Right ? R.left : R.left + R.width / 2, h.x)),
            y: Math.min(b === V.Down ? R.bottom - R.height / 2 : R.bottom, Math.max(b === V.Down ? R.top : R.top + R.height / 2, h.y))
          }, k = b === V.Right && !y || b === V.Left && !C, O = b === V.Down && !x || b === V.Up && !v;
          if (k && N.x !== h.x) {
            const $ = p.scrollLeft + g.x, W = b === V.Right && $ <= S.x || b === V.Left && $ >= D.x;
            if (W && !g.y) {
              p.scrollTo({
                left: $,
                behavior: a
              });
              return;
            }
            W ? f.x = p.scrollLeft - $ : f.x = b === V.Right ? p.scrollLeft - S.x : p.scrollLeft - D.x, f.x && p.scrollBy({
              left: -f.x,
              behavior: a
            });
            break;
          } else if (O && N.y !== h.y) {
            const $ = p.scrollTop + g.y, W = b === V.Down && $ <= S.y || b === V.Up && $ >= D.y;
            if (W && !g.x) {
              p.scrollTo({
                top: $,
                behavior: a
              });
              return;
            }
            W ? f.y = p.scrollTop - $ : f.y = b === V.Down ? p.scrollTop - S.y : p.scrollTop - D.y, f.y && p.scrollBy({
              top: -f.y,
              behavior: a
            });
            break;
          }
        }
        this.handleMove(t, Zt(Nn(h, this.referenceCoordinates), f));
      }
    }
  }
  handleMove(t, n) {
    const {
      onMove: s
    } = this.props;
    t.preventDefault(), s(n);
  }
  handleEnd(t) {
    const {
      onEnd: n
    } = this.props;
    t.preventDefault(), this.detach(), n();
  }
  handleCancel(t) {
    const {
      onCancel: n
    } = this.props;
    t.preventDefault(), this.detach(), n();
  }
  detach() {
    this.listeners.removeAll(), this.windowListeners.removeAll();
  }
}
ao.activators = [{
  eventName: "onKeyDown",
  handler: (e, t, n) => {
    let {
      keyboardCodes: s = Fa,
      onActivation: r
    } = t, {
      active: o
    } = n;
    const {
      code: i
    } = e.nativeEvent;
    if (s.start.includes(i)) {
      const a = o.activatorNode.current;
      return a && e.target !== a ? !1 : (e.preventDefault(), r == null || r({
        event: e.nativeEvent
      }), !0);
    }
    return !1;
  }
}];
function ai(e) {
  return !!(e && "distance" in e);
}
function li(e) {
  return !!(e && "delay" in e);
}
class lo {
  constructor(t, n, s) {
    var r;
    s === void 0 && (s = vg(t.event.target)), this.props = void 0, this.events = void 0, this.autoScrollEnabled = !0, this.document = void 0, this.activated = !1, this.initialCoordinates = void 0, this.timeoutId = null, this.listeners = void 0, this.documentListeners = void 0, this.windowListeners = void 0, this.props = t, this.events = n;
    const {
      event: o
    } = t, {
      target: i
    } = o;
    this.props = t, this.events = n, this.document = cn(i), this.documentListeners = new xn(this.document), this.listeners = new xn(s), this.windowListeners = new xn(ce(i)), this.initialCoordinates = (r = vs(o)) != null ? r : Me, this.handleStart = this.handleStart.bind(this), this.handleMove = this.handleMove.bind(this), this.handleEnd = this.handleEnd.bind(this), this.handleCancel = this.handleCancel.bind(this), this.handleKeydown = this.handleKeydown.bind(this), this.removeTextSelection = this.removeTextSelection.bind(this), this.attach();
  }
  attach() {
    const {
      events: t,
      props: {
        options: {
          activationConstraint: n,
          bypassActivationConstraint: s
        }
      }
    } = this;
    if (this.listeners.add(t.move.name, this.handleMove, {
      passive: !1
    }), this.listeners.add(t.end.name, this.handleEnd), t.cancel && this.listeners.add(t.cancel.name, this.handleCancel), this.windowListeners.add(we.Resize, this.handleCancel), this.windowListeners.add(we.DragStart, ii), this.windowListeners.add(we.VisibilityChange, this.handleCancel), this.windowListeners.add(we.ContextMenu, ii), this.documentListeners.add(we.Keydown, this.handleKeydown), n) {
      if (s != null && s({
        event: this.props.event,
        activeNode: this.props.activeNode,
        options: this.props.options
      }))
        return this.handleStart();
      if (li(n)) {
        this.timeoutId = setTimeout(this.handleStart, n.delay), this.handlePending(n);
        return;
      }
      if (ai(n)) {
        this.handlePending(n);
        return;
      }
    }
    this.handleStart();
  }
  detach() {
    this.listeners.removeAll(), this.windowListeners.removeAll(), setTimeout(this.documentListeners.removeAll, 50), this.timeoutId !== null && (clearTimeout(this.timeoutId), this.timeoutId = null);
  }
  handlePending(t, n) {
    const {
      active: s,
      onPending: r
    } = this.props;
    r(s, t, this.initialCoordinates, n);
  }
  handleStart() {
    const {
      initialCoordinates: t
    } = this, {
      onStart: n
    } = this.props;
    t && (this.activated = !0, this.documentListeners.add(we.Click, Cg, {
      capture: !0
    }), this.removeTextSelection(), this.documentListeners.add(we.SelectionChange, this.removeTextSelection), n(t));
  }
  handleMove(t) {
    var n;
    const {
      activated: s,
      initialCoordinates: r,
      props: o
    } = this, {
      onMove: i,
      options: {
        activationConstraint: a
      }
    } = o;
    if (!r)
      return;
    const c = (n = vs(t)) != null ? n : Me, u = Nn(r, c);
    if (!s && a) {
      if (ai(a)) {
        if (a.tolerance != null && cr(u, a.tolerance))
          return this.handleCancel();
        if (cr(u, a.distance))
          return this.handleStart();
      }
      if (li(a) && cr(u, a.tolerance))
        return this.handleCancel();
      this.handlePending(a, u);
      return;
    }
    t.cancelable && t.preventDefault(), i(c);
  }
  handleEnd() {
    const {
      onAbort: t,
      onEnd: n
    } = this.props;
    this.detach(), this.activated || t(this.props.active), n();
  }
  handleCancel() {
    const {
      onAbort: t,
      onCancel: n
    } = this.props;
    this.detach(), this.activated || t(this.props.active), n();
  }
  handleKeydown(t) {
    t.code === V.Esc && this.handleCancel();
  }
  removeTextSelection() {
    var t;
    (t = this.document.getSelection()) == null || t.removeAllRanges();
  }
}
const xg = {
  cancel: {
    name: "pointercancel"
  },
  move: {
    name: "pointermove"
  },
  end: {
    name: "pointerup"
  }
};
class co extends lo {
  constructor(t) {
    const {
      event: n
    } = t, s = cn(n.target);
    super(t, xg, s);
  }
}
co.activators = [{
  eventName: "onPointerDown",
  handler: (e, t) => {
    let {
      nativeEvent: n
    } = e, {
      onActivation: s
    } = t;
    return !n.isPrimary || n.button !== 0 ? !1 : (s == null || s({
      event: n
    }), !0);
  }
}];
const wg = {
  move: {
    name: "mousemove"
  },
  end: {
    name: "mouseup"
  }
};
var Nr;
(function(e) {
  e[e.RightClick = 2] = "RightClick";
})(Nr || (Nr = {}));
class Sg extends lo {
  constructor(t) {
    super(t, wg, cn(t.event.target));
  }
}
Sg.activators = [{
  eventName: "onMouseDown",
  handler: (e, t) => {
    let {
      nativeEvent: n
    } = e, {
      onActivation: s
    } = t;
    return n.button === Nr.RightClick ? !1 : (s == null || s({
      event: n
    }), !0);
  }
}];
const ur = {
  cancel: {
    name: "touchcancel"
  },
  move: {
    name: "touchmove"
  },
  end: {
    name: "touchend"
  }
};
class Rg extends lo {
  constructor(t) {
    super(t, ur);
  }
  static setup() {
    return window.addEventListener(ur.move.name, t, {
      capture: !1,
      passive: !1
    }), function() {
      window.removeEventListener(ur.move.name, t);
    };
    function t() {
    }
  }
}
Rg.activators = [{
  eventName: "onTouchStart",
  handler: (e, t) => {
    let {
      nativeEvent: n
    } = e, {
      onActivation: s
    } = t;
    const {
      touches: r
    } = n;
    return r.length > 1 ? !1 : (s == null || s({
      event: n
    }), !0);
  }
}];
var wn;
(function(e) {
  e[e.Pointer = 0] = "Pointer", e[e.DraggableRect = 1] = "DraggableRect";
})(wn || (wn = {}));
var ys;
(function(e) {
  e[e.TreeOrder = 0] = "TreeOrder", e[e.ReversedTreeOrder = 1] = "ReversedTreeOrder";
})(ys || (ys = {}));
function Lg(e) {
  let {
    acceleration: t,
    activator: n = wn.Pointer,
    canScroll: s,
    draggingRect: r,
    enabled: o,
    interval: i = 5,
    order: a = ys.TreeOrder,
    pointerCoordinates: c,
    scrollableAncestors: u,
    scrollableAncestorRects: d,
    delta: h,
    threshold: g
  } = e;
  const f = Mg({
    delta: h,
    disabled: !o
  }), [m, p] = Vf(), b = U({
    x: 0,
    y: 0
  }), v = U({
    x: 0,
    y: 0
  }), y = H(() => {
    switch (n) {
      case wn.Pointer:
        return c ? {
          top: c.y,
          bottom: c.y,
          left: c.x,
          right: c.x
        } : null;
      case wn.DraggableRect:
        return r;
    }
  }, [n, r, c]), C = U(null), x = le(() => {
    const D = C.current;
    if (!D)
      return;
    const R = b.current.x * v.current.x, N = b.current.y * v.current.y;
    D.scrollBy(R, N);
  }, []), S = H(() => a === ys.TreeOrder ? [...u].reverse() : u, [a, u]);
  B(
    () => {
      if (!o || !u.length || !y) {
        p();
        return;
      }
      for (const D of S) {
        if ((s == null ? void 0 : s(D)) === !1)
          continue;
        const R = u.indexOf(D), N = d[R];
        if (!N)
          continue;
        const {
          direction: k,
          speed: O
        } = fg(D, N, y, t, g);
        for (const $ of ["x", "y"])
          f[$][k[$]] || (O[$] = 0, k[$] = 0);
        if (O.x > 0 || O.y > 0) {
          p(), C.current = D, m(x, i), b.current = O, v.current = k;
          return;
        }
      }
      b.current = {
        x: 0,
        y: 0
      }, v.current = {
        x: 0,
        y: 0
      }, p();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      t,
      x,
      s,
      p,
      o,
      i,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(y),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(f),
      m,
      u,
      S,
      d,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(g)
    ]
  );
}
const Ng = {
  x: {
    [ee.Backward]: !1,
    [ee.Forward]: !1
  },
  y: {
    [ee.Backward]: !1,
    [ee.Forward]: !1
  }
};
function Mg(e) {
  let {
    delta: t,
    disabled: n
  } = e;
  const s = bs(t);
  return An((r) => {
    if (n || !s || !r)
      return Ng;
    const o = {
      x: Math.sign(t.x - s.x),
      y: Math.sign(t.y - s.y)
    };
    return {
      x: {
        [ee.Backward]: r.x[ee.Backward] || o.x === -1,
        [ee.Forward]: r.x[ee.Forward] || o.x === 1
      },
      y: {
        [ee.Backward]: r.y[ee.Backward] || o.y === -1,
        [ee.Forward]: r.y[ee.Forward] || o.y === 1
      }
    };
  }, [n, t, s]);
}
function Dg(e, t) {
  const n = t != null ? e.get(t) : void 0, s = n ? n.node.current : null;
  return An((r) => {
    var o;
    return t == null ? null : (o = s ?? r) != null ? o : null;
  }, [s, t]);
}
function $g(e, t) {
  return H(() => e.reduce((n, s) => {
    const {
      sensor: r
    } = s, o = r.activators.map((i) => ({
      eventName: i.eventName,
      handler: t(i.handler, s)
    }));
    return [...n, ...o];
  }, []), [e, t]);
}
var Mn;
(function(e) {
  e[e.Always = 0] = "Always", e[e.BeforeDragging = 1] = "BeforeDragging", e[e.WhileDragging = 2] = "WhileDragging";
})(Mn || (Mn = {}));
var Mr;
(function(e) {
  e.Optimized = "optimized";
})(Mr || (Mr = {}));
const ci = /* @__PURE__ */ new Map();
function Og(e, t) {
  let {
    dragging: n,
    dependencies: s,
    config: r
  } = t;
  const [o, i] = j(null), {
    frequency: a,
    measure: c,
    strategy: u
  } = r, d = U(e), h = b(), g = Ln(h), f = le(function(v) {
    v === void 0 && (v = []), !g.current && i((y) => y === null ? v : y.concat(v.filter((C) => !y.includes(C))));
  }, [g]), m = U(null), p = An((v) => {
    if (h && !n)
      return ci;
    if (!v || v === ci || d.current !== e || o != null) {
      const y = /* @__PURE__ */ new Map();
      for (let C of e) {
        if (!C)
          continue;
        if (o && o.length > 0 && !o.includes(C.id) && C.rect.current) {
          y.set(C.id, C.rect.current);
          continue;
        }
        const x = C.node.current, S = x ? new io(c(x), x) : null;
        C.rect.current = S, S && y.set(C.id, S);
      }
      return y;
    }
    return v;
  }, [e, o, n, h, c]);
  return B(() => {
    d.current = e;
  }, [e]), B(
    () => {
      h || f();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n, h]
  ), B(
    () => {
      o && o.length > 0 && i(null);
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(o)]
  ), B(
    () => {
      h || typeof a != "number" || m.current !== null || (m.current = setTimeout(() => {
        f(), m.current = null;
      }, a));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [a, h, f, ...s]
  ), {
    droppableRects: p,
    measureDroppableContainers: f,
    measuringScheduled: o != null
  };
  function b() {
    switch (u) {
      case Mn.Always:
        return !1;
      case Mn.BeforeDragging:
        return n;
      default:
        return !n;
    }
  }
}
function uo(e, t) {
  return An((n) => e ? n || (typeof t == "function" ? t(e) : e) : null, [t, e]);
}
function Tg(e, t) {
  return uo(e, t);
}
function kg(e) {
  let {
    callback: t,
    disabled: n
  } = e;
  const s = Ws(t), r = H(() => {
    if (n || typeof window > "u" || typeof window.MutationObserver > "u")
      return;
    const {
      MutationObserver: o
    } = window;
    return new o(s);
  }, [s, n]);
  return B(() => () => r == null ? void 0 : r.disconnect(), [r]), r;
}
function Us(e) {
  let {
    callback: t,
    disabled: n
  } = e;
  const s = Ws(t), r = H(
    () => {
      if (n || typeof window > "u" || typeof window.ResizeObserver > "u")
        return;
      const {
        ResizeObserver: o
      } = window;
      return new o(s);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n]
  );
  return B(() => () => r == null ? void 0 : r.disconnect(), [r]), r;
}
function Ig(e) {
  return new io(un(e), e);
}
function ui(e, t, n) {
  t === void 0 && (t = Ig);
  const [s, r] = j(null);
  function o() {
    r((c) => {
      if (!e)
        return null;
      if (e.isConnected === !1) {
        var u;
        return (u = c ?? n) != null ? u : null;
      }
      const d = t(e);
      return JSON.stringify(c) === JSON.stringify(d) ? c : d;
    });
  }
  const i = kg({
    callback(c) {
      if (e)
        for (const u of c) {
          const {
            type: d,
            target: h
          } = u;
          if (d === "childList" && h instanceof HTMLElement && h.contains(e)) {
            o();
            break;
          }
        }
    }
  }), a = Us({
    callback: o
  });
  return Ne(() => {
    o(), e ? (a == null || a.observe(e), i == null || i.observe(document.body, {
      childList: !0,
      subtree: !0
    })) : (a == null || a.disconnect(), i == null || i.disconnect());
  }, [e]), s;
}
function Eg(e) {
  const t = uo(e);
  return Da(e, t);
}
const di = [];
function Pg(e) {
  const t = U(e), n = An((s) => e ? s && s !== di && e && t.current && e.parentNode === t.current.parentNode ? s : zs(e) : di, [e]);
  return B(() => {
    t.current = e;
  }, [e]), n;
}
function Ag(e) {
  const [t, n] = j(null), s = U(e), r = le((o) => {
    const i = lr(o.target);
    i && n((a) => a ? (a.set(i, Lr(i)), new Map(a)) : null);
  }, []);
  return B(() => {
    const o = s.current;
    if (e !== o) {
      i(o);
      const a = e.map((c) => {
        const u = lr(c);
        return u ? (u.addEventListener("scroll", r, {
          passive: !0
        }), [u, Lr(u)]) : null;
      }).filter((c) => c != null);
      n(a.length ? new Map(a) : null), s.current = e;
    }
    return () => {
      i(e), i(o);
    };
    function i(a) {
      a.forEach((c) => {
        const u = lr(c);
        u == null || u.removeEventListener("scroll", r);
      });
    }
  }, [r, e]), H(() => e.length ? t ? Array.from(t.values()).reduce((o, i) => Zt(o, i), Me) : Pa(e) : Me, [e, t]);
}
function hi(e, t) {
  t === void 0 && (t = []);
  const n = U(null);
  return B(
    () => {
      n.current = null;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), B(() => {
    const s = e !== Me;
    s && !n.current && (n.current = e), !s && n.current && (n.current = null);
  }, [e]), n.current ? Nn(e, n.current) : Me;
}
function Fg(e) {
  B(
    () => {
      if (!js)
        return;
      const t = e.map((n) => {
        let {
          sensor: s
        } = n;
        return s.setup == null ? void 0 : s.setup();
      });
      return () => {
        for (const n of t)
          n == null || n();
      };
    },
    // TO-DO: Sensors length could theoretically change which would not be a valid dependency
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e.map((t) => {
      let {
        sensor: n
      } = t;
      return n;
    })
  );
}
function Vg(e, t) {
  return H(() => e.reduce((n, s) => {
    let {
      eventName: r,
      handler: o
    } = s;
    return n[r] = (i) => {
      o(i, t);
    }, n;
  }, {}), [e, t]);
}
function Va(e) {
  return H(() => e ? cg(e) : null, [e]);
}
const fi = [];
function Bg(e, t) {
  t === void 0 && (t = un);
  const [n] = e, s = Va(n ? ce(n) : null), [r, o] = j(fi);
  function i() {
    o(() => e.length ? e.map((c) => Ia(c) ? s : new io(t(c), c)) : fi);
  }
  const a = Us({
    callback: i
  });
  return Ne(() => {
    a == null || a.disconnect(), i(), e.forEach((c) => a == null ? void 0 : a.observe(c));
  }, [e]), r;
}
function Ba(e) {
  if (!e)
    return null;
  if (e.children.length > 1)
    return e;
  const t = e.children[0];
  return Pn(t) ? t : e;
}
function jg(e) {
  let {
    measure: t
  } = e;
  const [n, s] = j(null), r = le((u) => {
    for (const {
      target: d
    } of u)
      if (Pn(d)) {
        s((h) => {
          const g = t(d);
          return h ? {
            ...h,
            width: g.width,
            height: g.height
          } : g;
        });
        break;
      }
  }, [t]), o = Us({
    callback: r
  }), i = le((u) => {
    const d = Ba(u);
    o == null || o.disconnect(), d && (o == null || o.observe(d)), s(d ? t(d) : null);
  }, [t, o]), [a, c] = ms(i);
  return H(() => ({
    nodeRef: a,
    rect: n,
    setRef: c
  }), [n, a, c]);
}
const Wg = [{
  sensor: co,
  options: {}
}, {
  sensor: ao,
  options: {}
}], Hg = {
  current: {}
}, is = {
  draggable: {
    measure: oi
  },
  droppable: {
    measure: oi,
    strategy: Mn.WhileDragging,
    frequency: Mr.Optimized
  },
  dragOverlay: {
    measure: un
  }
};
class Sn extends Map {
  get(t) {
    var n;
    return t != null && (n = super.get(t)) != null ? n : void 0;
  }
  toArray() {
    return Array.from(this.values());
  }
  getEnabled() {
    return this.toArray().filter((t) => {
      let {
        disabled: n
      } = t;
      return !n;
    });
  }
  getNodeFor(t) {
    var n, s;
    return (n = (s = this.get(t)) == null ? void 0 : s.node.current) != null ? n : void 0;
  }
}
const zg = {
  activatorEvent: null,
  active: null,
  activeNode: null,
  activeNodeRect: null,
  collisions: null,
  containerNodeRect: null,
  draggableNodes: /* @__PURE__ */ new Map(),
  droppableRects: /* @__PURE__ */ new Map(),
  droppableContainers: /* @__PURE__ */ new Sn(),
  over: null,
  dragOverlay: {
    nodeRef: {
      current: null
    },
    rect: null,
    setRef: Cs
  },
  scrollableAncestors: [],
  scrollableAncestorRects: [],
  measuringConfiguration: is,
  measureDroppableContainers: Cs,
  windowRect: null,
  measuringScheduled: !1
}, ja = {
  activatorEvent: null,
  activators: [],
  active: null,
  activeNodeRect: null,
  ariaDescribedById: {
    draggable: ""
  },
  dispatch: Cs,
  draggableNodes: /* @__PURE__ */ new Map(),
  over: null,
  measureDroppableContainers: Cs
}, Vn = /* @__PURE__ */ Mt(ja), Wa = /* @__PURE__ */ Mt(zg);
function Ug() {
  return {
    draggable: {
      active: null,
      initialCoordinates: {
        x: 0,
        y: 0
      },
      nodes: /* @__PURE__ */ new Map(),
      translate: {
        x: 0,
        y: 0
      }
    },
    droppable: {
      containers: new Sn()
    }
  };
}
function Kg(e, t) {
  switch (t.type) {
    case J.DragStart:
      return {
        ...e,
        draggable: {
          ...e.draggable,
          initialCoordinates: t.initialCoordinates,
          active: t.active
        }
      };
    case J.DragMove:
      return e.draggable.active == null ? e : {
        ...e,
        draggable: {
          ...e.draggable,
          translate: {
            x: t.coordinates.x - e.draggable.initialCoordinates.x,
            y: t.coordinates.y - e.draggable.initialCoordinates.y
          }
        }
      };
    case J.DragEnd:
    case J.DragCancel:
      return {
        ...e,
        draggable: {
          ...e.draggable,
          active: null,
          initialCoordinates: {
            x: 0,
            y: 0
          },
          translate: {
            x: 0,
            y: 0
          }
        }
      };
    case J.RegisterDroppable: {
      const {
        element: n
      } = t, {
        id: s
      } = n, r = new Sn(e.droppable.containers);
      return r.set(s, n), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: r
        }
      };
    }
    case J.SetDroppableDisabled: {
      const {
        id: n,
        key: s,
        disabled: r
      } = t, o = e.droppable.containers.get(n);
      if (!o || s !== o.key)
        return e;
      const i = new Sn(e.droppable.containers);
      return i.set(n, {
        ...o,
        disabled: r
      }), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: i
        }
      };
    }
    case J.UnregisterDroppable: {
      const {
        id: n,
        key: s
      } = t, r = e.droppable.containers.get(n);
      if (!r || s !== r.key)
        return e;
      const o = new Sn(e.droppable.containers);
      return o.delete(n), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: o
        }
      };
    }
    default:
      return e;
  }
}
function qg(e) {
  let {
    disabled: t
  } = e;
  const {
    active: n,
    activatorEvent: s,
    draggableNodes: r
  } = lt(Vn), o = bs(s), i = bs(n == null ? void 0 : n.id);
  return B(() => {
    if (!t && !s && o && i != null) {
      if (!Hs(o) || document.activeElement === o.target)
        return;
      const a = r.get(i);
      if (!a)
        return;
      const {
        activatorNode: c,
        node: u
      } = a;
      if (!c.current && !u.current)
        return;
      requestAnimationFrame(() => {
        for (const d of [c.current, u.current]) {
          if (!d)
            continue;
          const h = Wf(d);
          if (h) {
            h.focus();
            break;
          }
        }
      });
    }
  }, [s, t, r, i, o]), null;
}
function Ha(e, t) {
  let {
    transform: n,
    ...s
  } = t;
  return e != null && e.length ? e.reduce((r, o) => o({
    transform: r,
    ...s
  }), n) : n;
}
function Xg(e) {
  return H(
    () => ({
      draggable: {
        ...is.draggable,
        ...e == null ? void 0 : e.draggable
      },
      droppable: {
        ...is.droppable,
        ...e == null ? void 0 : e.droppable
      },
      dragOverlay: {
        ...is.dragOverlay,
        ...e == null ? void 0 : e.dragOverlay
      }
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e == null ? void 0 : e.draggable, e == null ? void 0 : e.droppable, e == null ? void 0 : e.dragOverlay]
  );
}
function _g(e) {
  let {
    activeNode: t,
    measure: n,
    initialRect: s,
    config: r = !0
  } = e;
  const o = U(!1), {
    x: i,
    y: a
  } = typeof r == "boolean" ? {
    x: r,
    y: r
  } : r;
  Ne(() => {
    if (!i && !a || !t) {
      o.current = !1;
      return;
    }
    if (o.current || !s)
      return;
    const u = t == null ? void 0 : t.node.current;
    if (!u || u.isConnected === !1)
      return;
    const d = n(u), h = Da(d, s);
    if (i || (h.x = 0), a || (h.y = 0), o.current = !0, Math.abs(h.x) > 0 || Math.abs(h.y) > 0) {
      const g = Oa(u);
      g && g.scrollBy({
        top: h.y,
        left: h.x
      });
    }
  }, [t, i, a, s, n]);
}
const Ks = /* @__PURE__ */ Mt({
  ...Me,
  scaleX: 1,
  scaleY: 1
});
var it;
(function(e) {
  e[e.Uninitialized = 0] = "Uninitialized", e[e.Initializing = 1] = "Initializing", e[e.Initialized = 2] = "Initialized";
})(it || (it = {}));
const Yg = /* @__PURE__ */ oc(function(t) {
  var n, s, r, o;
  let {
    id: i,
    accessibility: a,
    autoScroll: c = !0,
    children: u,
    sensors: d = Wg,
    collisionDetection: h = sg,
    measuring: g,
    modifiers: f,
    ...m
  } = t;
  const p = ic(Kg, void 0, Ug), [b, v] = p, [y, C] = Xf(), [x, S] = j(it.Uninitialized), D = x === it.Initialized, {
    draggable: {
      active: R,
      nodes: N,
      translate: k
    },
    droppable: {
      containers: O
    }
  } = b, $ = R != null ? N.get(R) : null, W = U({
    initial: null,
    translated: null
  }), A = H(() => {
    var ie;
    return R != null ? {
      id: R,
      // It's possible for the active node to unmount while dragging
      data: (ie = $ == null ? void 0 : $.data) != null ? ie : Hg,
      rect: W
    } : null;
  }, [R, $]), z = U(null), [Ce, te] = j(null), [Z, Y] = j(null), ne = Ln(m, Object.values(m)), ue = Fn("DndDescribedBy", i), Et = H(() => O.getEnabled(), [O]), oe = Xg(g), {
    droppableRects: je,
    measureDroppableContainers: yt,
    measuringScheduled: gn
  } = Og(Et, {
    dragging: D,
    dependencies: [k.x, k.y],
    config: oe.droppable
  }), ye = Dg(N, R), Kn = H(() => Z ? vs(Z) : null, [Z]), Qe = nc(), We = Tg(ye, oe.draggable.measure);
  _g({
    activeNode: R != null ? N.get(R) : null,
    config: Qe.layoutShiftCompensation,
    initialRect: We,
    measure: oe.draggable.measure
  });
  const q = ui(ye, oe.draggable.measure, We), pn = ui(ye ? ye.parentElement : null), $e = U({
    activatorEvent: null,
    active: null,
    activeNode: ye,
    collisionRect: null,
    collisions: null,
    droppableRects: je,
    draggableNodes: N,
    draggingNode: null,
    draggingNodeRect: null,
    droppableContainers: O,
    over: null,
    scrollableAncestors: [],
    scrollAdjustedTranslate: null
  }), Pt = O.getNodeFor((n = $e.current.over) == null ? void 0 : n.id), He = jg({
    measure: oe.dragOverlay.measure
  }), At = (s = He.nodeRef.current) != null ? s : ye, Ft = D ? (r = He.rect) != null ? r : q : null, So = !!(He.nodeRef.current && He.rect), Ro = Eg(So ? null : q), Gs = Va(At ? ce(At) : null), et = Pg(D ? Pt ?? ye : null), qn = Bg(et), Xn = Ha(f, {
    transform: {
      x: k.x - Ro.x,
      y: k.y - Ro.y,
      scaleX: 1,
      scaleY: 1
    },
    activatorEvent: Z,
    active: A,
    activeNodeRect: q,
    containerNodeRect: pn,
    draggingNodeRect: Ft,
    over: $e.current.over,
    overlayNodeRect: He.rect,
    scrollableAncestors: et,
    scrollableAncestorRects: qn,
    windowRect: Gs
  }), Lo = Kn ? Zt(Kn, k) : null, No = Ag(et), Yl = hi(No), Gl = hi(No, [q]), Vt = Zt(Xn, Yl), Bt = Ft ? ig(Ft, Xn) : null, mn = A && Bt ? h({
    active: A,
    collisionRect: Bt,
    droppableRects: je,
    droppableContainers: Et,
    pointerCoordinates: Lo
  }) : null, Mo = Ma(mn, "id"), [tt, Do] = j(null), Zl = So ? Xn : Zt(Xn, Gl), Jl = rg(Zl, (o = tt == null ? void 0 : tt.rect) != null ? o : null, q), Zs = U(null), $o = le(
    (ie, he) => {
      let {
        sensor: fe,
        options: nt
      } = he;
      if (z.current == null)
        return;
      const xe = N.get(z.current);
      if (!xe)
        return;
      const ge = ie.nativeEvent, Oe = new fe({
        active: z.current,
        activeNode: xe,
        event: ge,
        options: nt,
        // Sensors need to be instantiated with refs for arguments that change over time
        // otherwise they are frozen in time with the stale arguments
        context: $e,
        onAbort(se) {
          if (!N.get(se))
            return;
          const {
            onDragAbort: Te
          } = ne.current, ze = {
            id: se
          };
          Te == null || Te(ze), y({
            type: "onDragAbort",
            event: ze
          });
        },
        onPending(se, st, Te, ze) {
          if (!N.get(se))
            return;
          const {
            onDragPending: vn
          } = ne.current, rt = {
            id: se,
            constraint: st,
            initialCoordinates: Te,
            offset: ze
          };
          vn == null || vn(rt), y({
            type: "onDragPending",
            event: rt
          });
        },
        onStart(se) {
          const st = z.current;
          if (st == null)
            return;
          const Te = N.get(st);
          if (!Te)
            return;
          const {
            onDragStart: ze
          } = ne.current, bn = {
            activatorEvent: ge,
            active: {
              id: st,
              data: Te.data,
              rect: W
            }
          };
          _n(() => {
            ze == null || ze(bn), S(it.Initializing), v({
              type: J.DragStart,
              initialCoordinates: se,
              active: st
            }), y({
              type: "onDragStart",
              event: bn
            }), te(Zs.current), Y(ge);
          });
        },
        onMove(se) {
          v({
            type: J.DragMove,
            coordinates: se
          });
        },
        onEnd: jt(J.DragEnd),
        onCancel: jt(J.DragCancel)
      });
      Zs.current = Oe;
      function jt(se) {
        return async function() {
          const {
            active: Te,
            collisions: ze,
            over: bn,
            scrollAdjustedTranslate: vn
          } = $e.current;
          let rt = null;
          if (Te && vn) {
            const {
              cancelDrop: Cn
            } = ne.current;
            rt = {
              activatorEvent: ge,
              active: Te,
              collisions: ze,
              delta: vn,
              over: bn
            }, se === J.DragEnd && typeof Cn == "function" && await Promise.resolve(Cn(rt)) && (se = J.DragCancel);
          }
          z.current = null, _n(() => {
            v({
              type: se
            }), S(it.Uninitialized), Do(null), te(null), Y(null), Zs.current = null;
            const Cn = se === J.DragEnd ? "onDragEnd" : "onDragCancel";
            if (rt) {
              const Js = ne.current[Cn];
              Js == null || Js(rt), y({
                type: Cn,
                event: rt
              });
            }
          });
        };
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [N]
  ), Ql = le((ie, he) => (fe, nt) => {
    const xe = fe.nativeEvent, ge = N.get(nt);
    if (
      // Another sensor is already instantiating
      z.current !== null || // No active draggable
      !ge || // Event has already been captured
      xe.dndKit || xe.defaultPrevented
    )
      return;
    const Oe = {
      active: ge
    };
    ie(fe, he.options, Oe) === !0 && (xe.dndKit = {
      capturedBy: he.sensor
    }, z.current = nt, $o(fe, he));
  }, [N, $o]), Oo = $g(d, Ql);
  Fg(d), Ne(() => {
    q && x === it.Initializing && S(it.Initialized);
  }, [q, x]), B(
    () => {
      const {
        onDragMove: ie
      } = ne.current, {
        active: he,
        activatorEvent: fe,
        collisions: nt,
        over: xe
      } = $e.current;
      if (!he || !fe)
        return;
      const ge = {
        active: he,
        activatorEvent: fe,
        collisions: nt,
        delta: {
          x: Vt.x,
          y: Vt.y
        },
        over: xe
      };
      _n(() => {
        ie == null || ie(ge), y({
          type: "onDragMove",
          event: ge
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [Vt.x, Vt.y]
  ), B(
    () => {
      const {
        active: ie,
        activatorEvent: he,
        collisions: fe,
        droppableContainers: nt,
        scrollAdjustedTranslate: xe
      } = $e.current;
      if (!ie || z.current == null || !he || !xe)
        return;
      const {
        onDragOver: ge
      } = ne.current, Oe = nt.get(Mo), jt = Oe && Oe.rect.current ? {
        id: Oe.id,
        rect: Oe.rect.current,
        data: Oe.data,
        disabled: Oe.disabled
      } : null, se = {
        active: ie,
        activatorEvent: he,
        collisions: fe,
        delta: {
          x: xe.x,
          y: xe.y
        },
        over: jt
      };
      _n(() => {
        Do(jt), ge == null || ge(se), y({
          type: "onDragOver",
          event: se
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [Mo]
  ), Ne(() => {
    $e.current = {
      activatorEvent: Z,
      active: A,
      activeNode: ye,
      collisionRect: Bt,
      collisions: mn,
      droppableRects: je,
      draggableNodes: N,
      draggingNode: At,
      draggingNodeRect: Ft,
      droppableContainers: O,
      over: tt,
      scrollableAncestors: et,
      scrollAdjustedTranslate: Vt
    }, W.current = {
      initial: Ft,
      translated: Bt
    };
  }, [A, ye, mn, Bt, N, At, Ft, je, O, tt, et, Vt]), Lg({
    ...Qe,
    delta: k,
    draggingRect: Bt,
    pointerCoordinates: Lo,
    scrollableAncestors: et,
    scrollableAncestorRects: qn
  });
  const ec = H(() => ({
    active: A,
    activeNode: ye,
    activeNodeRect: q,
    activatorEvent: Z,
    collisions: mn,
    containerNodeRect: pn,
    dragOverlay: He,
    draggableNodes: N,
    droppableContainers: O,
    droppableRects: je,
    over: tt,
    measureDroppableContainers: yt,
    scrollableAncestors: et,
    scrollableAncestorRects: qn,
    measuringConfiguration: oe,
    measuringScheduled: gn,
    windowRect: Gs
  }), [A, ye, q, Z, mn, pn, He, N, O, je, tt, yt, et, qn, oe, gn, Gs]), tc = H(() => ({
    activatorEvent: Z,
    activators: Oo,
    active: A,
    activeNodeRect: q,
    ariaDescribedById: {
      draggable: ue
    },
    dispatch: v,
    draggableNodes: N,
    over: tt,
    measureDroppableContainers: yt
  }), [Z, Oo, A, q, v, ue, N, tt, yt]);
  return F.createElement(Ra.Provider, {
    value: C
  }, F.createElement(Vn.Provider, {
    value: tc
  }, F.createElement(Wa.Provider, {
    value: ec
  }, F.createElement(Ks.Provider, {
    value: Jl
  }, u)), F.createElement(qg, {
    disabled: (a == null ? void 0 : a.restoreFocus) === !1
  })), F.createElement(Gf, {
    ...a,
    hiddenTextDescribedById: ue
  }));
  function nc() {
    const ie = (Ce == null ? void 0 : Ce.autoScrollEnabled) === !1, he = typeof c == "object" ? c.enabled === !1 : c === !1, fe = D && !ie && !he;
    return typeof c == "object" ? {
      ...c,
      enabled: fe
    } : {
      enabled: fe
    };
  }
}), Gg = /* @__PURE__ */ Mt(null), gi = "button", Zg = "Draggable";
function Jg(e) {
  let {
    id: t,
    data: n,
    disabled: s = !1,
    attributes: r
  } = e;
  const o = Fn(Zg), {
    activators: i,
    activatorEvent: a,
    active: c,
    activeNodeRect: u,
    ariaDescribedById: d,
    draggableNodes: h,
    over: g
  } = lt(Vn), {
    role: f = gi,
    roleDescription: m = "draggable",
    tabIndex: p = 0
  } = r ?? {}, b = (c == null ? void 0 : c.id) === t, v = lt(b ? Ks : Gg), [y, C] = ms(), [x, S] = ms(), D = Vg(i, t), R = Ln(n);
  Ne(
    () => (h.set(t, {
      id: t,
      key: o,
      node: y,
      activatorNode: x,
      data: R
    }), () => {
      const k = h.get(t);
      k && k.key === o && h.delete(t);
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [h, t]
  );
  const N = H(() => ({
    role: f,
    tabIndex: p,
    "aria-disabled": s,
    "aria-pressed": b && f === gi ? !0 : void 0,
    "aria-roledescription": m,
    "aria-describedby": d.draggable
  }), [s, f, p, b, m, d.draggable]);
  return {
    active: c,
    activatorEvent: a,
    activeNodeRect: u,
    attributes: N,
    isDragging: b,
    listeners: s ? void 0 : D,
    node: y,
    over: g,
    setNodeRef: C,
    setActivatorNodeRef: S,
    transform: v
  };
}
function za() {
  return lt(Wa);
}
const Qg = "Droppable", ep = {
  timeout: 25
};
function tp(e) {
  let {
    data: t,
    disabled: n = !1,
    id: s,
    resizeObserverConfig: r
  } = e;
  const o = Fn(Qg), {
    active: i,
    dispatch: a,
    over: c,
    measureDroppableContainers: u
  } = lt(Vn), d = U({
    disabled: n
  }), h = U(!1), g = U(null), f = U(null), {
    disabled: m,
    updateMeasurementsFor: p,
    timeout: b
  } = {
    ...ep,
    ...r
  }, v = Ln(p ?? s), y = le(
    () => {
      if (!h.current) {
        h.current = !0;
        return;
      }
      f.current != null && clearTimeout(f.current), f.current = setTimeout(() => {
        u(Array.isArray(v.current) ? v.current : [v.current]), f.current = null;
      }, b);
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [b]
  ), C = Us({
    callback: y,
    disabled: m || !i
  }), x = le((N, k) => {
    C && (k && (C.unobserve(k), h.current = !1), N && C.observe(N));
  }, [C]), [S, D] = ms(x), R = Ln(t);
  return B(() => {
    !C || !S.current || (C.disconnect(), h.current = !1, C.observe(S.current));
  }, [S, C]), B(
    () => (a({
      type: J.RegisterDroppable,
      element: {
        id: s,
        key: o,
        disabled: n,
        node: S,
        rect: g,
        data: R
      }
    }), () => a({
      type: J.UnregisterDroppable,
      key: o,
      id: s
    })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [s]
  ), B(() => {
    n !== d.current.disabled && (a({
      type: J.SetDroppableDisabled,
      id: s,
      key: o,
      disabled: n
    }), d.current.disabled = n);
  }, [s, o, n, a]), {
    active: i,
    rect: g,
    isOver: (c == null ? void 0 : c.id) === s,
    node: S,
    over: c,
    setNodeRef: D
  };
}
function np(e) {
  let {
    animation: t,
    children: n
  } = e;
  const [s, r] = j(null), [o, i] = j(null), a = bs(n);
  return !n && !s && a && r(a), Ne(() => {
    if (!o)
      return;
    const c = s == null ? void 0 : s.key, u = s == null ? void 0 : s.props.id;
    if (c == null || u == null) {
      r(null);
      return;
    }
    Promise.resolve(t(u, o)).then(() => {
      r(null);
    });
  }, [t, s, o]), F.createElement(F.Fragment, null, n, s ? ac(s, {
    ref: i
  }) : null);
}
const sp = {
  x: 0,
  y: 0,
  scaleX: 1,
  scaleY: 1
};
function rp(e) {
  let {
    children: t
  } = e;
  return F.createElement(Vn.Provider, {
    value: ja
  }, F.createElement(Ks.Provider, {
    value: sp
  }, t));
}
const op = {
  position: "fixed",
  touchAction: "none"
}, ip = (e) => Hs(e) ? "transform 250ms ease" : void 0, ap = /* @__PURE__ */ lc((e, t) => {
  let {
    as: n,
    activatorEvent: s,
    adjustScale: r,
    children: o,
    className: i,
    rect: a,
    style: c,
    transform: u,
    transition: d = ip
  } = e;
  if (!a)
    return null;
  const h = r ? u : {
    ...u,
    scaleX: 1,
    scaleY: 1
  }, g = {
    ...op,
    width: a.width,
    height: a.height,
    top: a.top,
    left: a.left,
    transform: dt.Transform.toString(h),
    transformOrigin: r && s ? Jf(s, a) : void 0,
    transition: typeof d == "function" ? d(s) : d,
    ...c
  };
  return F.createElement(n, {
    className: i,
    style: g,
    ref: t
  }, o);
}), lp = (e) => (t) => {
  let {
    active: n,
    dragOverlay: s
  } = t;
  const r = {}, {
    styles: o,
    className: i
  } = e;
  if (o != null && o.active)
    for (const [a, c] of Object.entries(o.active))
      c !== void 0 && (r[a] = n.node.style.getPropertyValue(a), n.node.style.setProperty(a, c));
  if (o != null && o.dragOverlay)
    for (const [a, c] of Object.entries(o.dragOverlay))
      c !== void 0 && s.node.style.setProperty(a, c);
  return i != null && i.active && n.node.classList.add(i.active), i != null && i.dragOverlay && s.node.classList.add(i.dragOverlay), function() {
    for (const [c, u] of Object.entries(r))
      n.node.style.setProperty(c, u);
    i != null && i.active && n.node.classList.remove(i.active);
  };
}, cp = (e) => {
  let {
    transform: {
      initial: t,
      final: n
    }
  } = e;
  return [{
    transform: dt.Transform.toString(t)
  }, {
    transform: dt.Transform.toString(n)
  }];
}, up = {
  duration: 250,
  easing: "ease",
  keyframes: cp,
  sideEffects: /* @__PURE__ */ lp({
    styles: {
      active: {
        opacity: "0"
      }
    }
  })
};
function dp(e) {
  let {
    config: t,
    draggableNodes: n,
    droppableContainers: s,
    measuringConfiguration: r
  } = e;
  return Ws((o, i) => {
    if (t === null)
      return;
    const a = n.get(o);
    if (!a)
      return;
    const c = a.node.current;
    if (!c)
      return;
    const u = Ba(i);
    if (!u)
      return;
    const {
      transform: d
    } = ce(i).getComputedStyle(i), h = $a(d);
    if (!h)
      return;
    const g = typeof t == "function" ? t : hp(t);
    return Aa(c, r.draggable.measure), g({
      active: {
        id: o,
        data: a.data,
        node: c,
        rect: r.draggable.measure(c)
      },
      draggableNodes: n,
      dragOverlay: {
        node: i,
        rect: r.dragOverlay.measure(u)
      },
      droppableContainers: s,
      measuringConfiguration: r,
      transform: h
    });
  });
}
function hp(e) {
  const {
    duration: t,
    easing: n,
    sideEffects: s,
    keyframes: r
  } = {
    ...up,
    ...e
  };
  return (o) => {
    let {
      active: i,
      dragOverlay: a,
      transform: c,
      ...u
    } = o;
    if (!t)
      return;
    const d = {
      x: a.rect.left - i.rect.left,
      y: a.rect.top - i.rect.top
    }, h = {
      scaleX: c.scaleX !== 1 ? i.rect.width * c.scaleX / a.rect.width : 1,
      scaleY: c.scaleY !== 1 ? i.rect.height * c.scaleY / a.rect.height : 1
    }, g = {
      x: c.x - d.x,
      y: c.y - d.y,
      ...h
    }, f = r({
      ...u,
      active: i,
      dragOverlay: a,
      transform: {
        initial: c,
        final: g
      }
    }), [m] = f, p = f[f.length - 1];
    if (JSON.stringify(m) === JSON.stringify(p))
      return;
    const b = s == null ? void 0 : s({
      active: i,
      dragOverlay: a,
      ...u
    }), v = a.node.animate(f, {
      duration: t,
      easing: n,
      fill: "forwards"
    });
    return new Promise((y) => {
      v.onfinish = () => {
        b == null || b(), y();
      };
    });
  };
}
let pi = 0;
function fp(e) {
  return H(() => {
    if (e != null)
      return pi++, pi;
  }, [e]);
}
const gp = /* @__PURE__ */ F.memo((e) => {
  let {
    adjustScale: t = !1,
    children: n,
    dropAnimation: s,
    style: r,
    transition: o,
    modifiers: i,
    wrapperElement: a = "div",
    className: c,
    zIndex: u = 999
  } = e;
  const {
    activatorEvent: d,
    active: h,
    activeNodeRect: g,
    containerNodeRect: f,
    draggableNodes: m,
    droppableContainers: p,
    dragOverlay: b,
    over: v,
    measuringConfiguration: y,
    scrollableAncestors: C,
    scrollableAncestorRects: x,
    windowRect: S
  } = za(), D = lt(Ks), R = fp(h == null ? void 0 : h.id), N = Ha(i, {
    activatorEvent: d,
    active: h,
    activeNodeRect: g,
    containerNodeRect: f,
    draggingNodeRect: b.rect,
    over: v,
    overlayNodeRect: b.rect,
    scrollableAncestors: C,
    scrollableAncestorRects: x,
    transform: D,
    windowRect: S
  }), k = uo(g), O = dp({
    config: s,
    draggableNodes: m,
    droppableContainers: p,
    measuringConfiguration: y
  }), $ = k ? b.setRef : void 0;
  return F.createElement(rp, null, F.createElement(np, {
    animation: O
  }, h && R ? F.createElement(ap, {
    key: R,
    id: h.id,
    ref: $,
    as: a,
    activatorEvent: d,
    adjustScale: t,
    className: c,
    transition: o,
    rect: k,
    style: {
      zIndex: u,
      ...r
    },
    transform: N
  }, n) : null));
});
function ho(e, t, n) {
  const s = e.slice();
  return s.splice(n < 0 ? s.length + n : n, 0, s.splice(t, 1)[0]), s;
}
function pp(e, t) {
  return e.reduce((n, s, r) => {
    const o = t.get(s);
    return o && (n[r] = o), n;
  }, Array(e.length));
}
function es(e) {
  return e !== null && e >= 0;
}
function mp(e, t) {
  if (e === t)
    return !0;
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function bp(e) {
  return typeof e == "boolean" ? {
    draggable: e,
    droppable: e
  } : e;
}
const ts = {
  scaleX: 1,
  scaleY: 1
}, vp = (e) => {
  var t;
  let {
    rects: n,
    activeNodeRect: s,
    activeIndex: r,
    overIndex: o,
    index: i
  } = e;
  const a = (t = n[r]) != null ? t : s;
  if (!a)
    return null;
  const c = Cp(n, i, r);
  if (i === r) {
    const u = n[o];
    return u ? {
      x: r < o ? u.left + u.width - (a.left + a.width) : u.left - a.left,
      y: 0,
      ...ts
    } : null;
  }
  return i > r && i <= o ? {
    x: -a.width - c,
    y: 0,
    ...ts
  } : i < r && i >= o ? {
    x: a.width + c,
    y: 0,
    ...ts
  } : {
    x: 0,
    y: 0,
    ...ts
  };
};
function Cp(e, t, n) {
  const s = e[t], r = e[t - 1], o = e[t + 1];
  return !s || !r && !o ? 0 : n < t ? r ? s.left - (r.left + r.width) : o.left - (s.left + s.width) : o ? o.left - (s.left + s.width) : s.left - (r.left + r.width);
}
const fo = (e) => {
  let {
    rects: t,
    activeIndex: n,
    overIndex: s,
    index: r
  } = e;
  const o = ho(t, s, n), i = t[r], a = o[r];
  return !a || !i ? null : {
    x: a.left - i.left,
    y: a.top - i.top,
    scaleX: a.width / i.width,
    scaleY: a.height / i.height
  };
}, ns = {
  scaleX: 1,
  scaleY: 1
}, yp = (e) => {
  var t;
  let {
    activeIndex: n,
    activeNodeRect: s,
    index: r,
    rects: o,
    overIndex: i
  } = e;
  const a = (t = o[n]) != null ? t : s;
  if (!a)
    return null;
  if (r === n) {
    const u = o[i];
    return u ? {
      x: 0,
      y: n < i ? u.top + u.height - (a.top + a.height) : u.top - a.top,
      ...ns
    } : null;
  }
  const c = xp(o, r, n);
  return r > n && r <= i ? {
    x: 0,
    y: -a.height - c,
    ...ns
  } : r < n && r >= i ? {
    x: 0,
    y: a.height + c,
    ...ns
  } : {
    x: 0,
    y: 0,
    ...ns
  };
};
function xp(e, t, n) {
  const s = e[t], r = e[t - 1], o = e[t + 1];
  return s ? n < t ? r ? s.top - (r.top + r.height) : o ? o.top - (s.top + s.height) : 0 : o ? o.top - (s.top + s.height) : r ? s.top - (r.top + r.height) : 0 : 0;
}
const Ua = "Sortable", Ka = /* @__PURE__ */ F.createContext({
  activeIndex: -1,
  containerId: Ua,
  disableTransforms: !1,
  items: [],
  overIndex: -1,
  useDragOverlay: !1,
  sortedRects: [],
  strategy: fo,
  disabled: {
    draggable: !1,
    droppable: !1
  }
});
function wp(e) {
  let {
    children: t,
    id: n,
    items: s,
    strategy: r = fo,
    disabled: o = !1
  } = e;
  const {
    active: i,
    dragOverlay: a,
    droppableRects: c,
    over: u,
    measureDroppableContainers: d
  } = za(), h = Fn(Ua, n), g = a.rect !== null, f = H(() => s.map((D) => typeof D == "object" && "id" in D ? D.id : D), [s]), m = i != null, p = i ? f.indexOf(i.id) : -1, b = u ? f.indexOf(u.id) : -1, v = U(f), y = !mp(f, v.current), C = b !== -1 && p === -1 || y, x = bp(o);
  Ne(() => {
    y && m && d(f);
  }, [y, f, m, d]), B(() => {
    v.current = f;
  }, [f]);
  const S = H(
    () => ({
      activeIndex: p,
      containerId: h,
      disabled: x,
      disableTransforms: C,
      items: f,
      overIndex: b,
      useDragOverlay: g,
      sortedRects: pp(f, c),
      strategy: r
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [p, h, x.draggable, x.droppable, C, f, b, c, g, r]
  );
  return F.createElement(Ka.Provider, {
    value: S
  }, t);
}
const Sp = (e) => {
  let {
    id: t,
    items: n,
    activeIndex: s,
    overIndex: r
  } = e;
  return ho(n, s, r).indexOf(t);
}, Rp = (e) => {
  let {
    containerId: t,
    isSorting: n,
    wasDragging: s,
    index: r,
    items: o,
    newIndex: i,
    previousItems: a,
    previousContainerId: c,
    transition: u
  } = e;
  return !u || !s || a !== o && r === i ? !1 : n ? !0 : i !== r && t === c;
}, Lp = {
  duration: 200,
  easing: "ease"
}, qa = "transform", Np = /* @__PURE__ */ dt.Transition.toString({
  property: qa,
  duration: 0,
  easing: "linear"
}), Mp = {
  roleDescription: "sortable"
};
function Dp(e) {
  let {
    disabled: t,
    index: n,
    node: s,
    rect: r
  } = e;
  const [o, i] = j(null), a = U(n);
  return Ne(() => {
    if (!t && n !== a.current && s.current) {
      const c = r.current;
      if (c) {
        const u = un(s.current, {
          ignoreTransform: !0
        }), d = {
          x: c.left - u.left,
          y: c.top - u.top,
          scaleX: c.width / u.width,
          scaleY: c.height / u.height
        };
        (d.x || d.y) && i(d);
      }
    }
    n !== a.current && (a.current = n);
  }, [t, n, s, r]), B(() => {
    o && i(null);
  }, [o]), o;
}
function $p(e) {
  let {
    animateLayoutChanges: t = Rp,
    attributes: n,
    disabled: s,
    data: r,
    getNewIndex: o = Sp,
    id: i,
    strategy: a,
    resizeObserverConfig: c,
    transition: u = Lp
  } = e;
  const {
    items: d,
    containerId: h,
    activeIndex: g,
    disabled: f,
    disableTransforms: m,
    sortedRects: p,
    overIndex: b,
    useDragOverlay: v,
    strategy: y
  } = lt(Ka), C = Op(s, f), x = d.indexOf(i), S = H(() => ({
    sortable: {
      containerId: h,
      index: x,
      items: d
    },
    ...r
  }), [h, r, x, d]), D = H(() => d.slice(d.indexOf(i)), [d, i]), {
    rect: R,
    node: N,
    isOver: k,
    setNodeRef: O
  } = tp({
    id: i,
    data: S,
    disabled: C.droppable,
    resizeObserverConfig: {
      updateMeasurementsFor: D,
      ...c
    }
  }), {
    active: $,
    activatorEvent: W,
    activeNodeRect: A,
    attributes: z,
    setNodeRef: Ce,
    listeners: te,
    isDragging: Z,
    over: Y,
    setActivatorNodeRef: ne,
    transform: ue
  } = Jg({
    id: i,
    data: S,
    attributes: {
      ...Mp,
      ...n
    },
    disabled: C.draggable
  }), Et = Ff(O, Ce), oe = !!$, je = oe && !m && es(g) && es(b), yt = !v && Z, gn = yt && je ? ue : null, Kn = je ? gn ?? (a ?? y)({
    rects: p,
    activeNodeRect: A,
    activeIndex: g,
    overIndex: b,
    index: x
  }) : null, Qe = es(g) && es(b) ? o({
    id: i,
    items: d,
    activeIndex: g,
    overIndex: b
  }) : x, We = $ == null ? void 0 : $.id, q = U({
    activeId: We,
    items: d,
    newIndex: Qe,
    containerId: h
  }), pn = d !== q.current.items, $e = t({
    active: $,
    containerId: h,
    isDragging: Z,
    isSorting: oe,
    id: i,
    index: x,
    items: d,
    newIndex: q.current.newIndex,
    previousItems: q.current.items,
    previousContainerId: q.current.containerId,
    transition: u,
    wasDragging: q.current.activeId != null
  }), Pt = Dp({
    disabled: !$e,
    index: x,
    node: N,
    rect: R
  });
  return B(() => {
    oe && q.current.newIndex !== Qe && (q.current.newIndex = Qe), h !== q.current.containerId && (q.current.containerId = h), d !== q.current.items && (q.current.items = d);
  }, [oe, Qe, h, d]), B(() => {
    if (We === q.current.activeId)
      return;
    if (We && !q.current.activeId) {
      q.current.activeId = We;
      return;
    }
    const At = setTimeout(() => {
      q.current.activeId = We;
    }, 50);
    return () => clearTimeout(At);
  }, [We]), {
    active: $,
    activeIndex: g,
    attributes: z,
    data: S,
    rect: R,
    index: x,
    newIndex: Qe,
    items: d,
    isOver: k,
    isSorting: oe,
    isDragging: Z,
    listeners: te,
    node: N,
    overIndex: b,
    over: Y,
    setNodeRef: Et,
    setActivatorNodeRef: ne,
    setDroppableNodeRef: O,
    setDraggableNodeRef: Ce,
    transform: Pt ?? Kn,
    transition: He()
  };
  function He() {
    if (
      // Temporarily disable transitions for a single frame to set up derived transforms
      Pt || // Or to prevent items jumping to back to their "new" position when items change
      pn && q.current.newIndex === x
    )
      return Np;
    if (!(yt && !Hs(W) || !u) && (oe || $e))
      return dt.Transition.toString({
        ...u,
        property: qa
      });
  }
}
function Op(e, t) {
  var n, s;
  return typeof e == "boolean" ? {
    draggable: e,
    // Backwards compatibility
    droppable: !1
  } : {
    draggable: (n = e == null ? void 0 : e.draggable) != null ? n : t.draggable,
    droppable: (s = e == null ? void 0 : e.droppable) != null ? s : t.droppable
  };
}
function xs(e) {
  if (!e)
    return !1;
  const t = e.data.current;
  return !!(t && "sortable" in t && typeof t.sortable == "object" && "containerId" in t.sortable && "items" in t.sortable && "index" in t.sortable);
}
const Tp = [V.Down, V.Right, V.Up, V.Left], kp = (e, t) => {
  let {
    context: {
      active: n,
      collisionRect: s,
      droppableRects: r,
      droppableContainers: o,
      over: i,
      scrollableAncestors: a
    }
  } = t;
  if (Tp.includes(e.code)) {
    if (e.preventDefault(), !n || !s)
      return;
    const c = [];
    o.getEnabled().forEach((h) => {
      if (!h || h != null && h.disabled)
        return;
      const g = r.get(h.id);
      if (g)
        switch (e.code) {
          case V.Down:
            s.top < g.top && c.push(h);
            break;
          case V.Up:
            s.top > g.top && c.push(h);
            break;
          case V.Left:
            s.left > g.left && c.push(h);
            break;
          case V.Right:
            s.left < g.left && c.push(h);
            break;
        }
    });
    const u = tg({
      active: n,
      collisionRect: s,
      droppableRects: r,
      droppableContainers: c,
      pointerCoordinates: null
    });
    let d = Ma(u, "id");
    if (d === (i == null ? void 0 : i.id) && u.length > 1 && (d = u[1].id), d != null) {
      const h = o.get(n.id), g = o.get(d), f = g ? r.get(g.id) : null, m = g == null ? void 0 : g.node.current;
      if (m && f && h && g) {
        const b = zs(m).some((D, R) => a[R] !== D), v = Xa(h, g), y = Ip(h, g), C = b || !v ? {
          x: 0,
          y: 0
        } : {
          x: y ? s.width - f.width : 0,
          y: y ? s.height - f.height : 0
        }, x = {
          x: f.left,
          y: f.top
        };
        return C.x && C.y ? x : Nn(x, C);
      }
    }
  }
};
function Xa(e, t) {
  return !xs(e) || !xs(t) ? !1 : e.data.current.sortable.containerId === t.data.current.sortable.containerId;
}
function Ip(e, t) {
  return !xs(e) || !xs(t) || !Xa(e, t) ? !1 : e.data.current.sortable.index < t.data.current.sortable.index;
}
const Ep = ({
  id: e,
  item: t,
  Item: n,
  ...s
}) => {
  const {
    attributes: r,
    listeners: o,
    setNodeRef: i,
    transform: a,
    transition: c
  } = $p({ id: e }), u = {
    transform: dt.Translate.toString(a),
    transition: c
  };
  return /* @__PURE__ */ l(
    n,
    {
      item: t,
      setNodeRef: i,
      style: u,
      listeners: o,
      ...r,
      ...s
    }
  );
}, Pp = (e) => {
  let {
    transform: t
  } = e;
  return {
    ...t,
    y: 0
  };
};
function _a(e, t, n) {
  const s = {
    ...e
  };
  return t.top + e.y <= n.top ? s.y = n.top - t.top : t.bottom + e.y >= n.top + n.height && (s.y = n.top + n.height - t.bottom), t.left + e.x <= n.left ? s.x = n.left - t.left : t.right + e.x >= n.left + n.width && (s.x = n.left + n.width - t.right), s;
}
const dr = (e) => {
  let {
    containerNodeRect: t,
    draggingNodeRect: n,
    transform: s
  } = e;
  return !n || !t ? s : _a(s, n, t);
}, Ap = (e) => {
  let {
    transform: t
  } = e;
  return {
    ...t,
    x: 0
  };
}, mi = (e) => {
  let {
    transform: t,
    draggingNodeRect: n,
    windowRect: s
  } = e;
  return !n || !s ? t : _a(t, n, s);
}, bi = {
  default: {
    modifiers: [dr],
    strategy: fo
  },
  vertical: {
    modifiers: [Ap, mi, dr],
    strategy: yp
  },
  horizontal: {
    modifiers: [Pp, mi, dr],
    strategy: vp
  }
}, Fp = ({
  items: e,
  setOrder: t,
  List: n = ({ children: d }) => d,
  Item: s,
  direction: r,
  // options = lookupVariant({ variant, horizontal, vertical }, variants),
  options: o = bi[r] || bi.default,
  modifiers: i = o.modifiers,
  strategy: a = o.strategy,
  Overlay: c,
  ...u
}) => ({ Context: ({ children: g }) => {
  const [f, m] = j(null), p = Zf(
    ni(co),
    ni(ao, {
      coordinateGetter: kp
    })
  );
  function b(C) {
    const x = e.findIndex((S) => S.id === C.active.id);
    m(x);
  }
  function v() {
    m(null);
  }
  function y(C) {
    const { active: x, over: S } = C;
    if (x.id !== S.id) {
      const D = e.findIndex((N) => N.id === x.id), R = e.findIndex((N) => N.id === S.id);
      e[D].moved = !0, t(ho(e, D, R));
    }
    m(null);
  }
  return /* @__PURE__ */ w(
    Yg,
    {
      sensors: p,
      collisionDetection: eg,
      onDragStart: b,
      onDragCancel: v,
      onDragEnd: y,
      modifiers: i,
      children: [
        /* @__PURE__ */ l(
          wp,
          {
            items: e,
            strategy: a,
            children: g
          }
        ),
        c && f && /* @__PURE__ */ l(gp, { children: /* @__PURE__ */ l(c, { item: f, ...u }) })
      ]
    }
  );
}, Content: () => /* @__PURE__ */ l(n, { ...u, children: e.map(
  (g) => /* @__PURE__ */ l(
    Ep,
    {
      id: g.id,
      item: g,
      Item: s,
      ...u,
      role: "drag"
    },
    g.id
  )
) }) }), go = (e) => {
  const { Context: t, Content: n } = Fp(e);
  return /* @__PURE__ */ l(t, { children: /* @__PURE__ */ l(n, {}) });
}, Vp = ({ ...e }) => /* @__PURE__ */ l(
  go,
  {
    ...e,
    direction: "vertical"
  }
), Bp = ({
  columns: e,
  visibleColumns: t,
  toggleVisibleColumn: n,
  columnOrder: s = Object.keys(e),
  columnsText: r = "Columns",
  columnsHelpClick: o = "Click checkbox to show/hide.",
  columnsHelpDrag: i = "Drag handle to order.",
  changeColumnOrder: a
}) => {
  const c = Nt(t), u = s.filter((h) => e[h]).map(
    (h) => kn(e[h], "id heading")
  );
  return /* @__PURE__ */ w(
    If,
    {
      right: !0,
      iconRight: "columns",
      text: r,
      size: "small",
      closeOnBlur: !1,
      triggerClass: "trigger pad-v-none",
      children: [
        /* @__PURE__ */ l("div", { className: "sortable list vertical", children: /* @__PURE__ */ l(
          Vp,
          {
            items: u,
            Item: Ef,
            setOrder: (h) => {
              a(
                h.map((g) => g.id)
              );
            },
            isVisible: c,
            toggleVisibleColumn: n
          }
        ) }),
        /* @__PURE__ */ w("div", { className: "smaller mar-b-2", children: [
          o,
          /* @__PURE__ */ l("br", {}),
          i
        ] }),
        /* @__PURE__ */ l(Af, {})
      ]
    }
  );
}, jp = _.Consumer(Bp), Ya = "cross", Wp = "datatable", tn = "filter", Ga = "filters", dn = "filtering", Hp = "filter-icon", Za = "heading", zp = "headings", Ja = "no-rows", Up = "selectable", po = "sorting", Kp = "has-filters", qp = "scroll-x", Xp = ({
  showFilters: e,
  toggleFilters: t,
  hasFilters: n,
  filterIcon: s = tn,
  filterText: r = (d) => d ? gu(d, "Filter") : "Filter",
  filteringIcon: o = tn,
  filterIconClass: i = Hp,
  filterTriggerClass: a = "small flex gap-2 middle trigger",
  filteringClass: c = dn,
  hasFiltersClass: u = Kp
}) => /* @__PURE__ */ w(
  "div",
  {
    className: M(
      a,
      {
        [c]: e,
        [u]: n
      }
    ),
    onClick: t,
    children: [
      re(r, n),
      /* @__PURE__ */ l(
        X,
        {
          className: i,
          name: e ? o : s
        }
      )
    ]
  }
), _p = _.Consumer(Xp), Yp = ({
  PageSize: e = Lf,
  Columns: t = jp,
  Filtering: n = _p,
  controlsClass: s = "controls flex center wrap gap-2 mar-b-1"
}) => /* @__PURE__ */ w("div", { className: s, children: [
  /* @__PURE__ */ l(n, {}),
  /* @__PURE__ */ l(t, {}),
  /* @__PURE__ */ l(e, {})
] }), Gp = _.Consumer(Yp), Zp = ({
  page: e,
  setPageNo: t,
  prevIcon: n = "arrow-left",
  prevLabel: s = el,
  nextIcon: r = "arrow-right",
  nextLabel: o = tl,
  navSize: i = "smaller",
  headerClass: a = "small flex space bottom gap-2",
  Summary: c = lh,
  Controls: u = Gp
}) => /* @__PURE__ */ w("header", { className: a, children: [
  /* @__PURE__ */ l(
    Se,
    {
      icon: n,
      size: i,
      disabled: e.pageNo <= e.firstPage,
      outline: !0,
      onClick: () => t(e.pageNo - 1),
      role: "navigation",
      label: re(s(e.pageNo - 1))
    }
  ),
  /* @__PURE__ */ w("div", { children: [
    /* @__PURE__ */ l(c, {}),
    /* @__PURE__ */ l(u, {})
  ] }),
  /* @__PURE__ */ l(
    Se,
    {
      icon: r,
      size: i,
      disabled: e.pageNo >= e.lastPage,
      outline: !0,
      onClick: () => t(e.pageNo + 1),
      role: "navigation",
      label: re(o(e.pageNo + 1))
    }
  )
] }), Jp = _.Consumer(Zp), hr = ({ value: e }) => T(e) ? e : "", Qp = ({ value: e }) => T(e) ? qt(e) : "", vi = ({ value: e }) => T(e) ? du(e) : "", em = ({ value: e }) => T(e) ? pu(e) : "", tm = ({ value: e, column: t }) => T(e) ? yr(e) ? t.trueText ?? aa : t.falseText ?? la : "", Qa = {
  default: hr,
  text: hr,
  id: hr,
  number: Qp,
  price: vi,
  currency: vi,
  boolean: tm,
  title: em
}, qe = {
  left: "text-left",
  right: "text-right",
  center: "text-center",
  centre: "text-center"
}, nm = ({
  row: e,
  column: t,
  name: n,
  value: s,
  rowIndex: r,
  cellIndex: o,
  cellClass: i,
  filters: a,
  sortColumn: c,
  sortingClass: u = po,
  filteringClass: d = dn,
  displayTypes: h = Qa
}) => {
  const g = t.type || "text", f = t.display || h[g] || h.default, m = c === n, p = M(
    i,
    re(t.className, { row: e, column: t, value: s, name: n, rowIndex: r, cellIndex: o }),
    m ? u : null,
    T(a[n]) ? d : null,
    t.right && qe.right,
    t.center && qe.center,
    t.align && qe[t.align]
  );
  return /* @__PURE__ */ l("td", { className: p, children: /* @__PURE__ */ l(
    f,
    {
      row: e,
      column: t,
      value: s,
      name: n,
      field: n,
      rowIndex: r,
      cellIndex: o
    }
  ) });
}, sm = _.Consumer(nm), rm = ({
  row: e,
  rowIndex: t,
  columns: n,
  rowClass: s,
  onRowClick: r = E,
  visibleColumns: o,
  Cell: i = sm
}) => /* @__PURE__ */ l(
  "tr",
  {
    className: re(s, { row: e, rowIndex: t }),
    onClick: () => r({ row: e, rowIndex: t }),
    children: o.filter((a) => n[a]).map(
      (a, c) => {
        const u = n[a], d = u.field ?? a, h = e[d];
        return /* @__PURE__ */ l(
          i,
          {
            row: e,
            rowIndex: t,
            index: c,
            name: a,
            field: d,
            column: u,
            value: h
          },
          a
        );
      }
    )
  }
), om = _.Consumer(rm), im = ({
  noRowsClass: e = Ja,
  noRowsText: t = "No rows selected",
  visibleColumns: n
}) => /* @__PURE__ */ l(
  "tr",
  {
    className: e,
    children: /* @__PURE__ */ l("td", { colSpan: n.length, children: t })
  }
), am = _.Consumer(im), lm = ({
  page: e,
  Row: t = om,
  NoRows: n = am
}) => /* @__PURE__ */ l("tbody", { children: e.rows.length ? e.rows.map(
  (s, r) => /* @__PURE__ */ l(
    t,
    {
      row: s,
      rowIndex: r
    },
    s.id ?? r
  )
) : /* @__PURE__ */ l(n, {}) }), cm = _.Consumer(lm), um = ({
  name: e,
  column: t,
  filters: n,
  sortColumn: s,
  sortReverse: r,
  toggleSortColumn: o,
  sortUpIcon: i = "arrow-up",
  sortDownIcon: a = "arrow-down",
  unsortedIcon: c = "arrows",
  sortIconClass: u = "sort-icon",
  sortingClass: d = po,
  headingClass: h = Za,
  filteringClass: g = dn
}) => {
  const f = e === s, m = f && r, p = t.sortable, b = p ? () => o(e) : null;
  return /* @__PURE__ */ l(
    "th",
    {
      className: M(
        h,
        f ? d : null,
        { sortable: p },
        T(n[e]) ? g : null,
        t.right && qe.right,
        t.center && qe.center,
        t.align && qe[t.align]
      ),
      onClick: b,
      children: /* @__PURE__ */ w("div", { className: "flex space middle", children: [
        /* @__PURE__ */ l("span", { className: "wide label", children: t.heading }),
        !!t.sortable && /* @__PURE__ */ l(
          X,
          {
            className: u,
            name: f ? m ? i : a : c
          }
        )
      ] })
    }
  );
}, dm = _.Consumer(um), hm = ({
  columns: e,
  headingsClass: t = zp,
  visibleColumns: n,
  Heading: s = dm
}) => /* @__PURE__ */ l("thead", { children: /* @__PURE__ */ l("tr", { className: t, children: n.filter((r) => e[r]).map(
  (r) => /* @__PURE__ */ l(
    s,
    {
      name: r,
      column: e[r]
    },
    r
  )
) }) }), fm = _.Consumer(hm), gm = ({
  value: e,
  setFilter: t,
  column: n,
  placeholder: s
}) => /* @__PURE__ */ l(
  Bn,
  {
    options: [
      { value: !0, text: n.trueText ?? aa },
      { value: !1, text: n.falseText ?? la }
    ],
    wide: !0,
    value: e,
    onUpdate: E,
    onSelect: (r) => t(r.value),
    placeholder: s
  }
), as = ({
  value: e,
  setFilter: t,
  type: n = "text",
  placeholder: s
}) => /* @__PURE__ */ l(
  "input",
  {
    type: n,
    value: e ?? "",
    onChange: (r) => t(r.target.value),
    placeholder: s
  }
), Ht = (e) => /* @__PURE__ */ l(as, { type: "number", ...e }), pm = ({
  value: e,
  setFilter: t,
  column: n,
  placeholder: s
}) => /* @__PURE__ */ l(
  Bn,
  {
    options: n.selectOptions || [],
    value: e,
    onUpdate: E,
    onSelect: (r) => t(
      n.selectValue ? n.selectValue(r) : ve(r) ? r.value : r
    ),
    placeholder: s,
    wide: !0
  }
), Jt = {
  default: as,
  string: as,
  text: as,
  id: Ht,
  number: Ht,
  integer: Ht,
  float: Ht,
  price: Ht,
  pounds: Ht,
  select: pm,
  boolean: gm
}, mm = ({
  name: e,
  column: t,
  filters: n,
  setFilter: s,
  filterClass: r = tn,
  filteringClass: o = dn,
  filterIcon: i = tn,
  clearFilterIcon: a = Ya
}) => {
  const c = t.filterComponent || Jt[t.filterType] || Jt[t.type] || Jt.default;
  return t.filterable ? /* @__PURE__ */ l(
    "th",
    {
      className: M(
        r,
        T(n == null ? void 0 : n[e]) ? o : null
      ),
      children: /* @__PURE__ */ w("div", { className: "flex space middle gap-1", children: [
        /* @__PURE__ */ l(
          c,
          {
            value: n[e] ?? "",
            setFilter: (u) => s(e, u),
            column: t,
            placeholder: t.filterPlaceholder || "Filter"
          }
        ),
        /* @__PURE__ */ l(
          X,
          {
            name: Dt(n[e]) || n[e] ? a : i,
            onClick: () => s(e, null)
          }
        )
      ] })
    }
  ) : /* @__PURE__ */ l("th", {});
}, bm = _.Consumer(mm), vm = ({
  columns: e,
  filtersClass: t = Ga,
  visibleColumns: n,
  Filter: s = bm
}) => /* @__PURE__ */ l("thead", { children: /* @__PURE__ */ l("tr", { className: t, children: n.filter((r) => e[r]).map(
  (r) => /* @__PURE__ */ l(
    s,
    {
      name: r,
      column: e[r]
    },
    r
  )
) }) }), Cm = _.Consumer(vm), ym = ({
  tableClass: e = "celled striped",
  selectableClass: t = Up,
  scrollX: n,
  onRowClick: s,
  showFilters: r,
  Headings: o = fm,
  Filters: i = Cm,
  Rows: a = cm
}) => /* @__PURE__ */ w(
  "table",
  {
    className: M(
      e,
      n ? "wide nowrap" : "wide",
      {
        [t]: s
      }
    ),
    children: [
      /* @__PURE__ */ l(o, {}),
      r && /* @__PURE__ */ l(i, {}),
      /* @__PURE__ */ l(a, {})
    ]
  }
), xm = _.Consumer(ym), wm = ({
  scrollX: e,
  Table: t = xm
}) => /* @__PURE__ */ l("div", { className: e ? qp : "", children: /* @__PURE__ */ l(t, {}) }), Sm = _.Consumer(wm), Rm = ({
  page: e = 0,
  pages: t,
  buttonClass: n = "outline",
  pageClass: s = n,
  currentPageClass: r = "solid",
  render: o,
  ...i
}) => {
  const u = t - 1, d = t, h = e + 1, g = e > 0 ? e - 1 : null, f = T(g) ? g + 1 : null, m = e < u ? e + 1 : null, p = T(m) ? m + 1 : null;
  return o({
    page: e,
    pageNo: h,
    firstPage: 0,
    firstPageNo: 1,
    lastPage: u,
    lastPageNo: d,
    pages: t,
    prevPage: g,
    prevPageNo: f,
    nextPage: m,
    nextPageNo: p,
    buttonClass: n,
    pageClass: s,
    currentPageClass: r,
    ...i
  });
}, bt = Xe(Rm), IC = bt.Use, Lm = (e) => `Go to page ${e}`, el = (e) => e ? `Previous page, page ${e}` : "No previous page", tl = (e) => e ? `Next page, page ${e}` : "No next page", Nm = ({
  prevPage: e,
  prevPageNo: t,
  setPage: n,
  buttonClass: s,
  prevClass: r = s,
  prevIcon: o = "arrow-left",
  prevLabel: i = el
}) => /* @__PURE__ */ l(
  Se,
  {
    className: r,
    icon: o,
    onClick: () => n(e),
    disabled: Ns(e),
    label: re(i, t)
  }
), Mm = bt.Consumer(Nm), Dm = ({
  nextPage: e,
  nextPageNo: t,
  setPage: n,
  buttonClass: s,
  nextClass: r = s,
  nextIcon: o = "arrow-right",
  nextLabel: i = tl
}) => /* @__PURE__ */ l(
  Se,
  {
    className: r,
    icon: o,
    onClick: () => n(e),
    disabled: !e,
    label: re(i, t)
  }
), $m = bt.Consumer(Dm), Om = ({
  pageNo: e,
  text: t = e,
  buttonClass: n,
  className: s = n,
  onClick: r,
  current: o,
  pageLabel: i = Lm
}) => /* @__PURE__ */ l(
  Se,
  {
    text: t,
    className: s,
    onClick: r,
    label: o ? null : re(i, e),
    "aria-current": o ? "page" : null
  }
), Tm = bt.Consumer(Om), km = /* @__PURE__ */ l(be, { children: "…" }), Im = ({
  pageSeparatorClass: e = "separator",
  pageSeparator: t = km
}) => /* @__PURE__ */ l(
  "div",
  {
    role: "separator",
    className: e,
    children: t
  }
), Em = bt.Consumer(Im), Pm = ({
  page: e,
  pageNo: t,
  firstPage: n,
  firstPageNo: s,
  prevPage: r,
  prevPageNo: o,
  nextPage: i,
  nextPageNo: a,
  lastPage: c,
  lastPageNo: u,
  setPage: d,
  pagesClass: h = "pages",
  buttonClass: g,
  pageClass: f = g,
  currentPageClass: m = "brand",
  showFirstLast: p = !0,
  Separator: b = Em,
  Page: v = Tm
}) => /* @__PURE__ */ w("div", { className: h, children: [
  p && r > n && /* @__PURE__ */ w(be, { children: [
    /* @__PURE__ */ l(
      v,
      {
        page: n,
        pageNo: s,
        className: f,
        onClick: () => d(n)
      }
    ),
    r > n + 1 && /* @__PURE__ */ l(b, {})
  ] }),
  T(r) && /* @__PURE__ */ l(
    v,
    {
      page: r,
      pageNo: o,
      className: f,
      onClick: () => d(r)
    }
  ),
  /* @__PURE__ */ l(
    v,
    {
      page: e,
      pageNo: t,
      className: m,
      current: !0,
      disabled: !0
    }
  ),
  T(i) && /* @__PURE__ */ l(
    v,
    {
      page: i,
      pageNo: a,
      className: f,
      onClick: () => d(i)
    }
  ),
  p && i && i < c && /* @__PURE__ */ w(be, { children: [
    i < c - 1 && /* @__PURE__ */ l(b, {}),
    /* @__PURE__ */ l(
      v,
      {
        page: c,
        pageNo: u,
        className: f,
        onClick: () => d(c)
      }
    )
  ] })
] }), Am = bt.Consumer(Pm), Fm = ({
  className: e = "pager",
  size: t,
  color: n,
  label: s = "Pagination navigation",
  Previous: r = Mm,
  Next: o = $m,
  Pages: i = Am
}) => /* @__PURE__ */ w(
  "div",
  {
    role: "navigation",
    "aria-label": s,
    className: M(e, t, n),
    children: [
      /* @__PURE__ */ l(r, {}),
      /* @__PURE__ */ l(i, {}),
      /* @__PURE__ */ l(o, {})
    ]
  }
), Vm = bt.Consumer(Fm), Bm = ({
  Content: e = Vm,
  ...t
}) => /* @__PURE__ */ l(bt.Provider, { ...t, children: /* @__PURE__ */ l(e, {}) }), jm = L(Bm, "Pager"), Wm = ({
  footerClass: e,
  pager: t = {},
  page: n,
  setPageNo: s,
  pagerSize: r = "small"
}) => /* @__PURE__ */ l("footer", { className: e, children: n.total > 0 && /* @__PURE__ */ l(
  jm,
  {
    page: n.page,
    pages: n.pages,
    setPage: (o) => s(o + 1),
    size: r,
    ...t
  }
) }), Hm = _.Consumer(Wm), zm = ({
  color: e,
  className: t = Wp,
  Header: n = Jp,
  Body: s = Sm,
  Footer: r = Hm
}) => /* @__PURE__ */ w("section", { className: M(t, e), children: [
  /* @__PURE__ */ l(n, {}),
  /* @__PURE__ */ l(s, {}),
  /* @__PURE__ */ l(r, {})
] }), Um = _.Consumer(zm), Km = ({
  Content: e = Um,
  ...t
}) => /* @__PURE__ */ l(_.Provider, { ...t, children: /* @__PURE__ */ l(e, {}) }), nl = L(Km, "DataTable"), qm = ({
  noRowsClass: e = Ja,
  noRowsText: t = "No rows selected"
}) => /* @__PURE__ */ l(
  "div",
  {
    className: e,
    children: t
  }
), Xm = ({
  row: e,
  column: t,
  name: n,
  value: s,
  rowIndex: r,
  cellIndex: o,
  cellClass: i,
  filters: a,
  sortColumn: c,
  sortReverse: u,
  sortUpIcon: d = "arrow-up",
  sortDownIcon: h = "arrow-down",
  unsortedIcon: g = "arrows",
  sortIconClass: f = "sort-icon",
  toggleSortColumn: m,
  headingClass: p = Za,
  sortingClass: b = po,
  filteringClass: v = dn,
  displayTypes: y = Qa
}) => {
  const C = t.type || "text", x = t.display || y[C] || y.default, S = c === n, D = S && u, R = t.sortable, N = R ? () => m(n) : null, k = [
    S ? b : null,
    T(a[n]) ? v : null,
    t.right && qe.right,
    t.center && qe.center,
    t.align && qe[t.align]
  ], O = M(
    "split-3",
    p,
    { sortable: R },
    ...k
  ), $ = M(
    i,
    re(t.className, { row: e, column: t, value: s, name: n, rowIndex: r, cellIndex: o }),
    ...k
  );
  return /* @__PURE__ */ w("tr", { children: [
    /* @__PURE__ */ l("th", { className: O, onClick: N, children: /* @__PURE__ */ w("div", { className: "flex space middle", children: [
      /* @__PURE__ */ l("span", { className: "wide label", children: t.heading }),
      !!R && /* @__PURE__ */ l(
        X,
        {
          className: f,
          name: S ? D ? d : h : g
        }
      )
    ] }) }),
    /* @__PURE__ */ l("td", { className: $, children: /* @__PURE__ */ l(
      x,
      {
        row: e,
        column: t,
        value: s,
        name: n,
        field: n,
        rowIndex: r,
        cellIndex: o
      }
    ) })
  ] });
}, _m = _.Consumer(Xm), Ym = ({
  row: e,
  rowIndex: t,
  columns: n,
  visibleColumns: s,
  tableClass: r = "wide celled shaded small"
}) => /* @__PURE__ */ l("table", { className: r, children: /* @__PURE__ */ l("tbody", { children: s.filter((o) => n[o]).map(
  (o, i) => {
    const a = n[o], c = a.field ?? o, u = e[c];
    return /* @__PURE__ */ l(
      _m,
      {
        row: e,
        rowIndex: t,
        index: i,
        name: o,
        field: c,
        column: a,
        value: u
      },
      o
    );
  }
) }) }), Gm = _.Consumer(Ym), Zm = ({
  name: e,
  column: t,
  filters: n,
  setFilter: s,
  filterClass: r = tn,
  filteringClass: o = dn,
  filterIcon: i = tn,
  clearFilterIcon: a = Ya
}) => {
  const c = t.filterComponent || Jt[t.filterType] || Jt[t.type] || Jt.default;
  return /* @__PURE__ */ w(
    "div",
    {
      className: M(
        r,
        "field mar-v-none",
        T(n == null ? void 0 : n[e]) ? o : null
      ),
      children: [
        /* @__PURE__ */ l("label", { children: t.heading }),
        /* @__PURE__ */ w("div", { className: "inputs", children: [
          /* @__PURE__ */ l(
            c,
            {
              value: n[e] ?? "",
              setFilter: (u) => s(e, u),
              column: t,
              placeholder: t.filterPlaceholder || "Filter"
            }
          ),
          /* @__PURE__ */ l("div", { className: "suffix", children: /* @__PURE__ */ l(
            X,
            {
              name: Dt(n[e]) || n[e] ? a : i,
              onClick: () => s(e, null)
            }
          ) })
        ] })
      ]
    }
  );
}, Jm = _.Consumer(Zm), Qm = ({
  minWidth: e,
  gap: t,
  children: n,
  className: s,
  tilesClass: r = "tiles",
  style: o = {}
}) => (e && (o["--tile-min-width"] = e), /* @__PURE__ */ l("div", { className: M(s, r, Kr(t)), style: o, children: n })), eb = L(Qm, "Tiles"), tb = ({
  columns: e,
  filtersClass: t = Ga,
  visibleColumns: n,
  Filter: s = Jm,
  minFilterWidth: r = "12rem",
  filterGap: o = "2"
}) => /* @__PURE__ */ l("div", { className: t, children: /* @__PURE__ */ l(eb, { minWidth: r, gap: o, children: n.filter((i) => {
  var a;
  return (a = e[i]) == null ? void 0 : a.filterable;
}).map(
  (i) => /* @__PURE__ */ l(
    s,
    {
      name: i,
      column: e[i]
    },
    i
  )
) }) }), nb = _.Consumer(tb), sb = ({
  page: e,
  showFilters: t,
  bodyClass: n = "grid-1 gap-4 mar-v-4",
  Filters: s = nb
}) => /* @__PURE__ */ w("div", { className: n, children: [
  !!t && /* @__PURE__ */ l(s, {}),
  e.rows.length ? e.rows.map(
    (r, o) => /* @__PURE__ */ l(
      Gm,
      {
        row: r,
        rowIndex: o
      },
      r.id ?? o
    )
  ) : /* @__PURE__ */ l(qm, {})
] }), sl = _.Consumer(sb), rb = ({
  breakpoint: e,
  ...t
}) => {
  const n = xd(e), { ref: s, width: r } = _l();
  return /* @__PURE__ */ l("div", { ref: s, children: /* @__PURE__ */ l(
    nl,
    {
      Body: r < n ? sl : void 0,
      ...t
    }
  ) });
}, EC = ({
  breakpoint: e,
  ...t
}) => e ? /* @__PURE__ */ l(
  rb,
  {
    breakpoint: e,
    ...t
  }
) : /* @__PURE__ */ l(
  nl,
  {
    Body: sl,
    ...t
  }
), Ci = sn(
  "value values"
);
var wt;
let ob = (wt = class extends Rt {
  constructor(t) {
    super(t);
    const n = this.initProps(t);
    this.state = {
      ...n
    };
  }
  initProps(t) {
    const { value: n = [], values: s = n, options: r = [], findOption: o, optionValue: i } = t;
    return { values: s.map(
      (c) => {
        const [u] = o(
          r,
          i(c)
        );
        return u;
      }
    ).filter(T) };
  }
  componentDidUpdate(t) {
    let n;
    if (this.props.options !== t.options ? n = vr(Ci, this.props, t) ? this.initProps(this.props) : this.initProps({ ...this.props, value: this.state.values }) : vr(Ci, this.props, t) && (n = this.initProps(this.props)), n) {
      const s = this.props.onUpdate || this.props.onChange;
      this.setState(
        n,
        () => s(n.values)
      );
    }
  }
  onSelect(t) {
    return this.debug("selected option:", t), this.debug("current values:", this.state.values), this.unselectMultiOption(t) || this.selectMultiOption(t);
  }
  optionIsSelected(t) {
    const [, n] = this.props.findOption(
      this.state.values,
      this.props.optionValue(t)
    );
    return T(n);
  }
  unselectMultiOption(t) {
    if (!T(t))
      return null;
    const [n, s] = this.props.findOption(
      this.state.values,
      this.props.optionValue(t)
    );
    if (!T(s))
      return this.debug("item is not selected:", t), !1;
    this.debug(`unselecting item at ${s}:`, n);
    const r = this.state.values.filter(
      (o, i) => i !== s
    );
    return this.setValues(r), !0;
  }
  selectMultiOption(t) {
    if (!T(t))
      return null;
    const [n, s] = this.props.findOption(
      this.props.options,
      this.props.optionValue(t)
    );
    if (!T(s))
      return this.debug("item is not selectable:", t), !1;
    this.debug(`selecting item at ${s}:`, n);
    const r = [...this.state.values, n];
    return this.setValues(r), !0;
  }
  setValues(t) {
    this.debug("setValues:", t), this.setState(
      { values: t },
      () => this.props.onChange(t)
    );
  }
}, I(wt, "debug", !1), I(wt, "debugPrefix", "MultiSelect > "), I(wt, "debugColor", "MediumVioletRed"), I(wt, "defaultProps", {
  findOption: na,
  optionValue: ta,
  displaySelection: Lt("displaySelection"),
  onChange: E
}), I(wt, "actions", [
  "onSelect",
  "optionIsSelected",
  "selectMultiOption",
  "unselectMultiOption",
  "setValues"
]), wt);
const Tt = Xe(ob), {
  Provider: AC,
  Consumer: FC,
  Use: VC
} = Tt, ib = ({
  option: e,
  optionClass: t = "option",
  selectedIcon: n = "check",
  unselectedIcon: s,
  noIconClass: r = "no-icon",
  displayOption: o = Lt("displayOption"),
  optionIsSelected: i
}) => /* @__PURE__ */ w("div", { className: t, children: [
  /* @__PURE__ */ l("div", { children: o(e) }),
  i(e) ? /* @__PURE__ */ l(X, { ...Uo(n) }) : s ? /* @__PURE__ */ l(X, { ...Uo(s) }) : /* @__PURE__ */ l("div", { className: r })
] }), ab = Tt.Consumer(ib);
var de;
let lb = (de = class extends ds {
  constructor(t) {
    super(t), this.state = {
      ...this.state,
      ...this.valueState(),
      closeOnBlur: !this.props.search
    }, this.debug(`search: ${this.props.search}  closeOnBlur: ${this.state.closeOnBlur}`);
  }
  componentDidUpdate(t) {
    let n;
    if (this.props.options !== t.options && (this.debug("options have changed, current value is", this.state.value), n = this.valueState(this.state.value)), this.props.value !== t.value && (this.debug(`value has changed from ${t.value} to ${this.props.value}`), n = this.valueState()), n) {
      const s = T(n.value) ? this.props.onUpdate || this.props.onSelect : E;
      this.setState(
        n,
        () => s(n.value)
      );
    }
  }
  initialCursor() {
    return this.state.cursor;
  }
  valueState(t = this.props.value) {
    const n = this.props.options, [s, r] = this.props.findOption(
      n,
      t
    );
    return { value: s, cursor: r, options: n };
  }
  selectState(t) {
    return {
      value: t,
      // input,
      selected: t
    };
  }
  closeState() {
    return {
      ...this.constructor.inactiveState,
      options: this.props.options
    };
  }
  onKeyDown(t) {
    if (this.debug(`onKeyDown(${t.key})`), !this.props.disabled) {
      switch (t.key) {
        case ks:
          this.state.isOpen ? this.setCursor(this.cursorNextIndex()) : this.open(this.initialCursor() ?? this.cursorFirstIndex());
          break;
        case Ts:
          this.state.isOpen ? this.setCursor(this.cursorPrevIndex()) : this.open(this.initialCursor() ?? this.cursorLastIndex());
          break;
        case Is:
          this.state.isOpen ? this.selectCursor() : this.open(this.initialCursor() ?? this.cursorFirstIndex());
          break;
        case Es:
          this.close();
          break;
        case hh:
          this.debug("backspace"), this.searchBackspace();
          break;
        case dh:
          return;
        case Jr:
          if (this.state.isOpen) {
            if (!(this.state.searchInput ?? Yt).length)
              break;
          } else {
            this.debug("space to open"), this.open(this.cursorFirstIndex());
            break;
          }
        default:
          if (this.debug("default keypress"), t.altKey || t.ctrlKey || t.metaKey)
            return;
          if (t.key.length === 1) {
            this.debug(`typed key ${t.key}`), this.searchKey(t.key), this.state.open || this.open(), this._searchRef && this._searchRef.focus();
            break;
          }
          this.debug(`ignored key ${t.key}`);
          return;
      }
      t.preventDefault();
    }
  }
  searchRef(t) {
    this.debug("searchRef()"), this._searchRef = t;
  }
  focusSearch(t) {
    this.debug("focusSearch()"), t == null || t.stopPropagation(), this.setState({ searchFocus: !0 });
  }
  blurSearch() {
    this.debug("blurSearch()"), this.setState({ searchFocus: !1 }), this.closeSoon();
  }
  setSearch(t) {
    this.setState(
      { searchInput: t },
      () => this.searchOptions()
    );
  }
  searchKey(t) {
    this.setSearch(
      (this.state.searchInput ?? Yt) + t
    );
  }
  searchBackspace() {
    this.setSearch(
      T(this.state.searchInput) && this.state.searchInput.length > 1 ? this.state.searchInput.slice(0, -1) : void 0
    );
  }
  clearSearch(t) {
    t == null || t.preventDefault(), t == null || t.stopPropagation(), this._searchRef && (this.debug("re-focussing search input"), this._searchRef.focus()), this.setSearch(void 0);
  }
  searchOptions() {
    this.debug("searchOptions(), searchInput: ", this.state.searchInput);
    const { options: t, searchOptions: n } = this.props;
    this.setState(
      (s) => ({
        options: T(s.searchInput) ? n(s.searchInput, this.props.options.filter(this.props.validOption)) : t,
        cursor: 0
      })
    );
  }
  closeable(t) {
    return this.debug(`closeable()  force:${t}  hasHover:${this.state.hasHover}  searchFocus:${this.state.searchFocus}`), t || !(this.state.hasHover || this.state.searchFocus);
  }
  menuOptions() {
    return this.state.options;
  }
}, I(de, "debug", !1), I(de, "debugPrefix", "Select > "), I(de, "debugColor", "MediumVioletRed"), I(de, "defaultProps", {
  ...de.defaultProps,
  options: [],
  search: !1,
  findOption: na,
  validOption: In,
  searchOptions: ud,
  displayValue: Lt("displayValue"),
  displayOption: Lt("displayOption"),
  displayHeading: Lt("displayHeading")
}), // NOTE: we don't want to reset the cursor or value when closing
I(de, "inactiveState", {
  isOpen: !1,
  selected: void 0,
  searchInput: void 0
}), I(de, "initialState", {
  value: Yt,
  cursor: void 0,
  ...de.inactiveState
}), I(de, "initialProps", {
  // value: 'initialValue',
}), I(de, "actions", [
  "onFocus",
  "onBlur",
  "onClick",
  "onKeyDown",
  "open",
  "close",
  "setCursor",
  "selectCursor",
  "selectOption",
  "menuRef",
  "activeRef",
  "searchRef",
  "focusSearch",
  "blurSearch",
  "setSearch",
  "clearSearch"
]), de);
const De = Xe(lb), {
  Provider: BC,
  Consumer: jC,
  Use: WC
} = De, cb = ({
  value: e,
  onFocus: t,
  onBlur: n,
  onClick: s,
  placeholder: r = "Select",
  placeholderClass: o = "placeholder",
  inputsClass: i = "inputs",
  inputClass: a = "input",
  suffixClass: c = "suffix",
  displayValue: u,
  disabled: d
}) => /* @__PURE__ */ w(
  "div",
  {
    className: i,
    onClick: d ? null : s,
    children: [
      /* @__PURE__ */ l(
        "div",
        {
          onFocus: d ? null : t,
          onBlur: d ? null : n,
          disabled: d,
          className: a,
          tabIndex: 0,
          children: T(e) ? u(e) ?? /* @__PURE__ */ l(be, { children: " " }) : /* @__PURE__ */ l("span", { className: o, children: r })
        }
      ),
      /* @__PURE__ */ l("div", { className: c, children: /* @__PURE__ */ l(X, { name: "angle-down" }) })
    ]
  }
), ub = De.Consumer(cb), db = ({
  option: e,
  optionClass: t = "item no-hover",
  headingClass: n = "heading",
  displayHeading: s
}) => /* @__PURE__ */ l(
  "div",
  {
    className: M(
      t,
      n,
      e.indent ? `indent-${e.indent}` : null
    ),
    children: s(e)
  }
), hb = De.Consumer(db), fb = ({
  option: e,
  active: t,
  activeRef: n,
  selected: s,
  onClick: r,
  onMouseEnter: o,
  validOption: i,
  displayOption: a,
  optionClass: c = "item no-hover",
  activeClass: u = "active",
  selectedClass: d = "selected",
  disabledClass: h = "disabled"
}) => /* @__PURE__ */ l(
  "div",
  {
    className: M(
      c,
      e.className,
      e.indent ? `indent-${e.indent}` : null,
      t ? u : null,
      s ? d : null,
      i(e) ? null : h
    ),
    onMouseEnter: o,
    onClick: r,
    ref: t ? n : null,
    "aria-disabled": e.disabled,
    children: a(e)
  }
), gb = De.Consumer(fb), pb = ({
  separatorClass: e = "separator"
}) => /* @__PURE__ */ l("div", { className: e }), mb = De.Consumer(pb), bb = ({
  option: e,
  Heading: t = hb,
  Separator: n = mb,
  Option: s = gb,
  ...r
}) => e.heading ? /* @__PURE__ */ l(t, { option: e, ...r }) : e.separator ? /* @__PURE__ */ l(n, { option: e, ...r }) : /* @__PURE__ */ l(s, { option: e, ...r }), vb = De.Consumer(bb), Cb = ({
  noOptionsClass: e = "none",
  noOptions: t = "No options"
}) => /* @__PURE__ */ l("div", { className: e, children: t }), yb = De.Consumer(Cb), xb = ({
  options: e,
  menuRef: t,
  menuClass: n = "menu border bdr-1",
  cursor: s,
  selected: r,
  selectOption: o,
  setCursor: i,
  // Option=SelectOption,
  Item: a = vb,
  NoOptions: c = yb
}) => /* @__PURE__ */ l(
  "div",
  {
    className: n,
    ref: t,
    children: Fe(e) && e.length ? e.map(
      (u, d) => /* @__PURE__ */ l(
        a,
        {
          option: u,
          active: T(s) && e[s] === u,
          selected: r === u,
          onClick: () => o(u),
          onMouseEnter: () => i(d)
        },
        u.id ?? u.value ?? d
      )
    ) : /* @__PURE__ */ l(c, {})
  }
), wb = De.Consumer(xb), Sb = ({
  searchInput: e,
  focusSearch: t,
  blurSearch: n,
  searchRef: s,
  setSearch: r,
  clearSearch: o,
  searchPlaceholder: i = "Search",
  searchFieldClass: a = "search field",
  searchInputsClass: c = "inputs",
  searchPrefixClass: u = "shaded lined prefix",
  searchSuffixClass: d = "shaded lined suffix",
  searchClearClass: h = "clear",
  inputClass: g,
  searchIcon: f = "search",
  clearSearchIcon: m = "cross"
}) => /* @__PURE__ */ l("div", { className: a, children: /* @__PURE__ */ w("div", { className: c, children: [
  /* @__PURE__ */ l("div", { className: u, children: /* @__PURE__ */ l(
    X,
    {
      name: f
    }
  ) }),
  /* @__PURE__ */ l(
    "input",
    {
      ref: s,
      className: g,
      type: "text",
      placeholder: i,
      value: e ?? "",
      onClick: (p) => p.stopPropagation(),
      onChange: (p) => r(p.target.value),
      onFocus: t,
      onBlur: n,
      autoComplete: "chrome-is-broken",
      tabIndex: "0"
    }
  ),
  /* @__PURE__ */ l(
    "div",
    {
      className: M(d, e ? h : null),
      onClick: o,
      children: /* @__PURE__ */ l(
        X,
        {
          name: m
        }
      )
    }
  )
] }) }), Rb = De.Consumer(Sb), Lb = ({
  onKeyDown: e,
  isOpen: t,
  search: n,
  selectClass: s = "select",
  openClass: r = "open",
  closedClass: o = "closed",
  Input: i = ub,
  Search: a = Rb,
  Menu: c = wb,
  wide: u
}) => /* @__PURE__ */ w(
  "div",
  {
    className: M(
      s,
      t ? r : o,
      { wide: u }
    ),
    onKeyDown: e,
    children: [
      /* @__PURE__ */ l(i, {}),
      !!t && !!n && /* @__PURE__ */ l(a, {}),
      !!t && /* @__PURE__ */ l(c, {})
    ]
  }
), Nb = De.Consumer(Lb), Mb = ({
  Content: e = Nb,
  ...t
}) => /* @__PURE__ */ l(De.Provider, { ...t, children: /* @__PURE__ */ l(e, {}) }), Bn = L(Mb, "Select"), Db = ({
  selection: e,
  displaySelection: t,
  unselectMultiOption: n,
  selectionClass: s = "selection",
  unselectIcon: r = "cross",
  dragHandle: o
}) => /* @__PURE__ */ w(
  "div",
  {
    className: s,
    onClick: () => n(e),
    children: [
      o,
      /* @__PURE__ */ l(
        mt,
        {
          iconRight: r,
          children: t(e)
        }
      )
    ]
  }
), rl = Tt.Consumer(Db), $b = ({
  values: e,
  selectionsClass: t = "selections",
  Selection: n = rl
}) => /* @__PURE__ */ l("div", { className: t, children: e.map(
  (s, r) => /* @__PURE__ */ l(
    n,
    {
      selection: s
    },
    r
  )
) }), Ob = Tt.Consumer($b), Tb = ({
  values: e,
  setValues: t,
  selectionsClass: n = "selections",
  dragIcon: s = "move",
  dragIconClass: r = "drag-icon",
  Selection: o = rl
}) => {
  const i = (c) => t(
    c.map((u) => u.value)
  ), a = ({
    item: c,
    setNodeRef: u,
    style: d,
    listeners: h,
    ...g
  }) => /* @__PURE__ */ l(
    "div",
    {
      ref: u,
      style: d,
      className: `sortable item ${c.moved ? "moved" : ""}`,
      ...g,
      children: /* @__PURE__ */ l(
        o,
        {
          selection: c.value,
          dragHandle: /* @__PURE__ */ l("div", { className: r, ...h, children: /* @__PURE__ */ l(X, { name: s }) })
        }
      )
    }
  );
  return /* @__PURE__ */ l("div", { className: n, children: /* @__PURE__ */ l(
    go,
    {
      items: e.map(
        (c, u) => ({ id: u + 1, value: c })
      ),
      Item: a,
      setOrder: i
    }
  ) });
}, kb = Tt.Consumer(Tb), Ib = ({
  className: e = "multiselect",
  sortable: t,
  Option: n = ab,
  Select: s = Bn,
  Selections: r = Ob,
  SortSelections: o = kb,
  ...i
}) => /* @__PURE__ */ w("div", { className: e, children: [
  /* @__PURE__ */ l(
    s,
    {
      ...i,
      onUpdate: E,
      displayOption: (a) => /* @__PURE__ */ l(n, { option: a })
    }
  ),
  t ? /* @__PURE__ */ l(o, {}) : /* @__PURE__ */ l(r, {})
] }), Eb = Tt.Consumer(Ib), Pb = ({
  Content: e = Eb,
  ...t
}) => /* @__PURE__ */ l(Tt.Provider, { ...t, children: /* @__PURE__ */ l(e, {}) }), Ab = L(Pb, "MultiSelect");
var Fb = Object.defineProperty, Vb = (e, t, n) => t in e ? Fb(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Ee = (e, t, n) => (Vb(e, typeof t != "symbol" ? t + "" : t, n), n), Bb = Object.defineProperty, jb = (e, t, n) => t in e ? Bb(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, fr = (e, t, n) => jb(e, typeof t != "symbol" ? t + "" : t, n);
function Wb(e = {}, t = {}, n = {}) {
  return Object.entries(t).reduce(
    (s, [r, o]) => {
      const i = n[o];
      return i !== null && typeof i < "u" && (s[r] = i), s;
    },
    { ...e }
  );
}
function Hb(e, t = []) {
  return (typeof t == "string" ? t.split(/,\s*|\s+/) : t).reduce(
    (n, s) => {
      const r = e[s] || qb(`Cannot expose non-existent action method: ${s}`);
      return n[s] = r.bind(e), n;
    },
    {}
  );
}
function zb(e, t) {
  const n = e.debug ?? t.debug, s = yi(e.debugPrefix ?? t.debugPrefix, e), r = yi(e.debugColor ?? t.debugColor, e);
  return n ? s ? (o, ...i) => console.log(
    `%c${s}%c${o}`,
    `color: ${r}`,
    "color:black",
    ...i
  ) : console.log.bind(console) : () => {
  };
}
function Ub(e) {
  return Array.isArray(e);
}
function ol(e) {
  return typeof e == "function";
}
function yi(e, t) {
  return ol(e) ? e(t) : e;
}
function Kb(e) {
  return Ub(e) ? e : [e];
}
function qb(...e) {
  throw new Error(e.join(""));
}
const il = (e, t = {}, n = F.createContext(t)) => ({ Context: n, Provider: (s) => /* @__PURE__ */ l(
  e,
  {
    ...s,
    render: (r) => /* @__PURE__ */ l(n.Provider, { value: r, children: s.children })
  }
), Consumer: (s) => (r) => /* @__PURE__ */ l(n.Consumer, { children: (o) => /* @__PURE__ */ l(s, { ...o, ...r }) }), Children: ({ children: s }) => Kb(s).map(
  (r, o) => ol(r) ? /* @__PURE__ */ l(n.Consumer, { children: r }, o) : r
), Use: () => F.useContext(n) });
let ls = class extends F.Component {
  constructor(e) {
    super(e);
    const t = this.constructor;
    this.debug = zb(e, t), this.state = Wb(
      t.initialState,
      t.initialProps,
      e
    ), this.actions = Hb(this, t.actions);
  }
  getContext() {
    return {
      ...this.props,
      // properties passed to the context
      ...this.state,
      // internal state
      ...this.actions
      // callable action functions mapped to methods
    };
  }
  getRenderProps() {
    return this.getContext();
  }
  render() {
    return this.props.render(
      this.getRenderProps()
    );
  }
};
fr(ls, "initialState", {}), fr(ls, "initialProps", {}), fr(ls, "actions", []);
function mo(e) {
  return typeof e == "boolean";
}
function kt(e) {
  return typeof e == "string";
}
function Xb(e) {
  return typeof e == "number";
}
function Dn(e) {
  return Array.isArray(e);
}
function qs(e) {
  return typeof e == "function";
}
function _b(e) {
  return e instanceof RegExp;
}
function jn(e) {
  return typeof e == "object" && !Dn(e) && !al(e);
}
function Yb(e) {
  return kt(e) || Xb(e) || mo(e);
}
function Gb(e) {
  return e === void 0;
}
function al(e) {
  return e === null;
}
function pe(e) {
  return !(Gb(e) || al(e));
}
function Zb(e) {
  return !pe(e);
}
function Jb(...e) {
  throw new Error(e.join(""));
}
const xi = (e, ...t) => qs(e) ? e(...t) : e;
function Qt() {
}
function Qb() {
  return Intl.DateTimeFormat().resolvedOptions().locale;
}
Qb();
function ll(e, t = /,\s*|\s+/) {
  return Zb(e) ? [] : kt(e) ? e.length ? e.split(t) : [] : Dn(e) ? e : [e];
}
function cl(e, t = !0, n = {}) {
  return jn(e) ? e : ll(e).reduce((s, r) => (s[r] = qs(t) ? t(r) : t, s), n);
}
function ev(e) {
  if (qs(e))
    return e;
  if (_b(e))
    return (t) => e.test(t);
  if (jn(e))
    return (t) => !!e[t];
  if (Dn(e) || kt(e)) {
    const t = cl(e);
    return (n) => !!t[n];
  }
  Jb("Invalid selector() specification: " + e);
}
const tv = (e, t, n = {}) => {
  let s = {}, r = { delete: !1, ...n };
  const o = ev(t);
  return Object.keys(e).map((i) => {
    if (o(i)) {
      let a = e[i];
      r.delete && delete e[i], r.key && (i = r.key(i)), r.value && (a = r.value(a)), s[i] = a;
    }
  }), s;
}, nv = "", sv = "blur", Wn = "changed", rv = "disabled", Xs = "focus", ov = "fulfilled", Hn = "invalid", ul = "Optional", iv = "radio", dl = "Required", av = "A value is required", wi = "reset", zn = "submitted", hn = "submitting", bo = "text", lv = "unvalidated", Un = "valid", vt = "validating", cv = [
  "id",
  "name",
  "type",
  "value",
  "checked",
  "disabled",
  "placeholder",
  "autoComplete",
  "onFocus",
  "onBlur",
  "size",
  "rows",
  "min",
  "max",
  "step",
  "minLength",
  "maxLength",
  "pattern",
  "list"
], uv = [
  "id",
  "name",
  "action",
  "method",
  "encType"
];
let hl = class extends ls {
  constructor(e) {
    super(e), this.newStatus = this.constructor.newStatus(e), this.state = {
      status: this.newStatus(wi)
    };
  }
  setStatus(e, t = {}, n = Qt) {
    this.mounted && this.setState(
      (s) => ({
        ...qs(t) ? t(s) : t,
        status: this.newStatus(e, s.status)
      }),
      n
    );
  }
  setResetState(e, t) {
    this.setStatus(wi, e, t);
  }
  setChangedState(e, t) {
    this.setStatus(Wn, e, t);
  }
  setValidatingState(e, t) {
    this.setStatus(vt, e, t);
  }
  setInvalidState(e, t) {
    this.setStatus(Hn, e, t);
  }
  setValidState(e, t) {
    this.setStatus(Un, e, t);
  }
  setUnvalidatedState(e, t) {
    this.setStatus(lv, e, t);
  }
};
function fl(e, t) {
  return t.reduce(
    (n, s) => {
      const r = e[s] || e[s.toLowerCase()];
      return pe(r) && (n[s] = r), n;
    },
    {}
  );
}
const _s = (e) => fl(e, cv), dv = (e) => fl(e, uv), gl = (e) => e.filter(pe).join(" "), hv = (e) => Object.entries(e).filter(([, t]) => t).map(([t]) => t), Be = (...e) => gl(
  e.flatMap(
    (t) => jn(t) ? hv(t) : t
  )
), Ys = (e, ...t) => Be(e.inputClass, e.inline && "inline", ...t), _t = (e, t, n = t) => (e == null ? void 0 : e[t]) || n, fv = (e, t = {}, ...n) => gl(
  Object.entries(e).reduce(
    (s, [r, o]) => (o && s.push(t[r] || r), s),
    [...n]
  )
), gv = (e) => {
  const {
    status: t,
    className: n,
    classes: s,
    required: r,
    showRequired: o,
    showOptional: i
    // inline
  } = e;
  return fv(
    t,
    s,
    _t(s, "field"),
    n,
    // inline ? 'inline' : null,
    o && r ? "required" : null,
    i && !r ? "optional" : null
  );
}, pl = (e, ...t) => {
  const { gap: n, space: s, stack: r, className: o } = e;
  return o || (s ? Be("flex", "space", ...t) : Be(
    "flex",
    n ? `gap-v-none gap-h-${n}` : null,
    r ? `stack-${r}` : null,
    ...t
  ));
}, pv = (e, ...t) => {
  const { grid: n, gap: s, stack: r, className: o } = e;
  return o || (n ? Be(
    `grid-${n}`,
    s ? `gap-v-none gap-h-${s}` : null,
    r ? `stack-${r}` : null,
    ...t
  ) : Be(...t));
}, mv = {
  boolean: !0,
  string: !0,
  number: !0
}, ml = (e) => mv[typeof e] ? { value: e, text: e } : e, ws = (...e) => function(...t) {
  for (let n of e.filter(Boolean))
    n(...t);
};
function Si(e) {
  if (mo(e))
    return [1, !1];
  if (pe(e)) {
    const t = (e == null ? void 0 : e.toString().length) ?? 0;
    return [t, t === 0];
  }
  return [0, !0];
}
const bv = (e, t) => kt(e) ? { [t]: e } : e, bl = (e) => e.replaceAll(/\W+/g, "").toLowerCase(), vv = {
  submittingClass: hn,
  validatingClass: vt,
  resetOnSuccess: !0,
  focusInvalidField: !0,
  enctype: "application/x-www-form-urlencoded",
  method: "post",
  errorsTitle: (e) => `Form Error${e > 1 ? "s" : ""}`,
  errorsPrompt: (e) => `Please correct ${e === 1 ? "this problem" : "these problems"} and re-submit:`
}, Ri = {
  validateOnChange: !1,
  validateOnBlur: !1,
  validateOnInvalid: !0,
  showRequired: !1,
  showOptional: !1,
  validMessage: null,
  minValidateLength: 1,
  requiredMessage: av,
  requiredLabel: dl,
  optionalLabel: ul
}, Cv = cl([
  "showRequired",
  "requiredLabel",
  "showOptional",
  "optionalLabel",
  "validateOnChange",
  "validateOnBlur",
  "validateOnInvalid",
  "minValidateLength",
  "validMessage",
  "requiredMessage",
  "classes",
  "wide"
]), nn = {
  [Un]: !1,
  [Hn]: !1
}, yv = {
  ...nn,
  [Wn]: !0
}, xv = {
  ...nn,
  [vt]: !0
}, wv = {
  [Un]: !1,
  [Hn]: !0,
  [vt]: !1
}, Sv = {
  [Un]: !0,
  [Hn]: !1,
  [vt]: !1
}, Rv = {
  [Xs]: !1
}, Lv = {
  [Xs]: !0
}, Nv = {
  [hn]: !0,
  [zn]: !1
}, Mv = {
  [hn]: !1,
  [zn]: !0
}, vl = {
  changed: yv,
  validating: xv,
  invalid: wv,
  valid: Sv
}, Cl = (e) => (t, n = {}) => ({
  ...n,
  ...e[t] || { [t]: !0 }
}), Dv = () => {
  const e = {
    ...nn,
    [Wn]: !1,
    [vt]: !1,
    [zn]: !1,
    [hn]: !1
  };
  return Cl({
    ...vl,
    reset: e,
    submitting: Nv,
    submitted: Mv,
    unvalidated: nn
  });
}, $v = (e = {}) => {
  const t = {
    ...nn,
    [Wn]: !1,
    [vt]: !1,
    [Xs]: !1,
    [rv]: e.disabled || !1
  };
  return Cl({
    ...vl,
    reset: t,
    focus: Lv,
    blur: Rv,
    unvalidated: nn
  });
}, Ov = ({
  status: e,
  not: t = !1,
  any: n = !1,
  ...s
}) => {
  const r = [Wn, vt, Un, Hn, hn, zn].filter((i) => pe(s[i])).map((i) => e[i]), o = n ? r.some(Boolean) : r.every(Boolean);
  return t ? !o : o;
};
class zt extends hl {
  constructor(t) {
    super(t), this.fields = {};
    const {
      // fields={ },
      hidden: n = {}
    } = t, s = { ...n }, r = {
      ...vv,
      ...this.props
    };
    this.state = {
      // ...formDefaultProperties,
      ...r,
      ...this.state,
      initialValues: s,
      values: { ...s },
      errors: [],
      error: null
    }, this.props.onLoad && this.props.onLoad(this);
  }
  componentDidMount() {
    this.debug("componentDidMount()"), this.mounted = !0;
  }
  componentWillUnmount() {
    this.debug("componentWillUnmount()"), this.mounted = !1;
  }
  // Fields
  fieldSpec(t, n) {
    var s, r;
    const o = ((s = this.props.fields) == null ? void 0 : s[t]) ?? {}, i = n.value ?? ((r = this.props.values) == null ? void 0 : r[t]);
    return {
      name: t,
      ...tv(this.props, Cv),
      ...o,
      ...n,
      value: i
    };
  }
  attachField(t, n) {
    this.debug(`attaching ${t} field`), this.fields[t] = n, this.setState(
      (s) => ({
        values: {
          ...s.values,
          [t]: n.state.value
        }
      })
    );
  }
  detachField(t) {
    this.debug(`detaching ${t} field`), delete this.fields[t];
  }
  setSubmittingState(t, n) {
    this.setStatus(hn, t, n);
  }
  setSubmittedState(t, n) {
    this.setStatus(zn, t, n);
  }
  //--------------------------------------------------------------------------
  // Field focus
  //--------------------------------------------------------------------------
  setFocus(t, n) {
    var s;
    n == null || n.preventDefault(), (s = this.fields[t]) == null || s.setFocus();
  }
  //--------------------------------------------------------------------------
  // Set/Reset
  //--------------------------------------------------------------------------
  reset(t) {
    this.mounted && (this.debug("reset()"), t == null || t.preventDefault(), this.resetFields(), this.setResetState(
      {
        errors: [],
        error: null
      },
      this.props.onReset
    ));
  }
  resetFields() {
    this.debug("resetFields()"), Object.values(this.fields).forEach(
      (t) => t.reset()
    );
  }
  setValue(t, n) {
    this.debug(`setValue(${t}, ${n})`), this.setChangedState(
      (s) => ({
        ...s,
        values: {
          ...s.values,
          [t]: n
        }
      })
    );
  }
  setValues(t, n) {
    this.debug("setValues():", t), n == null || n.preventDefault(), Object.entries(t).forEach(
      ([s, r]) => {
        var o;
        return (o = this.fields[s]) == null ? void 0 : o.setValue(r);
      }
    );
  }
  setHidden(t) {
    const n = {
      ...this.state.hidden,
      ...t
    };
    this.setState({ hidden: n });
  }
  //--------------------------------------------------------------------------
  // Submit
  //--------------------------------------------------------------------------
  submit(t) {
    this.debug("submit()"), t == null || t.preventDefault(), this.validate().then((n) => this.handleSubmit(n)).catch((n) => this.debug("Form is NOT valid:", n));
  }
  validate() {
    return this.debug("validate()"), this.setValidatingState(), new Promise(this.validator()).then(
      (t) => (this.debug("validate passed: ", t), this.setValidState(
        { submit: t, error: null, errors: [] },
        this.props.onValid
      ), t)
    ).catch(
      (t) => {
        throw this.debug("validate failed: ", t), this.handleError({
          error: t.error,
          errors: t.errors
        }), t;
      }
    );
  }
  validator() {
    return (t, n) => Promise.allSettled(
      Object.values(this.fields).map(
        (s) => s.validate()
      )
    ).then(
      (s) => s.reduce(
        (r, { status: o, value: i, reason: a }) => (o === ov ? Object.assign(
          r.values,
          i.data || { [i.name]: i.value }
        ) : r.errors.push(a), r),
        {
          values: { ...this.state.values },
          errors: []
        }
      )
    ).then(
      (s) => {
        var r;
        return this.debug("field validation complete: ", s), (r = s.errors) != null && r.length ? (this.debug("errors detected, rejecting: ", s), n(s)) : this.props.validate ? (this.debug("validating form: ", s), this.props.validate(
          s.values,
          this.getContext()
        ).then((o) => t({ ...s, values: o })).catch((o) => n(o))) : t(s);
      }
    );
  }
  unvalidate() {
    Object.values(this.fields).map(
      (t) => t.unvalidate()
    ), this.setUnvalidatedState();
  }
  handleSubmit(t) {
    if (this.debug("Form is valid, handling submission:", t), !this.props.onSubmit) {
      window.alert(
        "You haven't defined an onSubmit handler: " + JSON.stringify(t.values)
      );
      return;
    }
    this.setSubmittingState(
      {},
      async () => {
        this.debug("calling onSubmit handler: ", t);
        try {
          const n = await this.props.onSubmit(t.values, this.getContext());
          if (this.debug("onSubmit response:", n), this.setSubmittedState(), n != null && n.ok || (n == null ? void 0 : n.status) === 200)
            this.debug(`Success response ok:${n == null ? void 0 : n.ok} status:${n == null ? void 0 : n.status}`), this.handleSuccess(n);
          else if ((n == null ? void 0 : n.status) >= 400 && n.status <= 500)
            this.debug(`Error response status:${n == null ? void 0 : n.status}`), this.handleError(n.data);
          else
            throw new Error(`Unknown response: ${n == null ? void 0 : n.status}`);
        } catch (n) {
          this.debug("onSubmit error:", n), this.setSubmittedState(), this.handleError(
            kt(n) ? { error: n } : n instanceof Error ? { error: n.message } : n
          );
        }
      }
    );
  }
  handleSuccess(t) {
    this.debug("handleSuccess()", t);
    const n = this.props.onSuccess || Qt;
    this.setValidState(
      {},
      ws(
        () => n(t, this),
        this.props.resetOnSuccess && (() => this.reset()),
        this.props.unvalidateOnSuccess && (() => this.unvalidate())
      )
    );
  }
  handleError(t = {}) {
    this.debug("handleError()", t), t.errors && (t.errors = this.sanitiseErrors(t.errors));
    const n = Dn(t == null ? void 0 : t.errors) && this.fieldErrors(t.errors), s = this.props.onError || this.props.onFailure || Qt;
    this.setInvalidState(
      t,
      ws(
        () => s(t),
        n ? () => n.setFocus() : null
      )
    );
  }
  fieldErrors(t) {
    this.debug("fieldErrors: ", t);
    const n = t.reduce(
      (s, r) => {
        const o = r.name ?? r.param ?? r.field, { message: i } = r, a = o && this.fields[o];
        return a && (r.label || (r.label = a.props.label), a.setInvalidState({ message: i }), s.push(a)), s;
      },
      []
    );
    return this.state.focusInvalidField && n.length ? n[0] : null;
  }
  sanitiseErrors(t) {
    if (jn(t) && (t = Object.entries(t).map(
      ([n, s]) => ({
        name: n,
        ...bv(s, "message")
      })
    )), !Dn(t))
      throw new Error("Invalid errors type (not an array or object)");
    return t.forEach(
      (n) => n.message ?? (n.message = n.error)
    ), t;
  }
  //--------------------------------------------------------------------------
  // render
  //--------------------------------------------------------------------------
  getContext() {
    return {
      // ...formDefaultProperties,
      ...this.props,
      // properties passed to the context
      ...this.state,
      // internal state
      ...this.actions
      // callable action functions mapped to methods
    };
  }
}
Ee(zt, "newStatus", Dv), Ee(zt, "debug", !1), Ee(zt, "debugPrefix", "Form > "), Ee(zt, "debugColor", "rebeccapurple"), Ee(zt, "actions", [
  "fieldSpec",
  "attachField",
  "detachField",
  "setFocus",
  "reset",
  "validate",
  "unvalidate",
  "submit",
  "setValue",
  "setValues",
  "setHidden",
  // should this be kept internal?
  "setStatus",
  "setResetState",
  "setChangedState",
  "setValidatingState",
  "setValidState",
  "setInvalidState",
  "setSubmittingState",
  "setSubmittedState",
  "handleError"
]);
const Tv = il(zt), { Context: HC, Provider: kv, Consumer: Iv, Children: yl, Use: fn } = Tv, Ev = ({
  children: e
}) => {
  const t = fn(), n = dv(t), { submit: s, className: r } = t;
  return /* @__PURE__ */ l("form", { className: r, ...n, onSubmit: s, noValidate: !0, children: /* @__PURE__ */ l(yl, { children: e }) });
}, Pv = ({
  children: e,
  Layout: t = Ev,
  ...n
}) => /* @__PURE__ */ l(kv, { ...n, children: /* @__PURE__ */ l(t, { children: e }) }), Av = (e) => {
  const { id: t, value: n } = e;
  return {
    ...e,
    id: t || $i(),
    value: n ?? e.default ?? nv
  };
};
class Ut extends hl {
  constructor(t) {
    super(t), this.name = t.name;
    const { value: n } = t, s = n;
    this.form = this.props.form, this.state = {
      ...this.state,
      initialValue: s,
      value: n,
      error: null
    }, this.debug("initial state:", this.state), this.inputRef = To(), this.resetRef = To(), this.on = {
      load: this.contextFunction(this.props.onLoad),
      focus: this.contextFunction(this.props.onFocus),
      blur: this.contextFunction(this.props.onBlur),
      change: this.contextFunction(this.props.onChange),
      valid: this.contextFunction(this.props.onValid),
      invalid: this.contextFunction(this.props.onInvalid),
      unvalidate: this.contextFunction(this.props.onUnvalidate),
      reset: this.contextFunction(this.props.onReset)
    }, this.on.load();
  }
  contextFunction(t) {
    return t ? () => t(this.getContext()) : Qt;
  }
  componentDidMount() {
    this.debug("componentDidMount"), this.mounted = !0, this.form.attachField(this.props.name, this);
  }
  componentWillUnmount() {
    this.debug("componentWillUnmount"), this.mounted = !1, this.form.detachField(this.props.name);
  }
  setFocusState(t, n) {
    return this.setStatus(Xs, t, n);
  }
  setBlurState(t, n) {
    return this.setStatus(sv, t, n);
  }
  onFocus() {
    this.setFocusState(
      {},
      this.on.focus
    );
  }
  onBlur() {
    this.setBlurState(
      {},
      this.props.validateOnBlur ? () => this.validation(this.on.blur) : this.on.blur
    );
  }
  setFocus(t) {
    var n, s;
    t == null || t.preventDefault(), (s = (n = this.inputRef) == null ? void 0 : n.current) == null || s.focus();
  }
  //--------------------------------------------------------------------------
  // Change and reset
  //--------------------------------------------------------------------------
  onChange(t) {
    this.debug(`onChange(${t})`);
    const n = this.props.prepareValue ? this.props.prepareValue(t) : t, { invalid: s } = this.state.status, {
      validateOnChange: r,
      validateOnInvalid: o = !0,
      minValidateLength: i = 1
    } = this.props, [a] = Si(n);
    let c = r || o && s;
    a < i && !s && (c = !1), this.setChangedState(
      { value: n },
      () => {
        this.form.setValue(this.props.name, n), c ? this.validation(this.on.change) : this.on.change();
      }
    );
  }
  setValue(t, n) {
    n == null || n.preventDefault(), this.onChange(t);
  }
  reset(t) {
    t == null || t.preventDefault();
    const n = this.props.prepareValue ? this.props.prepareValue(this.state.initialValue) : this.state.initialValue;
    return this.debug(`reset initialValue:${this.state.initialValue} => ${n}`), this.form.setValue(this.props.name, n), this.setResetState(
      { value: n, message: this.props.message },
      () => {
        var s, r;
        return (r = (s = this.resetRef) == null ? void 0 : s.current) == null ? void 0 : r.reset();
      }
    ), n;
  }
  validation(t) {
    this.validate(t).then(Qt).catch(Qt);
  }
  validate(t) {
    this.debug("validate()");
    const n = {
      name: this.name,
      label: this.props.label
    };
    return new Promise(this.validator()).then(
      (s) => (this.debug("validate() passed:", s), this.setValidState(
        s,
        ws(this.on.valid, t)
      ), {
        ...n,
        ...s
      })
    ).catch(
      (s) => {
        throw this.debug("validate() failed:", s), this.setInvalidState(
          s,
          ws(this.on.invalid, t)
        ), {
          ...n,
          ...s
        };
      }
    );
  }
  validator() {
    return async (t, n) => {
      const { value: s = "" } = this.state, {
        validate: r,
        required: o,
        optional: i,
        requiredMessage: a,
        validMessage: c
      } = { ...Ri, ...this.props }, [, u] = Si(s);
      if (this.setValidatingState(), r)
        return u && i ? (this.debug("optional field is empty"), t({ value: s, message: c })) : await this.validateValidator(
          t,
          n,
          r,
          c
        );
      if (u)
        return await this.validateEmpty(
          t,
          n,
          o,
          c,
          a
        );
      this.debug("no validation defined"), t({ value: s, message: c });
    };
  }
  async validateValidator(t, n, s, r) {
    this.debug("calling validate function");
    const o = this.getContext();
    try {
      this.debug(`calling validate function with value [${o.value}]`);
      const i = await s(o.value, o, t, n);
      this.debug("validate function passed:", i), t(
        jn(i) ? { message: r, ...i } : { value: i, message: r }
      );
    } catch (i) {
      this.debug("validate threw an error:", i);
      const a = kt(i) ? i : i.message;
      this.debug("rejecting with message:", a), n({ message: a });
    }
  }
  validateEmpty(t, n, s, r, o) {
    s ? (this.debug("failing validation - required field is empty"), n({ message: o })) : (this.debug("passing validation - value is empty but not required"), t({ message: r }));
  }
  setValid(t, n) {
    n == null || n.preventDefault(), this.setValidState({ message: t }, this.on.valid);
  }
  setInvalid(t, n) {
    n == null || n.preventDefault(), this.setInvalidState({ message: t }, this.on.invalid);
  }
  unvalidate() {
    this.setUnvalidatedState(
      { message: this.props.message }
    );
  }
  /*
  setRef(r) {
    // used to store a reference to an input component so that we can reset it
    // if the server-side form validation fails (e.g. in the case of recaptcha)
    // where the user must perform the "I'm not a robot" check again.
    this.ref = r
  }
  OLDset(input) {
    const value = this.props.prepareValue
      ? this.props.prepareValue(input)
      : input
    // TODO: validate on change
    this.setChangedState(
      { value },
      () => this.form.setValue(this.props.name, value)
    )
  }
  */
  getContext() {
    const t = {
      ...Ri,
      ...this.props,
      ...this.state,
      ...this.actions,
      name: this.name,
      inputRef: this.inputRef,
      resetRef: this.resetRef,
      setRef: this.resetRef
      // OLD name
    };
    return delete t.form, delete t.children, delete t.render, t;
  }
}
Ee(Ut, "newStatus", $v), Ee(Ut, "debug", !1), Ee(Ut, "debugPrefix", (e) => `Field [${e.name}] > `), Ee(Ut, "debugColor", "teal"), Ee(Ut, "actions", [
  // 'set',
  "onFocus",
  "onBlur",
  "onChange",
  "setFocus",
  "setValue",
  "setValid",
  "setInvalid",
  "reset",
  // 'setStatus',
  "setResetState",
  "setChangedState",
  "setValidatingState",
  "setValidState",
  "setInvalidState",
  "setFocusState",
  "setBlurState"
]);
const Fv = il(Ut), { Context: zC, Provider: Vv, Consumer: UC, Children: xl, Use: Q } = Fv, wl = ({ field: e = Q() }) => {
  const { label: t, id: n, required: s, optional: r } = e, o = e.showRequired && s, i = e.showOptional && (r || !s), a = t || o || i, c = e.labelClass, u = {};
  return o && e.requiredLabel !== dl && (u["--required-text"] = `"${e.requiredLabel}"`), i && e.optionalLabel !== ul && (u["--optional-text"] = `"${e.optionalLabel}"`), a && /* @__PURE__ */ l("label", { htmlFor: n, className: c, style: u, children: t || /* @__PURE__ */ l("span", { children: " " }) });
}, Bv = ({
  field: e = Q()
}) => /* @__PURE__ */ l("div", { className: Be("prefix", e.prefixClass), children: e.prefix }), jv = ({
  field: e = Q()
}) => /* @__PURE__ */ l("div", { className: Be("suffix", e.suffixClass), children: e.suffix }), Wv = (e) => (t) => e.onChange(t.target.value), Hv = (e) => (t) => e.onChange(t.target.checked), ht = {
  default: Wv,
  checkbox: Hv
}, Sl = ({
  field: e = Q()
}) => {
  const {
    id: t,
    text: n,
    inline: s,
    border: r,
    labelClass: o,
    type: i = "checkbox",
    switch: a,
    round: c,
    square: u,
    handler: d = ht[i] || ht.default
  } = e, h = _s(e), g = Be("checkbox", o, { inline: s, border: r });
  return /* @__PURE__ */ w("label", { htmlFor: t, className: g, children: [
    /* @__PURE__ */ l(
      "input",
      {
        type: i,
        ref: e.inputRef,
        "aria-disabled": e.disabled,
        tabIndex: e.disabled ? -1 : e.tabIndex,
        onChange: d(e),
        className: Ys(e, { round: c, square: u }),
        ...h,
        checked: e.value,
        role: a ? "switch" : ""
      }
    ),
    n
  ] });
}, vo = ({ field: e = Q() }) => /* @__PURE__ */ l("input", { type: "hidden", name: e.name, value: e.value }), Rl = ({
  field: e = Q()
}) => {
  const {
    inline: t,
    border: n,
    options: s = [],
    inputClass: r,
    optionClass: o,
    optionsClass: i = "options",
    type: a = "radio",
    handler: c = ht[a] || ht.default
  } = e, u = _s(e);
  return /* @__PURE__ */ l("div", { className: Be(i), children: s.map(
    (d, h) => {
      d = ml(d);
      const g = `${e.id}-${d.value}`, f = e.value == d.value, m = (e.value ? f : h == 0) ? e.inputRef : null, p = Be(
        "radio",
        o,
        d.className,
        { inline: t, border: n }
      );
      return /* @__PURE__ */ w(
        "label",
        {
          className: p,
          disabled: d.disabled,
          htmlFor: g,
          children: [
            /* @__PURE__ */ l(
              "input",
              {
                type: a,
                className: r,
                ref: m,
                "aria-disabled": e.disabled,
                tabIndex: e.disabled ? -1 : e.tabIndex,
                onChange: c(e),
                ...u,
                id: g,
                checked: f,
                value: d.value
              }
            ),
            d.text
          ]
        },
        d.value
      );
    }
  ) });
}, Ll = ({ field: e = Q() }) => {
  const {
    options: t = [],
    placeholder: n,
    type: s = "select",
    optionClass: r = "option",
    handler: o = ht[s] || ht.default
  } = e, i = _s(e);
  return /* @__PURE__ */ w(
    "select",
    {
      ref: e.inputRef,
      "aria-disabled": e.disabled,
      tabIndex: e.disabled ? -1 : e.tabIndex,
      className: Ys(e),
      onChange: o(e),
      ...i,
      value: e.value,
      required: e.required || !!n,
      children: [
        !!n && /* @__PURE__ */ l("option", { value: "", hidden: !0, disabled: !0, children: n }),
        t.map(
          (a) => (a = ml(a), /* @__PURE__ */ l(
            "option",
            {
              className: r,
              value: a.value,
              disabled: a.disabled,
              children: a.text
            },
            a.value
          ))
        )
      ]
    }
  );
}, Dr = ({ field: e = Q() }) => {
  const {
    type: t = bo,
    handler: n = ht[t] || ht.default
  } = e, s = _s(e);
  return /* @__PURE__ */ l(
    "input",
    {
      type: t,
      ref: e.inputRef,
      className: Ys(e),
      "aria-disabled": e.disabled,
      tabIndex: e.disabled ? -1 : e.tabIndex,
      onFocus: e.onFocus,
      onBlur: e.onBlur,
      onChange: n(e),
      ...s
    }
  );
}, Nl = ({ field: e = Q() }) => {
  const { rows: t = 5, cols: n = 20 } = e;
  return /* @__PURE__ */ l(
    "textarea",
    {
      id: e.id,
      ref: e.inputRef,
      className: Ys(e),
      name: e.name,
      value: e.value,
      disabled: e.disabled,
      "aria-disabled": e.disabled,
      tabIndex: e.disabled ? -1 : e.tabIndex,
      placeholder: e.placeholder,
      autoComplete: e.autocomplete,
      onChange: (s) => e.onChange(s.target.value),
      onFocus: e.onFocus,
      onBlur: e.onBlur,
      onSelect: e.onSelect,
      rows: t,
      cols: n
    }
  );
}, $r = {
  default: Dr,
  checkbox: Sl,
  hidden: vo,
  radio: Rl,
  select: Ll,
  text: Dr,
  textarea: Nl
}, It = (e, t) => $r[bl(e)] = t, Ml = (e = "text") => $r[bl(e)] || $r.default, zv = ({ field: e = Q() }) => {
  const {
    classes: t,
    prefix: n,
    suffix: s,
    inputsClass: r,
    inline: o,
    type: i = bo,
    Prefix: a = Bv,
    Suffix: c = jv
  } = e, u = Ml(i);
  let d = [
    _t(t, "inputs")
  ];
  pe(n) && d.push(_t(t, "prefixed")), pe(s) && d.push(_t(t, "suffixed")), o && d.push(_t(t, "inline")), pe(r) && d.push(r);
  const h = d.join(" ");
  return /* @__PURE__ */ w("div", { className: h, children: [
    pe(n) && /* @__PURE__ */ l(a, { field: e }),
    /* @__PURE__ */ l(u, { field: e }),
    pe(s) && /* @__PURE__ */ l(c, { field: e })
  ] });
}, Dl = ({
  field: e = Q()
}) => {
  const {
    prefix: t,
    suffix: n,
    type: s = bo
  } = e, r = Ml(s);
  return s == iv ? /* @__PURE__ */ l(r, { field: e }) : pe(t) || pe(n) ? /* @__PURE__ */ l(zv, {}) : /* @__PURE__ */ l(r, { field: e });
}, $l = ({ field: e = Q() }) => {
  const { help: t, message: n, classes: s } = e, r = n ?? t, o = _t(s, "help");
  return r ? /* @__PURE__ */ l("div", { className: o, children: r }) : null;
}, Ol = ({
  field: e = Q(),
  children: t
}) => {
  const {
    type: n,
    Label: s = wl,
    Message: r = $l,
    Input: o = Dl
  } = e, i = gv(e);
  return n === "hidden" ? /* @__PURE__ */ l(vo, { field: e }) : /* @__PURE__ */ l("div", { className: i, children: t || /* @__PURE__ */ w(be, { children: [
    /* @__PURE__ */ l(s, { field: e }),
    /* @__PURE__ */ l(o, { field: e }),
    /* @__PURE__ */ l(r, { field: e })
  ] }) });
}, Tl = ({
  name: e,
  children: t,
  ...n
}) => {
  const s = fn(), r = Av(s.fieldSpec(e, n)), o = r.Layout || Ol;
  return /* @__PURE__ */ l(Vv, { form: s, ...r, children: t ? /* @__PURE__ */ l(xl, { children: t }) : /* @__PURE__ */ l(o, {}) });
}, kl = ({
  names: e,
  className: t,
  grid: n = !1,
  gap: s = 4,
  stack: r,
  ...o
}) => {
  const i = ll(e);
  return mo(n) && n && (n = i.length), /* @__PURE__ */ l("div", { className: pv({ grid: n, gap: s, stack: r, props: o }, t), children: i.map(
    (a) => /* @__PURE__ */ l(Tl, { name: a, ...o }, a)
  ) });
}, Uv = ({
  className: e = "",
  legend: t,
  children: n,
  fields: s,
  ...r
}) => /* @__PURE__ */ w("fieldset", { className: e, children: [
  !!t && /* @__PURE__ */ l("legend", { children: t }),
  !!s && /* @__PURE__ */ l(kl, { names: s, ...r }),
  n
] }), Kv = ({
  children: e,
  ...t
}) => Ov(t) && e, Il = Iv(Kv), qv = ({
  values: e = !0,
  status: t = !1,
  all: n = !1,
  className: s = "border bdr-2 shadow-2 mar-v-4 pad-4 form-debug",
  title: r = "Form Debugging",
  valuesTitle: o = "Values",
  statusTitle: i = "Status",
  ...a
}) => {
  const c = fn();
  return /* @__PURE__ */ w("div", { className: s, children: [
    r && /* @__PURE__ */ l("h3", { className: "mar-v-none", children: r }),
    /* @__PURE__ */ w("div", { className: "grid-1 gap-4", children: [
      e && /* @__PURE__ */ w("div", { children: [
        o && /* @__PURE__ */ l("h4", { className: "mar-v-none", children: o }),
        /* @__PURE__ */ l(
          Li,
          {
            rows: Object.entries(c.values),
            ...a
          }
        )
      ] }),
      (t || n) && c.status && /* @__PURE__ */ w("div", { children: [
        i && /* @__PURE__ */ l("h4", { children: i }),
        /* @__PURE__ */ l(
          Li,
          {
            title: "Status",
            rows: Object.entries(c.status),
            ...a
          }
        )
      ] })
    ] })
  ] });
}, Li = ({
  rows: e,
  children: t,
  color: n = "brand",
  tableClass: s = `${n} shaded celled wide small pad-none mar-b-0`,
  ...r
}) => /* @__PURE__ */ l("table", { className: s, children: /* @__PURE__ */ l("tbody", { children: t || e.map(
  ([o, i]) => /* @__PURE__ */ l(
    Xv,
    {
      name: o,
      value: i,
      ...r
    },
    o
  )
) }) }), Xv = ({
  name: e,
  value: t,
  keyClass: n = "text-right split-3",
  valueClass: s = "font-mono bgc-95 bgd-5"
}) => /* @__PURE__ */ w("tr", { valign: "top", children: [
  /* @__PURE__ */ l("th", { className: n, children: e }),
  /* @__PURE__ */ l("td", { className: s, children: /* @__PURE__ */ l(_v, { value: t }) })
] }), _v = ({ value: e }) => pe(e) ? Yb(e) ? e.toString() : JSON.stringify(e) : "", KC = ({ children: e }) => /* @__PURE__ */ l(yl, { children: e }), Yv = ({ error: e }) => {
  const t = e.label || e.name;
  return /* @__PURE__ */ w(be, { children: [
    !!t && /* @__PURE__ */ w("b", { children: [
      t,
      ": "
    ] }),
    e.message
  ] });
}, Gv = ({ error: e }) => kt(e) ? e : /* @__PURE__ */ l(Yv, { error: e }), Zv = ({
  form: e = fn(),
  title: t = e.errorsTitle,
  prompt: n = e.errorsPrompt,
  fieldErrors: s = !1,
  className: r = "error alert border"
}) => {
  const {
    error: o,
    errors: i,
    Error: a = Gv
  } = e, c = !!o, u = (s ? i.length : 0) + (c ? 1 : 0);
  return u !== 0 ? /* @__PURE__ */ w("div", { className: r, children: [
    !!t && /* @__PURE__ */ l("div", { className: "headline", children: xi(t, u) }),
    /* @__PURE__ */ w("div", { children: [
      c && /* @__PURE__ */ l("h4", { children: /* @__PURE__ */ l(a, { error: o }) }),
      s && i.length !== 0 && /* @__PURE__ */ w(be, { children: [
        !!n && /* @__PURE__ */ l("p", { className: "wide", children: xi(n, i.length) }),
        /* @__PURE__ */ l("ul", { children: i.map(
          (d, h) => /* @__PURE__ */ l("li", { children: /* @__PURE__ */ l(a, { error: d }) }, h)
        ) })
      ] })
    ] })
  ] }) : null;
}, qC = ({ children: e }) => /* @__PURE__ */ l(xl, { children: e }), Jv = ({
  field: e = Q(),
  selectValue: t = e.selectValue || Ot
}) => /* @__PURE__ */ l(
  Ab,
  {
    ...e,
    values: T(e.value) ? Fe(e.value) ? e.value : e.value.length ? [e.value] : [] : [],
    onUpdate: e.onUpdate || E,
    onChange: (n) => e.onChange(
      n.map(t)
    )
  }
), Qv = ({
  field: e = Q(),
  selectValue: t = e.selectValue || Ot
}) => /* @__PURE__ */ l(
  Bn,
  {
    ...e,
    onUpdate: e.onUpdate || E,
    onSelect: (n) => e.onChange(t(n))
  }
), ss = {
  searching: !1,
  search: void 0,
  results: void 0,
  result: void 0,
  cursor: void 0
};
class ot extends Rt {
  constructor(t) {
    super(t), this.state = {
      ...this.state,
      ...this.valueState(),
      searching: !1
    }, this.startSearch = t.debounceTime ? vu(this.search.bind(this), t.debounceTime) : this.search.bind(this);
  }
  componentDidMount() {
    this.mounted = !0, this.props.onLoad(this);
  }
  componentWillUnmount() {
    this.setState({ results: null }), this.mounted = !1, this.props.onUnload(this);
  }
  componentDidUpdate(t) {
    this.props.value !== t.value && (this.debug(`value has changed from ${t.value} to ${this.props.value}`), this.setState(this.valueState()));
  }
  valueState(t = this.props.value) {
    const n = this.inputValue(t);
    return { value: t, input: n };
  }
  inputValue(t = this.props.value) {
    return T(t) ? this.props.displayValue(t) ?? Yt : Yt;
  }
  onFocus() {
    this.debug("onFocus()"), this.setState(
      { hasFocus: !0 },
      this.props.onFocus
    );
  }
  onBlur() {
    this.debug("onBlur()"), this.setState(
      { hasFocus: !1 },
      this.props.onBlur
    ), Hr(500).then(() => this.clearResults());
  }
  onChange(t) {
    const n = t.target.value;
    this.debug(`input: ${n}`), n.length >= this.props.minLength ? this.setState(
      { input: n },
      this.startSearch
    ) : this.setState({
      input: n,
      ...ss
    });
  }
  onKeyDown(t) {
    if (this.debug(`onKeyDown(${t.key})`), this.props.disabled)
      return;
    const n = this.state.cursor;
    switch (t.key) {
      case ks:
        this.setCursor(n + 1);
        break;
      case Ts:
        this.setCursor(n - 1);
        break;
      case Is:
        this.selectCursor();
        break;
      case Es:
        this.reset();
        break;
      default:
        return;
    }
    t.preventDefault();
  }
  reset() {
    this.debug("reset()");
    const t = this.props.initialValue, n = this.inputValue(t);
    this.setState(
      {
        value: t,
        input: n,
        error: null,
        ...ss
      },
      this.props.onReset
    );
  }
  clear() {
    this.debug("clear()"), this.setState(
      {
        value: void 0,
        error: null,
        input: Yt,
        ...ss
      },
      this.props.onClear
    );
  }
  search() {
    const { input: t } = this.state, { minLength: n, onSearch: s } = this.props;
    if (t.length < n) {
      this.debug(`search() cancelled - input is shorter than ${n}`);
      return;
    }
    if (!s) {
      this.debug("search() cancelled - no onSearch() handler defined");
      return;
    }
    this.debug("onSearch: ", s), this.setState(
      {
        search: t,
        searching: !0,
        error: null
      },
      async () => {
        try {
          this.searchResults(
            await s(t, this)
          );
        } catch (r) {
          this.setState({
            searching: !1,
            results: null,
            error: r.message ?? r
          });
        }
      }
    );
  }
  searchResults(t) {
    this.debug("searchResults()", t), this.setState({
      results: t,
      searching: !1,
      cursor: 0
    });
  }
  selectResult(t) {
    this.debug("selectResult()", t);
    const n = this.inputValue(t);
    this.setState(
      {
        value: t,
        input: n,
        ...ss
      },
      () => this.props.onSelect(t)
    );
  }
  setCursor(t) {
    this.debug(`setCursor(${t})`);
    const { results: n } = this.state;
    this.setState({
      // handle cases where cursor is less than 0 or greater than the length
      cursor: n && n.length ? (t + n.length) % n.length : void 0
    });
  }
  selectCursor() {
    const { cursor: t, results: n } = this.state;
    n && n.length && T(t) && this.selectResult(n[t]);
  }
  clearResults() {
    this.mounted && this.setState({
      results: null,
      error: null
    });
  }
  resultsRef(t) {
    this._resultsRef = t;
  }
  activeRef(t) {
    sa(this._resultsRef, t);
  }
}
I(ot, "debug", !1), I(ot, "debugPrefix", "Search > "), I(ot, "debugColor", "MediumVioletRed"), I(ot, "defaultProps", {
  minLength: 2,
  debounceTime: 500,
  // placeholder: 'Search',
  // loadingIcon: 'cog',
  // clearIcon: 'cross',
  // searchIcon: 'search',
  onLoad: E,
  onUnload: E,
  onFocus: E,
  onBlur: E,
  onReset: E,
  onClear: E,
  onSelect: E,
  displayValue: Lt("displayValue"),
  displayResult: Lt("displayResult")
}), I(ot, "initialState", {
  value: "",
  searching: !1
}), I(ot, "initialProps", {
  value: "initialValue"
}), I(ot, "actions", [
  "onFocus",
  "onBlur",
  "onChange",
  "onKeyDown",
  "reset",
  "clear",
  "selectResult",
  "setCursor",
  "selectCursor",
  "resultsRef",
  "activeRef"
]);
const Ct = Xe(ot), XC = Ct.Use, e2 = ({
  input: e,
  onFocus: t,
  onBlur: n,
  onChange: s,
  clear: r,
  autocomplete: o,
  autoComplete: i = o,
  placeholder: a = "Search",
  clearIcon: c = "cross",
  searchIcon: u = "search",
  searchingIcon: d = "cog.spin",
  inputsClass: h = "inputs round",
  prefixClass: g = "prefix",
  suffixClass: f = "suffix",
  inputType: m = "text",
  inputClass: p = "",
  disabled: b,
  searching: v
}) => /* @__PURE__ */ w("div", { className: h, children: [
  /* @__PURE__ */ l("div", { className: g, children: /* @__PURE__ */ l(X, { name: u }) }),
  /* @__PURE__ */ l(
    "input",
    {
      type: m,
      placeholder: a,
      value: e,
      onFocus: t,
      onBlur: n,
      onChange: s,
      disabled: b,
      className: p,
      autoComplete: i
    }
  ),
  /* @__PURE__ */ l("div", { className: f, onClick: b ? null : r, children: /* @__PURE__ */ l(X, { name: v ? d : c }) })
] }), t2 = Ct.Consumer(e2), n2 = ({
  result: e,
  active: t,
  activeRef: n,
  onClick: s,
  onMouseEnter: r,
  displayResult: o,
  resultClass: i = "item",
  activeClass: a = "active"
}) => /* @__PURE__ */ l(
  "div",
  {
    className: M(i, { [a]: t }),
    onClick: s,
    onMouseEnter: r,
    ref: t ? n : null,
    children: o(e)
  }
), s2 = Ct.Consumer(n2), r2 = ({
  noResultsClass: e = "none",
  noResults: t = "No results"
}) => /* @__PURE__ */ l("div", { className: e, children: t }), o2 = Ct.Consumer(r2), i2 = ({
  results: e,
  resultsRef: t,
  cursor: n,
  selectResult: s,
  setCursor: r,
  resultsClass: o = "menu border bdr-1",
  Result: i = s2,
  NoResults: a = o2
}) => /* @__PURE__ */ l("div", { className: o, ref: t, children: Fe(e) && e.length ? e.map(
  (c, u) => /* @__PURE__ */ l(
    i,
    {
      result: c,
      active: T(n) && e[n] === c,
      onClick: () => s(c),
      onMouseEnter: () => r(u)
    },
    c.id ?? c.value ?? u
  )
) : /* @__PURE__ */ l(a, {}) }), a2 = Ct.Consumer(i2), l2 = ({
  error: e,
  resultsClass: t = "menu border bdr-1",
  errorClass: n = "error item no-hover"
}) => /* @__PURE__ */ l("div", { className: t, children: /* @__PURE__ */ l("div", { className: n, children: e }) }), c2 = Ct.Consumer(l2), u2 = ({
  results: e,
  error: t,
  onKeyDown: n,
  Input: s = t2,
  Results: r = a2,
  Error: o = c2
}) => /* @__PURE__ */ w("div", { className: "search", onKeyDown: n, children: [
  /* @__PURE__ */ l(s, {}),
  !!t && /* @__PURE__ */ l(o, {}),
  !!e && /* @__PURE__ */ l(r, {})
] }), d2 = Ct.Consumer(u2), h2 = ({
  Content: e = d2,
  ...t
}) => /* @__PURE__ */ l(Ct.Provider, { ...t, children: /* @__PURE__ */ l(e, {}) }), f2 = L(h2, "Search"), g2 = ({
  field: e = Q(),
  selectValue: t = e.selectValue || Ot
}) => /* @__PURE__ */ l(
  f2,
  {
    ...e,
    onSelect: (n) => e.onChange(t(n)),
    onClear: () => e.setValue(null)
  }
), p2 = (e = {}) => {
  let {
    min: t = 0,
    max: n = 100,
    minNormal: s = 0.25,
    maxNormal: r = 0.75,
    value: o,
    minValue: i,
    maxValue: a,
    minRange: c,
    maxRange: u,
    step: d,
    tickStep: h,
    quantize: g,
    options: f,
    displayValue: m
  } = e;
  if (T(f))
    if (Fe(f))
      t = 0, n = f.length - 1, d = 1, c ?? (c = 1), m || (m = v2);
    else
      throw "range options should be an array";
  else
    m || (m = Ot);
  t = xt(t), n = xt(n);
  const p = n - t;
  T(o) && (Fe(o) ? [i, a] = o : ve(o) ? (i = o.min, a = o.max) : Tn(o) && (a = o)), i = T(i) ? G(xt(i), t, n) : t + p * s, a = T(a) ? G(xt(a), t, n) : t + p * r, c = T(c) ? G(xt(c), 0, p) : 0, u = T(u) ? G(xt(u), 0, p) : p, d === Xt || Vr(d) ? d = Xt : T(d) ? d = xt(d) : d = 1;
  const b = d === Xt ? null : rs(p, d);
  h ?? (h = d);
  const v = h === Xt ? null : rs(p, h);
  g = m2({ min: t, max: n, step: d, quantize: g }), i = g(i), a = g(a);
  const y = (D) => g(
    Xi(
      t,
      at(
        p,
        G(D, 0, 1)
      )
    )
  ), C = (D, R = t, N = n) => rs(
    cu(
      G(D, R, N),
      t
    ),
    p
  );
  s = C(i), r = C(a);
  const x = at(s, 100), S = at(r, 100);
  return {
    min: t,
    max: n,
    range: p,
    minValue: i,
    maxValue: a,
    minRange: c,
    maxRange: u,
    options: f,
    minInput: i,
    maxInput: a,
    step: d,
    steps: b,
    tickStep: h,
    tickSteps: v,
    quantize: g,
    minNormal: s,
    maxNormal: r,
    minPercent: x,
    maxPercent: S,
    normalToValue: y,
    valueToNormal: C,
    displayValue: m
  };
}, m2 = ({ min: e, max: t, step: n, quantize: s }) => $t(s) ? (r, o = e, i = t) => G(s(r), o, i) : n === Xt ? (r, o = e, i = t) => G(r, o, i) : (r, o = e, i = t) => {
  r = G(r, o, i);
  const a = Math.round((r - e) / n);
  return Xi(
    e,
    at(a, n)
  );
}, b2 = (e, t, n, s, r) => {
  if (e < t)
    return s(e);
  if (e > n)
    return r(e);
  const o = e - t, i = n - e;
  return o < i ? s(e) : r(e);
}, v2 = (e, t) => t[e], C2 = sn(
  "min max value options minValue maxValue minRange maxRange step tickStep quantize"
);
class Kt extends Rt {
  constructor(t) {
    super(t);
    const n = this.initProps(t);
    this.normalClick = t.normalClick, this.windowEventListeners = {}, this.state = {
      ...this.state,
      ...n,
      minInput: n.minValue,
      maxInput: n.maxValue
    };
  }
  initProps(t) {
    const { normalToValue: n, valueToNormal: s, quantize: r, ...o } = p2(t);
    return this.quantize = r, this.normalToValue = n, this.valueToNormal = s, o;
  }
  componentDidUpdate(t) {
    vr(C2, this.props, t) && (this.debug("props have changed"), this.setState(
      this.initProps(this.props)
    ));
  }
  componentWillUnmount() {
    this.debug("unmount"), this.removeAllWindowEventListeners();
  }
  addWindowEventListener(t, n) {
    var r;
    const s = (r = this.windowEventListeners)[t] || (r[t] = []);
    window.addEventListener(t, n), s.push(n);
  }
  removeWindowEventListener(t, n) {
    var o;
    const s = (o = this.windowEventListeners)[t] || (o[t] = []);
    window.removeEventListener(t, n);
    const r = s.indexOf(n);
    r >= 0 ? (this.debug(`removing existing ${t} window listener`), this.debug(`had ${s.length} listeners`), s.splice(r, 1), this.debug(`now got ${s.length} listeners`)) : this.debug(`could not find cached ${t} listener to remove`);
  }
  removeAllWindowEventListeners() {
    this.debug("Removing all window event listeners"), Object.entries(this.windowEventListeners).forEach(
      ([t, n]) => {
        this.debug(`Removing ${n.length} ${t} listeners`), n.forEach(
          (s) => window.removeEventListener(t, s)
        );
      }
    ), this.windowEventListeners = {};
  }
  minValueLimits() {
    const { maxValue: t, min: n, max: s, minRange: r, maxRange: o } = this.state;
    return [
      G(t - o, n, s),
      G(t - r, n, s)
    ];
  }
  maxValueLimits() {
    const { minValue: t, min: n, max: s, minRange: r, maxRange: o } = this.state;
    return [
      G(t + r, n, s),
      G(t + o, n, s)
    ];
  }
  setMinInput(t) {
    this.setState(
      { minInput: t },
      () => this.setMinValue(t)
    );
  }
  setMaxInput(t) {
    this.setState(
      { maxInput: t },
      () => this.setMaxValue(t)
    );
  }
  setMinValue(t) {
    t = this.quantize(t, ...this.minValueLimits());
    const n = this.valueToNormal(t), s = at(n, 100);
    return this.setState(
      {
        minNormal: n,
        minValue: t,
        minPercent: s
      },
      () => this.onChange()
    ), t;
  }
  setMaxValue(t) {
    t = this.quantize(t, ...this.maxValueLimits());
    const n = this.valueToNormal(t), s = at(n, 100);
    return this.setState(
      {
        maxNormal: n,
        maxValue: t,
        maxPercent: s
      },
      () => this.onChange()
    ), t;
  }
  setValues(t, n) {
    this.setMinValue(t), this.setMaxValue(n);
  }
  setNormalisedMinValue(t) {
    const n = G(
      this.normalToValue(t),
      ...this.minValueLimits()
    );
    t = this.valueToNormal(n);
    const s = at(100, t).toFixed(2);
    return this.setState(
      {
        minNormal: t,
        minValue: n,
        minPercent: s,
        minInput: n
      },
      () => this.onChange()
    ), n;
  }
  setNormalisedMaxValue(t) {
    const n = G(
      this.normalToValue(t),
      ...this.maxValueLimits()
    );
    t = this.valueToNormal(n);
    const s = at(100, t).toFixed(2);
    return this.setState(
      {
        maxNormal: t,
        maxValue: n,
        maxPercent: s,
        maxInput: n
      },
      () => this.onChange()
    ), n;
  }
  step() {
    const t = this.state.step;
    return t === Xt ? 1 : t;
  }
  stepMinUp() {
    const t = this.state.minValue + this.step();
    this.setMinInput(t);
  }
  stepMaxUp() {
    const t = this.state.maxValue + this.step();
    this.setMaxInput(t);
  }
  stepMinDown() {
    const t = this.state.minValue - this.step();
    this.setMinInput(t);
  }
  stepMaxDown() {
    const t = this.state.maxValue - this.step();
    this.setMaxInput(t);
  }
  thumbsRef(t) {
    this._thumbsRef = t;
  }
  trackRef(t) {
    this._trackRef = t;
  }
  onKeyDown(t, n, s) {
    switch (this.debug(`onKeyDown(${t.key})`), t.key) {
      case ch:
      case ks:
        n();
        break;
      case uh:
      case Ts:
        s();
        break;
      default:
        this.debug(`ignored key ${t.key}`);
        return;
    }
    t.preventDefault();
  }
  onKeyDownMin(t) {
    this.onKeyDown(
      t,
      () => this.stepMinDown(),
      () => this.stepMinUp()
    );
  }
  onKeyDownMax(t) {
    this.onKeyDown(
      t,
      () => this.stepMaxDown(),
      () => this.stepMaxUp()
    );
  }
  onDrag(t, n, s) {
    const r = t.target;
    if (!this._thumbsRef) {
      console.error("No thumbsRef.  Did you forget to set it in Thumbs?");
      return;
    }
    const { clientX: o } = t, { left: i, width: a } = r.getBoundingClientRect(), c = i + a / 2, u = i - o, d = {
      initialX: o,
      thumbLeft: i,
      thumbMid: c,
      thumbOffset: u,
      control: n
    }, { left: h, width: g } = this._thumbsRef.getBoundingClientRect();
    d.thumbsLeft = h, d.thumbsWidth = g, d.thumbPos = (c - h) * 100 / g, this.debug("drag start: ", d), this.setState({ dragging: d });
    const f = (p) => {
      p.preventDefault();
      const b = p.clientX - d.initialX, v = G(d.thumbMid + b - d.thumbsLeft, 0, d.thumbsWidth);
      this.debug("drag"), s(
        rs(v, d.thumbsWidth)
      );
    }, m = (p) => {
      p.preventDefault(), p.stopPropagation(), this.debug("drag end"), this.removeWindowEventListener("pointermove", f), this.removeWindowEventListener("pointerup", m), Hr(this.props.dragTimeout).then(
        () => this.setState({ dragging: null })
      );
    };
    this.addWindowEventListener(
      "pointermove",
      f
    ), this.addWindowEventListener(
      "pointerup",
      m
    );
  }
  onDragMin(t) {
    this.onDrag(
      t,
      "min",
      (n) => this.setNormalisedMinValue(n)
    );
  }
  onDragMax(t) {
    this.onDrag(
      t,
      "max",
      (n) => this.setNormalisedMaxValue(n)
    );
  }
  onClick(t) {
    if (!this._trackRef) {
      console.error("No trackRef.  Did you forget to set it in Track?");
      return;
    }
    if (this.state.dragging) {
      this.debug("Just finished dragging... ignoring click");
      return;
    }
    const { clientX: s } = t, { left: r, width: o } = this._trackRef.getBoundingClientRect(), i = (s - r) / o, { minNormal: a, maxNormal: c } = this.state;
    this.debug(`click at ${s} from ${r} with width ${o}: ${i}`), this.normalClick(
      i,
      a,
      c,
      (u) => this.setNormalisedMinValue(u),
      (u) => this.setNormalisedMaxValue(u)
    );
  }
  onChange() {
    const { minValue: t, maxValue: n } = this.state;
    this.props.onChange(t, n, this.state);
    const [s, r] = this.lastChange || [];
    (t !== s || n !== r) && (this.debug("min and/or max value have changed, firing onChangeValue"), this.props.onChangeValue(t, n, this.state), this.lastChange = [t, n]);
  }
  getRenderProps() {
    const t = this.getContext(), {
      minNormal: n,
      maxNormal: s,
      minPercent: r,
      maxPercent: o,
      className: i,
      rangeClass: a,
      draggingClass: c,
      hasScaleClass: u,
      showScale: d,
      dragging: h,
      color: g,
      size: f
    } = t;
    return t.quantize = this.quantize, t.normalToValue = this.normalToValue, t.rangeProps = {
      className: M(
        a,
        i,
        g,
        f,
        {
          [u]: d,
          [c]: h
        }
      ),
      style: Fu(
        {},
        this.props,
        {
          "--min-position": n,
          "--max-position": s,
          "--min-percent": `${r}%`,
          "--max-percent": `${o}%`
        }
      )
    }, this.props.prepareRenderProps(t);
  }
}
I(Kt, "debug", !1), I(Kt, "debugPrefix", "Range > "), I(Kt, "debugColor", "rebeccapurple"), I(Kt, "defaultProps", {
  onChange: E,
  onChangeValue: E,
  // displayValue: identity,
  normalClick: b2,
  prepareRenderProps: Ot,
  minNormal: 0,
  maxNormal: 1,
  dragTimeout: 300,
  color: "brand",
  rangeClass: "range",
  draggingClass: "range-dragging",
  hasScaleClass: "range-has-scale"
}), I(Kt, "actions", [
  "trackRef",
  "thumbsRef",
  "setMinValue",
  "setMaxValue",
  "setValues",
  "setMinInput",
  "setMaxInput",
  "stepMinUp",
  "stepMaxUp",
  "stepMinDown",
  "stepMaxDown",
  "onDragMin",
  "onDragMax",
  "onKeyDownMin",
  "onKeyDownMax",
  "onClick"
]);
const K = Xe(Kt), {
  Provider: _C,
  Consumer: YC,
  Children: GC,
  Use: ZC
} = K, y2 = ({
  selectionClass: e = "range-selection"
}) => /* @__PURE__ */ l("div", { className: e }), x2 = K.Consumer(y2), w2 = ({
  thumbClass: e = "range-thumb",
  minClass: t = "min",
  dragging: n,
  onDragMin: s,
  onKeyDownMin: r
}) => /* @__PURE__ */ l(
  "div",
  {
    className: M(
      e,
      t,
      { dragging: (n == null ? void 0 : n.control) === "min" }
    ),
    onPointerDown: s,
    onKeyDown: r,
    tabIndex: "0"
  }
), El = K.Consumer(w2), S2 = ({
  thumbClass: e = "range-thumb",
  maxClass: t = "max",
  dragging: n,
  onDragMax: s,
  onKeyDownMax: r
}) => /* @__PURE__ */ l(
  "div",
  {
    className: M(
      e,
      t,
      { dragging: (n == null ? void 0 : n.control) === "max" }
    ),
    onPointerDown: s,
    onKeyDown: r,
    tabIndex: "0"
  }
), Pl = K.Consumer(S2), R2 = ({
  thumbsClass: e = "range-thumbs",
  ThumbMin: t = El,
  ThumbMax: n = Pl,
  thumbsRef: s
}) => /* @__PURE__ */ w(
  "div",
  {
    className: e,
    ref: s,
    children: [
      /* @__PURE__ */ l(t, {}),
      /* @__PURE__ */ l(n, {})
    ]
  }
), L2 = K.Consumer(R2), N2 = ({
  trackClass: e = "range-track",
  Selection: t = x2,
  Thumbs: n = L2,
  onClick: s,
  trackRef: r
}) => /* @__PURE__ */ w("div", { className: e, ref: r, onClick: s, children: [
  /* @__PURE__ */ l(t, {}),
  /* @__PURE__ */ l(n, {})
] }), M2 = K.Consumer(N2), D2 = ({
  ticksClass: e = "range-ticks",
  tickClass: t = "range-tick",
  scaleValueClass: n = "range-scale-value",
  scaleSize: s = "smaller",
  tickSteps: r,
  showScale: o,
  displayValue: i,
  normalToValue: a,
  options: c
}) => {
  const u = M(n, s);
  return /* @__PURE__ */ l(
    "div",
    {
      className: e,
      children: _i(0, r).map(
        (d) => /* @__PURE__ */ l("div", { className: t, children: !!o && /* @__PURE__ */ l("div", { className: u, children: i(a(d / r), c) }) }, d)
      )
    }
  );
}, $2 = K.Consumer(D2), O2 = ({
  sliderClass: e = "range-slider",
  Track: t = M2,
  Ticks: n = $2,
  steps: s,
  showTicks: r
}) => /* @__PURE__ */ w("div", { className: e, children: [
  s && r && /* @__PURE__ */ l(n, {}),
  /* @__PURE__ */ l(t, {})
] }), T2 = K.Consumer(O2), k2 = ({
  inputClass: e = "range-input field mar-b-none",
  stepClass: t = "step",
  inputInputsClass: n = "inputs inline",
  inputPrefixClass: s = "prefix shaded lined",
  inputSuffixClass: r = "suffix shaded lined",
  disabledClass: o = "disabled",
  stepDownIcon: i = "minus",
  stepUpIcon: a = "plus",
  min: c,
  max: u,
  step: d,
  stepUp: h,
  stepDown: g,
  input: f,
  setInput: m
}) => /* @__PURE__ */ l("div", { className: e, children: /* @__PURE__ */ w("div", { className: n, children: [
  /* @__PURE__ */ l(
    "div",
    {
      className: M(s, t, g ? null : o),
      onClick: g,
      children: /* @__PURE__ */ l(X, { name: i })
    }
  ),
  /* @__PURE__ */ l(
    "input",
    {
      type: "number",
      min: c,
      max: u,
      step: d,
      value: f,
      className: "inline",
      onChange: (p) => m(p.target.value)
    }
  ),
  /* @__PURE__ */ l(
    "div",
    {
      className: M(r, t, h ? null : o),
      onClick: h,
      children: /* @__PURE__ */ l(X, { name: a })
    }
  )
] }) }), Al = K.Consumer(k2), I2 = ({
  inputClass: e = "range-input field mar-b-none",
  stepClass: t = "step",
  inputInputsClass: n = "inputs inline",
  inputPrefixClass: s = "prefix shaded lined",
  inputSuffixClass: r = "suffix shaded lined",
  disabledClass: o = "disabled",
  stepDownIcon: i = "minus",
  stepUpIcon: a = "plus",
  selectOptions: c = {},
  min: u,
  max: d,
  stepUp: h,
  stepDown: g,
  input: f,
  setInput: m,
  options: p,
  displayValue: b
}) => /* @__PURE__ */ l("div", { className: e, children: /* @__PURE__ */ w("div", { className: n, children: [
  /* @__PURE__ */ l(
    "div",
    {
      className: M(s, t, g ? null : o),
      onClick: g,
      children: /* @__PURE__ */ l(X, { name: i })
    }
  ),
  /* @__PURE__ */ l(
    Bn,
    {
      ...c,
      value: f,
      options: _i(u, d).map(
        (v) => ({
          value: v,
          text: b(v, p)
        })
      ),
      onSelect: (v) => m((v == null ? void 0 : v.value) || 0),
      onUpdate: E
    }
  ),
  /* @__PURE__ */ l(
    "div",
    {
      className: M(r, t, h ? null : o),
      onClick: h,
      children: /* @__PURE__ */ l(X, { name: a })
    }
  )
] }) }), Fl = K.Consumer(I2), E2 = ({
  min: e,
  max: t,
  minRange: n,
  maxRange: s,
  minInput: r,
  setMinInput: o,
  stepMinUp: i,
  stepMinDown: a,
  minValue: c,
  maxValue: u,
  options: d,
  Input: h = d ? Fl : Al
}) => {
  const g = G(u - s, e, t), f = G(u - n, e, t), m = c > g, p = c < f;
  return /* @__PURE__ */ l(
    h,
    {
      stepDown: m ? a : null,
      stepUp: p ? i : null,
      min: g,
      max: f,
      input: r,
      setInput: o
    }
  );
}, Vl = K.Consumer(E2), P2 = ({
  min: e,
  max: t,
  minRange: n,
  maxRange: s,
  maxInput: r,
  setMaxInput: o,
  stepMaxUp: i,
  stepMaxDown: a,
  minValue: c,
  maxValue: u,
  options: d,
  Input: h = d ? Fl : Al
}) => {
  const g = G(c + n, e, t), f = G(c + s, e, t), m = u < f, p = u > g;
  return /* @__PURE__ */ l(
    h,
    {
      stepDown: p ? a : null,
      stepUp: m ? i : null,
      min: g,
      max: f,
      input: r,
      setInput: o
    }
  );
}, Bl = K.Consumer(P2), A2 = ({
  inputsClass: e = "range-inputs",
  alignInput: t = "space",
  alignInputs: n = t,
  inputSize: s,
  inputsSize: r = s,
  InputMin: o = Vl,
  InputMax: i = Bl
}) => /* @__PURE__ */ w("div", { className: M(e, n, r), children: [
  /* @__PURE__ */ l(o, {}),
  /* @__PURE__ */ l(i, {})
] }), F2 = K.Consumer(A2), V2 = {
  space: "left"
}, B2 = ({
  valueClass: e = "range-value",
  minClass: t = "min",
  alignValue: n = "thumb",
  alignValues: s = n,
  alignMinValue: r = V2[s] || s,
  minValue: o,
  displayValue: i,
  options: a
}) => /* @__PURE__ */ l("div", { className: M(e, t, r), children: i(o, a) }), jl = K.Consumer(B2), j2 = {
  space: "right"
}, W2 = ({
  valueClass: e = "range-value",
  maxClass: t = "max",
  alignValue: n = "thumb",
  alignValues: s = n,
  alignMaxValue: r = j2[s] || s,
  maxValue: o,
  displayValue: i,
  options: a
}) => /* @__PURE__ */ l("div", { className: M(e, t, r), children: i(o, a) }), Wl = K.Consumer(W2), H2 = ({
  valuesClass: e = "range-values",
  ValueMin: t = jl,
  ValueMax: n = Wl,
  valueSize: s = "small",
  valuesSize: r = s
}) => /* @__PURE__ */ w("div", { className: M(e, r), children: [
  /* @__PURE__ */ l(t, {}),
  /* @__PURE__ */ l(n, {})
] }), z2 = K.Consumer(H2), U2 = ({
  outputClass: e = "range-output",
  Values: t = z2
}) => /* @__PURE__ */ l("div", { className: e, children: /* @__PURE__ */ l(t, {}) }), K2 = K.Consumer(U2), q2 = ({
  limitsClass: e = "range-limits",
  scaleValueClass: t = "range-scale-value",
  scaleSize: n = "smaller",
  displayValue: s,
  min: r,
  max: o,
  options: i
}) => {
  const a = M(t, n);
  return /* @__PURE__ */ w("div", { className: e, children: [
    /* @__PURE__ */ l("div", { className: a, children: s(r, i) }),
    /* @__PURE__ */ l("div", { className: a, children: s(o, i) })
  ] });
}, X2 = K.Consumer(q2), _2 = ({
  min: e,
  max: t,
  minValue: n,
  maxValue: s,
  minNormal: r,
  maxNormal: o,
  minPercent: i,
  maxPercent: a,
  step: c,
  steps: u
}) => /* @__PURE__ */ l("table", { className: "celled shaded grey smaller", children: /* @__PURE__ */ w("tbody", { children: [
  ke("minValue", n),
  ke("maxValue", s),
  ke("minNormal", r),
  ke("maxNormal", o),
  ke("minPercent", i),
  ke("maxPercent", a),
  ke("min", e),
  ke("max", t),
  ke("step", c),
  ke("steps", u)
] }) }), ke = (e, t) => /* @__PURE__ */ w("tr", { children: [
  /* @__PURE__ */ l("th", { className: "font-mono split-3", children: e }),
  /* @__PURE__ */ l("td", { children: t })
] }), Y2 = K.Consumer(_2), G2 = ({
  Slider: e = T2,
  Inputs: t = F2,
  Output: n = K2,
  Limits: s = X2,
  Debug: r = Y2,
  debug: o,
  showInput: i,
  showInputs: a = i,
  showValue: c,
  showValues: u = c,
  showScale: d,
  showLimits: h
}) => /* @__PURE__ */ w(be, { children: [
  !!u && /* @__PURE__ */ l(n, {}),
  /* @__PURE__ */ l(e, {}),
  h && !d && /* @__PURE__ */ l(s, {}),
  a && /* @__PURE__ */ l(t, {}),
  !!o && /* @__PURE__ */ l(r, {})
] }), Z2 = K.Consumer(G2), J2 = ({
  rangeProps: e,
  Layout: t = Z2,
  children: n
}) => /* @__PURE__ */ l("div", { ...e, children: n ? /* @__PURE__ */ l(K.Children, { children: n }) : /* @__PURE__ */ l(t, {}) }), Q2 = K.Consumer(J2), e0 = ({
  Content: e = Q2,
  children: t,
  ...n
}) => /* @__PURE__ */ l(K.Provider, { ...n, children: /* @__PURE__ */ l(e, { children: t }) }), Co = L(e0, "Range"), t0 = (e, t) => [e, t], Hl = ({
  field: e = Q(),
  changeValue: t = e.changeValue || t0
}) => /* @__PURE__ */ l(
  Co,
  {
    ...e,
    onChange: (...n) => e.onChange(t(...n))
  }
), n0 = ({
  thumbsClass: e = "range-thumbs",
  Thumb: t = El,
  thumbsRef: n
}) => /* @__PURE__ */ l(
  "div",
  {
    className: e,
    ref: n,
    children: /* @__PURE__ */ l(t, {})
  }
), s0 = K.Consumer(n0), r0 = ({
  valuesClass: e = "range-values",
  ValueMin: t = jl
}) => /* @__PURE__ */ l("div", { className: e, children: /* @__PURE__ */ l(t, {}) }), o0 = K.Consumer(r0), i0 = ({
  inputsClass: e = "range-inputs",
  alignInput: t = "center",
  alignInputs: n = t,
  inputSize: s,
  inputsSize: r = s,
  InputMin: o = Vl
}) => /* @__PURE__ */ l("div", { className: M(e, n, r), children: /* @__PURE__ */ l(o, {}) }), a0 = K.Consumer(i0), l0 = (e, t, n, s) => s(e), c0 = (e) => (e.value = e.maxValue, e.input = e.maxInput, e.normal = e.maxNormal, e.percent = e.maxPercent, e.setValue = e.setMaxValue, e.setInput = e.setMaxInput, e.stepUp = e.stepMaxUp, e.stepDown = e.stepMaxDown, e.onDrag = e.onDragMax, e.onKeyDown = e.onKeyDownMax, e), u0 = ({
  children: e,
  value: t,
  minNormal: n = 0.5,
  maxNormal: s = 1,
  minRange: r = 0,
  rangeClass: o = "range range-min",
  Thumbs: i = s0,
  Values: a = o0,
  Inputs: c = a0,
  normalClick: u = l0,
  prepareRenderProps: d = c0,
  onChange: h = E,
  ...g
}) => /* @__PURE__ */ l(
  Co,
  {
    minValue: t,
    minNormal: n,
    maxNormal: s,
    minRange: r,
    rangeClass: o,
    normalClick: u,
    prepareRenderProps: d,
    onChange: (f, m, ...p) => h(f, ...p),
    Thumbs: i,
    Values: a,
    Inputs: c,
    ...g,
    children: e
  }
), d0 = L(u0, "RangeMin"), h0 = ({
  field: e = Q(),
  changeValue: t = e.changeValue || Ot
}) => /* @__PURE__ */ l(
  d0,
  {
    ...e,
    onChange: (...n) => e.onChange(t(...n))
  }
), f0 = ({
  thumbsClass: e = "range-thumbs",
  Thumb: t = Pl,
  thumbsRef: n
}) => /* @__PURE__ */ l(
  "div",
  {
    className: e,
    ref: n,
    children: /* @__PURE__ */ l(t, {})
  }
), g0 = K.Consumer(f0), p0 = ({
  valuesClass: e = "range-values",
  ValueMax: t = Wl
}) => /* @__PURE__ */ l("div", { className: e, children: /* @__PURE__ */ l(t, {}) }), m0 = K.Consumer(p0), b0 = ({
  inputsClass: e = "range-inputs",
  alignInput: t = "center",
  alignInputs: n = t,
  inputSize: s,
  inputsSize: r = s,
  InputMax: o = Bl
}) => /* @__PURE__ */ l("div", { className: M(e, n, r), children: /* @__PURE__ */ l(o, {}) }), v0 = K.Consumer(b0), C0 = (e, t, n, s, r) => r(e), y0 = (e) => (e.value = e.maxValue, e.input = e.maxInput, e.normal = e.maxNormal, e.percent = e.maxPercent, e.setValue = e.setMaxValue, e.setInput = e.setMaxInput, e.stepUp = e.stepMaxUp, e.stepDown = e.stepMaxDown, e.onDrag = e.onDragMax, e.onKeyDown = e.onKeyDownMax, e), x0 = ({
  children: e,
  value: t,
  minNormal: n = 0,
  maxNormal: s = 0.5,
  minRange: r = 0,
  rangeClass: o = "range range-max",
  Thumbs: i = g0,
  Values: a = m0,
  Inputs: c = v0,
  normalClick: u = C0,
  prepareRenderProps: d = y0,
  onChange: h = E,
  ...g
}) => /* @__PURE__ */ l(
  Co,
  {
    maxValue: t,
    minNormal: n,
    maxNormal: s,
    minRange: r,
    rangeClass: o,
    normalClick: u,
    prepareRenderProps: d,
    onChange: (f, m, ...p) => h(m, ...p),
    Thumbs: i,
    Values: a,
    Inputs: c,
    ...g,
    children: e
  }
), w0 = L(x0, "RangeMax"), S0 = ({
  field: e = Q(),
  changeValue: t = e.changeValue || Ot
}) => /* @__PURE__ */ l(
  w0,
  {
    ...e,
    onChange: (...n) => e.onChange(t(...n))
  }
), R0 = ({
  color: e,
  className: t,
  style: n,
  fixed: s,
  light: r,
  dark: o,
  onClick: i,
  children: a
}) => /* @__PURE__ */ l(
  "div",
  {
    className: M("overlay", t, e, { fixed: s, light: r, dark: o }),
    style: n,
    onClick: i,
    children: a
  }
), zl = L(R0, "Overlay"), Ni = (e, t) => [
  e.length ? "-" + e.join("-") : "",
  t.length ? "." + t.join(".") : ""
].join(""), Mi = (e, t, n, s, r, o) => {
  n ? (t.push(`stc-${r}`, `std-${o}`), Dt(n) ? s && e.push(`strokeWidth=${s}`) : e.push(n)) : e.push("stroke=none");
}, Di = (e, t, n, s, r) => {
  n ? t.push(`flc-${s}`, `fld-${r}`) : e.push("fill=none");
}, L0 = ({
  size: e,
  className: t,
  icon: n = "cog",
  color: s = "brand",
  stroke: r = !0,
  strokeWidth: o,
  strokeStop: i = 40,
  strokeStopDark: a = 50,
  fill: c = !1,
  fillStop: u = 50,
  fillStopDark: d = 20,
  // bgIcon='circle',
  bgIcon: h = !1,
  bgColor: g = s,
  bgStroke: f = !1,
  bgStrokeWidth: m,
  bgStrokeStop: p = 60,
  bgStrokeStopDark: b = 70,
  bgFill: v = !0,
  bgFillStop: y = 70,
  bgFillStopDark: C = 30,
  shrink: x = h ? 5 : 0,
  reverse: S = !1,
  fast: D = !1,
  slow: R = !1,
  speed: N = D ? "fast" : R ? "slow" : null,
  animation: k = S ? "spin.reverse" : "spin"
}) => {
  const O = M(
    e,
    t
  ), $ = [], W = [g], A = [], z = [s, k, N];
  Mi($, W, f, m, p, b), Mi(A, z, r, o, i, a), Di($, W, v, y, C), Di(A, z, c, u, d), x && A.push(`shrink=${x}`);
  const Ce = h ? `${h}${Ni($, W)}` : "", te = `${n}${Ni(A, z)}`, Z = h ? `${Ce} ${te}` : te;
  return /* @__PURE__ */ l(X, { name: Z, className: O });
}, N0 = L(L0, "Spinner"), M0 = ({
  text: e = "Submitting...",
  size: t = "largest",
  className: n = "flex middle center pad-8",
  light: s,
  dark: r,
  fixed: o,
  spinnerSize: i = "x4",
  Spinner: a = N0,
  ...c
}) => /* @__PURE__ */ l(Il, { submitting: !0, children: /* @__PURE__ */ l(
  zl,
  {
    className: M(n, t),
    light: s,
    dark: r,
    fixed: o,
    children: /* @__PURE__ */ w("div", { className: "text-center", children: [
      a && /* @__PURE__ */ l(a, { size: i, ...c }),
      /* @__PURE__ */ l("div", { className: "mar-t-4", children: e })
    ] })
  }
) }), JC = L(M0, "Submitting"), D0 = ({
  text: e = "Cancel",
  className: t = "cancel",
  Button: n = Se,
  ...s
}) => /* @__PURE__ */ l(
  n,
  {
    text: e,
    className: t,
    ...s
  }
), $0 = L(D0, "Cancel"), O0 = ({
  type: e = "reset",
  text: t = "Reset",
  className: n = "reset",
  Button: s = Se,
  ...r
}) => {
  const { reset: o } = fn();
  return /* @__PURE__ */ l(
    s,
    {
      type: e,
      text: t,
      className: n,
      onClick: o,
      ...r
    }
  );
}, T0 = L(O0, "Reset"), k0 = ({
  type: e = "submit",
  text: t = "Submit",
  className: n = "submit",
  Button: s = Se,
  ...r
}) => {
  const { submit: o, status: i } = fn();
  return /* @__PURE__ */ l(
    s,
    {
      type: e,
      text: t,
      className: n,
      onClick: o,
      disabled: i.submitting,
      ...r
    }
  );
}, Ul = L(k0, "Submit"), I0 = ({
  className: e,
  gap: t = 4,
  space: n = !1,
  size: s,
  reset: r = {},
  submit: o = {}
}) => /* @__PURE__ */ w(
  "div",
  {
    className: pl({ className: e, gap: t, space: n }, s, "controls"),
    children: [
      /* @__PURE__ */ l(T0, { ...r }),
      /* @__PURE__ */ l(Ul, { ...o })
    ]
  }
), QC = L(I0, "ResetSubmit"), E0 = ({
  className: e,
  gap: t = 4,
  space: n = !1,
  size: s,
  cancel: r = {},
  submit: o = {}
}) => /* @__PURE__ */ w(
  "div",
  {
    className: pl({ className: e, gap: t, space: n }, s, "controls"),
    children: [
      /* @__PURE__ */ l($0, { ...r }),
      /* @__PURE__ */ l(Ul, { ...o })
    ]
  }
), e1 = L(E0, "CancelSubmit");
It("multiselect", Jv);
It("uiselect", Qv);
It("search", g2);
It("uirange", Hl);
It("rangeminmax", Hl);
It("rangemin", h0);
It("rangemax", S0);
const t1 = L(Pv, "Form"), n1 = L(Tl, "Field"), s1 = L(kl, "Fields"), r1 = L(Uv, "Fieldset"), o1 = L(Zv, "Errors"), i1 = L(Il, "Status"), a1 = L(qv, "Debug"), l1 = L(Ol, "Layout"), c1 = L(wl, "Label"), u1 = L(Dl, "Input"), d1 = L($l, "Message"), h1 = L(Sl, "CheckboxField"), f1 = L(vo, "HiddenField"), g1 = L(Rl, "RadioField"), p1 = L(Ll, "SelectField"), m1 = L(Dr, "TextField"), b1 = L(Nl, "TextAreaField"), v1 = ({
  open: e = !1
} = {}) => {
  const { isVisible: t, show: n, hide: s } = Zr({ visible: e });
  return {
    show: n,
    hide: s,
    Modal: (r) => /* @__PURE__ */ l(
      ia,
      {
        open: t,
        ...r
      }
    )
  };
}, C1 = ({
  open: e = !1
} = {}) => {
  const { isVisible: t, show: n, hide: s } = Zr({ visible: e });
  return {
    show: n,
    hide: s,
    Overlay: (r) => t && /* @__PURE__ */ l(
      zl,
      {
        ...r
      }
    )
  };
}, P0 = ({
  className: e,
  disabled: t,
  children: n
}) => /* @__PURE__ */ l(
  "label",
  {
    className: M(e, { disabled: t }),
    children: n
  }
), A0 = L(P0, "RadioLabel"), F0 = ({
  name: e,
  option: t,
  tabIndex: n = 0,
  onChange: s = E,
  checked: r
}) => /* @__PURE__ */ l(
  "input",
  {
    type: "radio",
    name: e,
    disabled: t.disabled,
    "aria-disabled": t.disabled,
    tabIndex: t.disabled ? -1 : n,
    onChange: (o) => s(o.target.checked),
    checked: r
  }
), V0 = L(F0, "RadioInput"), B0 = ({
  name: e,
  option: t,
  checked: n,
  inline: s,
  border: r,
  labelClass: o = "radio",
  inputClass: i,
  Label: a = A0,
  Input: c = V0,
  onChange: u
}) => /* @__PURE__ */ w(
  a,
  {
    className: M(o, t.labelClass, { inline: s, border: r }),
    disabled: t.disabled,
    option: t,
    children: [
      /* @__PURE__ */ l(
        c,
        {
          name: e,
          option: t,
          checked: n,
          className: M(i, t.inputClass),
          onChange: () => u(t.value)
        }
      ),
      t.text ?? t.label ?? t.name
    ]
  }
), j0 = L(B0, "RadioOption"), W0 = ({
  name: e = $i(),
  value: t,
  options: n,
  className: s = "radioset",
  disabled: r,
  Option: o = j0,
  ...i
}) => /* @__PURE__ */ l("div", { className: M(s, { disabled: r }), children: n.map(
  (a) => {
    const c = ve(a) ? a : { value: a, label: a };
    return /* @__PURE__ */ l(
      o,
      {
        name: e,
        option: c,
        checked: c.value === t,
        value: t,
        ...i
      },
      c.value
    );
  }
) }), y1 = L(W0, "Radio"), x1 = ({ ...e }) => /* @__PURE__ */ l(
  go,
  {
    ...e,
    direction: "horizontal"
  }
), Kl = ({
  th: e,
  text: t,
  ...n
}) => e ? /* @__PURE__ */ l("th", { ...n, children: re(t, n) }) : /* @__PURE__ */ l("td", { ...n, children: re(t, n) }), yo = (e) => Fe(e) ? { cells: e } : e, xo = (e) => ve(e) ? e : { text: e }, H0 = ({
  columns: e
}) => /* @__PURE__ */ l("thead", { children: /* @__PURE__ */ l("tr", { children: Object.entries(e).map(
  ([t, n]) => {
    const s = n.head ? xo(n.head) : { text: t };
    return /* @__PURE__ */ l(
      Kl,
      {
        th: s.th ?? !0,
        ...s
      },
      t
    );
  }
) }) }), z0 = ({
  th: e,
  text: t,
  row: n,
  ...s
}) => e ? /* @__PURE__ */ l("th", { ...s, children: re(t, { row: n, text: t }) }) : /* @__PURE__ */ l("td", { ...s, children: re(t, { row: n, text: t }) }), U0 = ({
  row: e,
  columns: t
}) => /* @__PURE__ */ l("tr", { children: Object.entries(t).map(
  ([n, s]) => {
    const r = s.body ? xo(s.body) : { text: e[n] };
    return /* @__PURE__ */ l(
      z0,
      {
        th: r.th ?? !1,
        row: e,
        ...r
      },
      n
    );
  }
) }), K0 = ({
  columns: e,
  rows: t = [],
  ...n
}) => /* @__PURE__ */ l("tbody", { children: t.map(
  (s, r) => /* @__PURE__ */ l(
    U0,
    {
      row: s,
      columns: e,
      ...n
    },
    s.id ?? r
  )
) }), q0 = ({
  rows: e,
  columns: t,
  ...n
}) => /* @__PURE__ */ w(be, { children: [
  /* @__PURE__ */ l(H0, { columns: t, ...n }),
  /* @__PURE__ */ l(K0, { columns: t, rows: e, ...n })
] }), wo = ({
  cells: e,
  th: t = !1,
  Cell: n = Kl,
  ...s
}) => /* @__PURE__ */ l("tr", { ...s, children: e.map(
  (r, o) => /* @__PURE__ */ l(
    n,
    {
      th: r.th ?? t,
      ...xo(r)
    },
    r.key ?? o
  )
) }), X0 = ({
  headRows: e,
  Row: t = wo,
  HeadRow: n = t,
  ...s
}) => /* @__PURE__ */ l("thead", { children: e.map(
  (r, o) => /* @__PURE__ */ l(
    n,
    {
      th: !0,
      ...yo(r),
      ...s
    },
    r.key ?? o
  )
) }), _0 = ({
  bodyRows: e,
  Row: t = wo,
  BodyRow: n = t,
  ...s
}) => /* @__PURE__ */ l("tbody", { children: e.map(
  (r, o) => /* @__PURE__ */ l(
    n,
    {
      ...yo(r),
      ...s
    },
    r.key ?? o
  )
) }), Y0 = ({
  footRows: e,
  Row: t = wo,
  FootRow: n = t,
  ...s
}) => /* @__PURE__ */ l("tfoot", { children: e.map(
  (r, o) => /* @__PURE__ */ l(
    n,
    {
      ...yo(r),
      ...s
    },
    r.key ?? o
  )
) }), G0 = ({
  bodyRows: e,
  headRows: t,
  footRows: n,
  Head: s = X0,
  Body: r = _0,
  Foot: o = Y0,
  ...i
}) => /* @__PURE__ */ w(be, { children: [
  !!t && /* @__PURE__ */ l(s, { headRows: t, ...i }),
  /* @__PURE__ */ l(r, { bodyRows: e, ...i }),
  !!n && /* @__PURE__ */ l(o, { footRows: n, ...i })
] }), Z0 = ({
  className: e,
  border: t,
  color: n,
  radius: s,
  shadow: r,
  size: o,
  lined: i,
  celled: a,
  shaded: c,
  striped: u,
  wide: d,
  compact: h,
  compressed: g = h,
  expanded: f,
  headings: m,
  rows: p,
  footings: b,
  columns: v,
  bodyRows: y = p,
  headRows: C = m && [m],
  footRows: x = b && [b],
  ...S
}) => {
  const D = M(
    e,
    o,
    zr(n),
    ft(t),
    pt(s),
    gt(r),
    { celled: a, lined: i, shaded: c, striped: u, wide: d, compressed: g, expanded: f }
  );
  return /* @__PURE__ */ l("table", { className: D, children: v ? /* @__PURE__ */ l(
    q0,
    {
      columns: Nt(
        v,
        (R) => ({ head: ra(R) })
      ),
      rows: p,
      ...S
    }
  ) : /* @__PURE__ */ l(
    G0,
    {
      headRows: C,
      bodyRows: y,
      footRows: x,
      ...S
    }
  ) });
}, w1 = L(Z0, "Table"), J0 = ({
  tab: e
}) => {
  if (!e)
    return null;
  const { content: t, Component: n } = e;
  return t || (n ? /* @__PURE__ */ l(n, { tab: e }) : "No content, element or Component defined for tab");
}, Q0 = ({
  tabs: e,
  storageKey: t,
  storageItem: n = "active-tab",
  tabsetClass: s = "tabset",
  tabsClass: r = "tabs",
  activeClass: o = "active",
  disabledClass: i = "disabled",
  className: a,
  bodyClass: c,
  color: u,
  size: d,
  solid: h,
  lined: g,
  center: f,
  right: m,
  activeTab: p = 0,
  Body: b = J0
}) => {
  const v = t && Gr(t), [y, C] = F.useState(
    v && v.get(n) || p
  ), x = (R) => {
    C(R), v && v.set(n, R);
  }, S = M(
    s,
    a,
    u,
    d,
    { solid: h, lined: g, center: f, right: m }
  ), D = M(
    r,
    u,
    d
  );
  return /* @__PURE__ */ w("div", { className: S, children: [
    /* @__PURE__ */ l("ul", { className: D, children: e.map(
      (R, N) => /* @__PURE__ */ l(
        "li",
        {
          className: M({
            [o]: y === N,
            [i]: R.disabled
          }),
          onClick: () => R.disabled ? E : x(N),
          children: /* @__PURE__ */ l(mt, { ...R })
        },
        R.id || N
      )
    ) }),
    /* @__PURE__ */ l("div", { className: c, children: /* @__PURE__ */ l(
      b,
      {
        tabs: e,
        active: y,
        tab: e[y]
      }
    ) })
  ] });
}, S1 = L(Q0, "Tabset"), ql = [
  { text: "On", value: !0 },
  { text: "Off", value: !1 }
], eC = (e, t) => e.value === (ve(t) ? t.value : t), Xl = (e, t) => Ls(t) ? t : e.findIndex((n) => eC(n, t)), tC = ({
  selected: e = 0,
  findSelectedIndex: t = Xl,
  onSelect: n = E,
  options: s = ql,
  activeProps: r = {},
  inactiveProps: o = { className: "outline" },
  buttonsClass: i = "buttons",
  size: a,
  className: c,
  ...u
} = {}) => {
  const d = t(s, e), h = s.map(
    (g, f) => {
      const m = f === d;
      return {
        ...g,
        ...m ? r : o,
        className: M(
          g.className,
          m ? r.className : o.className
        ),
        onClick: () => n(g, f)
      };
    }
  );
  return /* @__PURE__ */ l(
    Cr,
    {
      buttons: h,
      className: M(a, c, i),
      ...u
    }
  );
}, nC = L(tC, "Toggle"), sC = ({
  selected: e = 0,
  findSelectedIndex: t = Xl,
  options: n = ql,
  onSelect: s = E,
  storageKey: r,
  storageItem: o = "selected",
  ...i
} = {}) => {
  const a = t(n, e), c = r && Gr(r), [u, d] = j(
    c ? c.get(o) ?? a : a
  ), [h, g] = j(
    n[u]
  ), f = (p) => {
    const b = t(n, p);
    if (b >= 0 && b < n.length)
      c && c.set(o, b), d(b), g(n[b]), s(n[b], b);
    else
      throw "Invalid toggle option selected: " + JSON.stringify(p);
  };
  return [
    h,
    ({ ...p }) => /* @__PURE__ */ l(
      nC,
      {
        options: n,
        selected: u,
        onSelect: (b, v) => f(v),
        ...i,
        ...p
      }
    ),
    f,
    () => f((u + 1) % n.length)
  ];
}, R1 = (e) => {
  const [, t] = sC(e);
  return /* @__PURE__ */ l(t, {});
}, rC = ({
  style: e,
  content: t,
  children: n,
  ...s
}) => /* @__PURE__ */ l("div", { className: Ur(s), style: e, children: t || n });
L(rC, "Div");
const oC = ({
  children: e,
  ...t
}) => /* @__PURE__ */ l("div", { className: Ur(t, "flex"), children: e });
L(oC, "Flex");
const iC = ({
  gap: e,
  children: t,
  ...n
}) => {
  const { ref: s, breakpoint: r } = _l(), [o, i] = vd(n, r);
  return /* @__PURE__ */ l(
    "div",
    {
      ref: s,
      className: M(
        o,
        Kr(e),
        Ur(i)
      ),
      children: t
    }
  );
};
L(iC, "Grid");
const _l = (e = {}) => {
  const [t, n] = j(!1), [s, r] = j(!1), [o, i] = j(!1), [a, c] = j(!1), [u, d] = j(!1), h = U();
  return B(
    () => {
      if (!h.current || typeof ResizeObserver > "u")
        return;
      const g = new ResizeObserver(
        (f) => {
          const m = f[0], p = m.contentRect, b = m.borderBoxSize[0];
          if (p) {
            const v = Math.round(p.width), y = Math.round(p.height);
            n(v), r(y), d(_r(v, e));
          }
          if (b) {
            const v = Math.round(b.inlineSize), y = Math.round(b.blockSize);
            i(v), c(y);
          }
        }
      );
      return g.observe(h.current), () => g.disconnect();
    },
    []
  ), { ref: h, width: t, height: s, boxWidth: o, boxHeight: a, breakpoint: u };
};
function L1() {
  const e = U(0);
  return e.current++, e.current;
}
const aC = (e, t = {}) => {
  const {
    onChange: n,
    convertCase: s = ra,
    setterNamer: r = (c) => `set${s(c)}`
  } = t, [o, i] = j(
    n ? n(e) : e
  ), a = Object.keys(e).reduce(
    (c, u) => {
      const d = r(u);
      return c[d] = (h) => i(
        (g) => {
          const f = {
            ...g,
            [u]: re(h, g[u])
          };
          return n ? n(f) : f;
        }
      ), c;
    },
    {}
  );
  return [o, a];
}, N1 = (e = {}) => {
  const t = e.element || window, [n, s] = j(!1), [r, o] = j(!1), [i, a] = j(!1), c = () => {
    if (!t)
      return;
    s(t.innerWidth), o(t.innerHeight);
    const u = _r(t.innerWidth, e);
    a(u);
  };
  return B(
    () => {
      if (typeof t < "u" && t.addEventListener)
        return c(), t.addEventListener("resize", c), () => {
          t.removeEventListener("resize", c);
        };
    },
    []
  ), { width: n, height: r, breakpoint: i };
};
export {
  Xt as ANY,
  ks as ARROW_DOWN,
  ch as ARROW_LEFT,
  uh as ARROW_RIGHT,
  Ts as ARROW_UP,
  pC as Accordion,
  xC as Alert,
  hh as BACKSPACE,
  Yt as BLANK,
  wC as Badge,
  Se as Button,
  Cr as Buttons,
  $0 as Cancel,
  e1 as CancelSubmit,
  oa as Checkbox,
  h1 as CheckboxField,
  SC as CheckboxState,
  Fd as CheckedState,
  RC as Confirm,
  DC as DASH,
  OC as DEFAULT_ICON_HEIGHT,
  $C as DEFAULT_ICON_WIDTH,
  od as DESKTOP,
  nl as DataTable,
  Sm as DataTableBody,
  sm as DataTableCell,
  MC as DataTableConsumer,
  Um as DataTableContent,
  _ as DataTableContext,
  Gp as DataTableControls,
  bm as DataTableFilter,
  _p as DataTableFiltering,
  Cm as DataTableFilters,
  Hm as DataTableFooter,
  Jp as DataTableHeader,
  dm as DataTableHeading,
  fm as DataTableHeadings,
  am as DataTableNoRows,
  Lf as DataTablePageSize,
  om as DataTableRow,
  cm as DataTableRows,
  lh as DataTableSummary,
  EC as DataTables,
  nl as Datatable,
  a1 as Debug,
  qu as Details,
  Wu as DetailsContainer,
  Ji as DetailsContent,
  Tr as DetailsContext,
  Bu as DetailsSummary,
  rC as Div,
  If as Dropdown,
  $f as DropdownBody,
  Tf as DropdownContent,
  an as DropdownContext,
  Sf as DropdownMenu,
  xf as DropdownMenuContent,
  rn as DropdownMenuContext,
  Ch as DropdownMenuHeading,
  bh as DropdownMenuOption,
  xh as DropdownMenuOptions,
  vh as DropdownMenuSeparator,
  ph as DropdownMenuTrigger,
  Mf as DropdownTrigger,
  Is as ENTER,
  Es as ESCAPE,
  Nd as Error,
  o1 as Errors,
  la as FALSE,
  n1 as Field,
  s1 as Fields,
  r1 as Fieldset,
  oC as Flex,
  t1 as Form,
  iC as Grid,
  f1 as HiddenField,
  x1 as HorizontalSort,
  X as Icon,
  Pr as IconLibrary,
  mC as Icons,
  Sd as Info,
  u1 as Input,
  rd as LAPTOP,
  c1 as Label,
  l1 as Layout,
  wd as LocalStorage,
  nd as MOBILE,
  Fp as MakeSortable,
  d1 as Message,
  ia as Modal,
  Bd as ModalClose,
  Kd as ModalContent,
  zd as ModalFooter,
  Wd as ModalHeader,
  v1 as ModalState,
  Ab as MultiSelect,
  FC as MultiSelectConsumer,
  Eb as MultiSelectContent,
  Tt as MultiSelectContext,
  ab as MultiSelectOption,
  AC as MultiSelectProvider,
  rl as MultiSelectSelection,
  Ob as MultiSelectSelections,
  kb as MultiSelectSortSelections,
  zl as Overlay,
  C1 as OverlayState,
  jm as Pager,
  Vm as PagerContent,
  bt as PagerContext,
  $m as PagerNext,
  Tm as PagerPage,
  Am as PagerPages,
  Mm as PagerPrevious,
  Em as PagerSeparator,
  y1 as Radio,
  g1 as RadioField,
  V0 as RadioInput,
  A0 as RadioLabel,
  j0 as RadioOption,
  Co as Range,
  GC as RangeChildren,
  YC as RangeConsumer,
  Q2 as RangeContent,
  K as RangeContext,
  Y2 as RangeDebug,
  Al as RangeInput,
  Bl as RangeInputMax,
  Vl as RangeInputMin,
  F2 as RangeInputs,
  Z2 as RangeLayout,
  X2 as RangeLimits,
  w0 as RangeMax,
  v0 as RangeMaxInputs,
  g0 as RangeMaxThumbs,
  m0 as RangeMaxValues,
  d0 as RangeMin,
  a0 as RangeMinInputs,
  s0 as RangeMinThumbs,
  o0 as RangeMinValues,
  K2 as RangeOutput,
  _C as RangeProvider,
  Fl as RangeSelect,
  x2 as RangeSelection,
  T2 as RangeSlider,
  Pl as RangeThumbMax,
  El as RangeThumbMin,
  L2 as RangeThumbs,
  $2 as RangeTicks,
  M2 as RangeTrack,
  Wl as RangeValueMax,
  jl as RangeValueMin,
  z2 as RangeValues,
  T0 as Reset,
  QC as ResetSubmit,
  Jr as SPACE,
  f2 as Search,
  d2 as SearchContent,
  Ct as SearchContext,
  c2 as SearchError,
  t2 as SearchInput,
  o2 as SearchNoResults,
  s2 as SearchResult,
  a2 as SearchResults,
  Bn as Select,
  jC as SelectConsumer,
  Nb as SelectContent,
  De as SelectContext,
  p1 as SelectField,
  hb as SelectHeading,
  ub as SelectInput,
  vb as SelectItem,
  wb as SelectMenu,
  yb as SelectNoOptions,
  gb as SelectOption,
  BC as SelectProvider,
  Rb as SelectSearch,
  mb as SelectSeparator,
  go as Sortable,
  Ep as SortableItem,
  N0 as Spinner,
  i1 as Status,
  Gr as Storage,
  Jn as Store,
  Ul as Submit,
  JC as Submitting,
  Rd as Success,
  dh as TAB,
  sd as TABLET,
  aa as TRUE,
  w1 as Table,
  _0 as TableBody,
  Kl as TableCell,
  q0 as TableColumns,
  Y0 as TableFoot,
  X0 as TableHead,
  wo as TableRow,
  G0 as TableRows,
  S1 as Tabset,
  J0 as TabsetBody,
  b1 as TextAreaField,
  m1 as TextField,
  Eu as Theme,
  L as Themed,
  Iu as Themer,
  eb as Tiles,
  nC as Toggle,
  R1 as ToggleState,
  ad as ULTRA,
  td as UNKNOWN,
  qC as UseField,
  KC as UseForm,
  Vp as VerticalSort,
  Zr as VisibleState,
  id as WIDESCREEN,
  Ld as Warning,
  mt as WithIcons,
  $c as addIcon,
  gC as addIcons,
  It as addInputType,
  vr as anyPropsChanged,
  Mu as backgroundClass,
  $u as backgroundDarkClass,
  ft as borderClass,
  Os as breakpoints,
  ra as capitalFirstLetter,
  xo as cellProps,
  $s as classInt,
  qr as classTrue,
  Xr as classTrueInt,
  Gi as classTrueVHTRBL,
  Ou as classVHTRBL,
  M as classes,
  yr as coerceBoolean,
  xt as coerceNumber,
  zr as colorClass,
  dd as cursorFirst,
  hd as cursorLast,
  fd as cursorNext,
  gd as cursorPrev,
  rr as dataTableColumnDefinition,
  Yd as dataTableColumnDefinitions,
  Zd as dataTableColumnOrder,
  LC as dataTableColumnString,
  sh as dataTableFilter,
  qo as dataTableFilterTypes,
  rh as dataTablePaginate,
  oh as dataTableSort,
  Jd as dataTableSortColumn,
  Xo as dataTableSorters,
  Gd as dataTableVisibleColumns,
  Lt as defaultRenderer,
  v2 as displayValueFromOptions,
  vC as elementBreakpoint,
  cd as elementWidth,
  vd as extractGridProp,
  bd as extractGridProps,
  Fu as extractStyleProps,
  gv as fieldClass,
  nh as filterBoolean,
  th as filterFloat,
  eh as filterInteger,
  Wt as filterStringContains,
  Qd as filterStringExact,
  na as findOption,
  br as fixValues,
  vf as floatingMiddleware,
  Cf as floatingPlacement,
  Nu as foregroundClass,
  Du as foregroundDarkClass,
  Kr as gapClass,
  wu as gridClass,
  Cd as gridPropBestMatch,
  Uo as iconNameOrProps,
  sr as iconProps,
  p2 as initRange,
  Ys as inputClasses,
  Cu as joinClasses,
  yC as lookupVariant,
  Lu as marginClass,
  Yr as mergeRefs,
  ta as optionValue,
  Ru as paddingClass,
  tl as pagerNextPageLabel,
  Lm as pagerPageLabel,
  el as pagerPreviousPageLabel,
  bC as parseAttrs,
  xd as parseSize,
  Qn as prefixKey,
  pt as radiusClass,
  C0 as rangeMaxNormalClick,
  y0 as rangeMaxPrepareRenderProps,
  l0 as rangeMinNormalClick,
  c0 as rangeMinPrepareRenderProps,
  b2 as rangeNormalClick,
  m2 as rangeQuantizer,
  Au as rotateStyle,
  yo as rowProps,
  sa as scrollParentChild,
  ud as searchOptions,
  md as selectGridProps,
  yu as setKeys,
  gt as shadowClass,
  Yi as sizeColorProps,
  Su as stackClass,
  fv as statusClasses,
  pd as stopPropagation,
  xu as styleProps,
  Ur as stylePropsClasses,
  CC as themedProps,
  aC as useComplexState,
  _l as useContainer,
  NC as useDataTable,
  fC as useDetails,
  kC as useDropdown,
  TC as useDropdownMenu,
  Q as useField,
  xa as useFloating,
  fn as useForm,
  VC as useMultiSelect,
  IC as usePager,
  ZC as useRange,
  L1 as useRenderCount,
  XC as useSearch,
  WC as useSelect,
  sC as useToggle,
  N1 as useWindow,
  In as validOption,
  _r as widthBreakpoint,
  yd as withIconsRenderer
};
//# sourceMappingURL=badger-react-ui.js.map
